import Decimal from 'decimal.js';
import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigDecimal: { input: Decimal | number | string; output: number; }
  Currency: { input: string; output: string; }
  LocalDate: { input: string; output: string; }
  LocalDateTime: { input: string; output: string; }
  URL: { input: string; output: string; }
  UUID: { input: string; output: string; }
  Upload: { input: any; output: any; }
  Year: { input: number | string; output: number; }
  YearMonth: { input: string; output: string; }
};

export type Account = {
  __typename?: 'Account';
  balanceIndex?: Maybe<Scalars['Int']['output']>;
  bankAccount?: Maybe<BankAccount>;
  creditLimit: MonetaryAmount;
  currentBalance: MonetaryAmount;
  domain?: Maybe<DomainSimple>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  publicId: Scalars['UUID']['output'];
  transactions: Array<AccountTransaction>;
  visible: Scalars['Boolean']['output'];
};


export type AccountTransactionsArgs = {
  yearMonth?: InputMaybe<Scalars['YearMonth']['input']>;
};

export type AccountCreationInput = {
  balanceIndex?: InputMaybe<Scalars['Int']['input']>;
  bankAccountPublicId?: InputMaybe<Scalars['UUID']['input']>;
  creditLimit: MonetaryAmountInput;
  name: Scalars['String']['input'];
  visible: Scalars['Boolean']['input'];
};

export type AccountPutBetweenInput = {
  afterAccountPublicId?: InputMaybe<Scalars['UUID']['input']>;
  beforeAccountPublicId?: InputMaybe<Scalars['UUID']['input']>;
};

export type AccountReorderInput = {
  accountPublicId: Scalars['UUID']['input'];
  putBetween: AccountPutBetweenInput;
};

export type AccountTransaction = {
  __typename?: 'AccountTransaction';
  credit?: Maybe<MonetaryAmount>;
  debit?: Maybe<MonetaryAmount>;
  description: Scalars['String']['output'];
  destination?: Maybe<Account>;
  publicId: Scalars['String']['output'];
  source?: Maybe<Account>;
  timeOfTransaction: Scalars['LocalDateTime']['output'];
};

export type AccountUpdateInput = {
  balanceIndex?: InputMaybe<Scalars['Int']['input']>;
  bankAccountPublicId?: InputMaybe<Scalars['UUID']['input']>;
  creditLimit: MonetaryAmountInput;
  name: Scalars['String']['input'];
  publicId: Scalars['UUID']['input'];
  visible: Scalars['Boolean']['input'];
};

export type AccountantSettings = {
  __typename?: 'AccountantSettings';
  isCompany: Scalars['Boolean']['output'];
};

export type AccountantSettingsUpdateInput = {
  isCompany: Scalars['Boolean']['input'];
};

export type AssignBankAccountToAccountInput = {
  accountPublicId: Scalars['UUID']['input'];
  bankAccountPublicId: Scalars['UUID']['input'];
};

export type AssignStrengthTrainingDimensionToFamilyInput = {
  exerciseFamilyPublicId: Scalars['UUID']['input'];
  position: Scalars['Int']['input'];
  required?: Scalars['Boolean']['input'];
  variantDimensionPublicId: Scalars['UUID']['input'];
};

export enum AssignmentAction {
  Assign = 'ASSIGN',
  Nop = 'NOP',
  Unassign = 'UNASSIGN'
}

export type AuthenticationInfo = {
  __typename?: 'AuthenticationInfo';
  jwt: Scalars['String']['output'];
  user: User;
};

export type BankAccount = {
  __typename?: 'BankAccount';
  iban: Scalars['String']['output'];
  publicId: Scalars['UUID']['output'];
};

export type BankPermission = {
  __typename?: 'BankPermission';
  bankAccounts: Array<BankAccount>;
  confirmationLink?: Maybe<Scalars['URL']['output']>;
  createdAt: Scalars['LocalDateTime']['output'];
  givenAt?: Maybe<Scalars['LocalDateTime']['output']>;
  institution?: Maybe<Institution>;
  institutionId: Scalars['String']['output'];
  publicId: Scalars['UUID']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  requisitionId: Scalars['UUID']['output'];
  ssn?: Maybe<Scalars['String']['output']>;
  withdrawnAt?: Maybe<Scalars['LocalDateTime']['output']>;
};

export type BankPermissionRequest = {
  institutionId: Scalars['String']['input'];
  maxHistoricalDays: Scalars['Int']['input'];
  redirect: Scalars['URL']['input'];
  userLanguage: Scalars['String']['input'];
};

export type BankPermissions = {
  __typename?: 'BankPermissions';
  availableInstitutions: Array<Institution>;
  bankAccountsNotAssignedToAccount: Array<BankAccount>;
  granted: Array<BankPermission>;
  toProcess: Array<BankPermission>;
  toRecreate: Array<Institution>;
};


export type BankPermissionsAvailableInstitutionsArgs = {
  country: Scalars['String']['input'];
};

export type BankTransactionToImport = {
  __typename?: 'BankTransactionToImport';
  conversionRate: Scalars['BigDecimal']['output'];
  credit: Scalars['BigDecimal']['output'];
  creditBankAccountPublicId?: Maybe<Scalars['UUID']['output']>;
  creditTransactionPublicId?: Maybe<Scalars['UUID']['output']>;
  debit: Scalars['BigDecimal']['output'];
  debitBankAccountPublicId?: Maybe<Scalars['UUID']['output']>;
  debitTransactionPublicId?: Maybe<Scalars['UUID']['output']>;
  description: Scalars['String']['output'];
  destinationAccountPublicId?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['Int']['output'];
  sourceAccountPublicId?: Maybe<Scalars['UUID']['output']>;
  timeOfTransaction: Scalars['LocalDateTime']['output'];
  transactionPublicId: Scalars['UUID']['output'];
};

export type BillCreationInput = {
  amount: MonetaryAmountInput;
  createdAt: Scalars['LocalDate']['input'];
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  otherPartyId: Scalars['UUID']['input'];
  type: BillType;
};

export type BillOfPurchase = FinancialDocument & {
  __typename?: 'BillOfPurchase';
  amount: MonetaryAmount;
  createdAt: Scalars['LocalDate']['output'];
  description: Scalars['String']['output'];
  domain: DomainSimple;
  name: Scalars['String']['output'];
  otherParty: Supplier;
  publicId: Scalars['UUID']['output'];
};

export type BillOfSale = FinancialDocument & {
  __typename?: 'BillOfSale';
  amount: MonetaryAmount;
  createdAt: Scalars['LocalDate']['output'];
  description: Scalars['String']['output'];
  domain: DomainSimple;
  name: Scalars['String']['output'];
  otherParty: Client;
  publicId: Scalars['UUID']['output'];
};

export enum BillType {
  BillOfPurchase = 'BILL_OF_PURCHASE',
  BillOfSale = 'BILL_OF_SALE'
}

export type BillUpdateInput = {
  amount: MonetaryAmountInput;
  billPublicId: Scalars['UUID']['input'];
  createdAt: Scalars['LocalDate']['input'];
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  otherPartyId: Scalars['UUID']['input'];
  type: BillType;
};

export type BillingCategory = {
  __typename?: 'BillingCategory';
  description: Scalars['String']['output'];
  domain: DomainSimple;
  name: Scalars['String']['output'];
  publicId: Scalars['UUID']['output'];
};

export type BillingCategoryCreationInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type BillingCategoryShort = {
  __typename?: 'BillingCategoryShort';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type BillingCategoryUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publicId: Scalars['UUID']['input'];
};

export type BillingPeriod = {
  __typename?: 'BillingPeriod';
  expenses: Array<Expense>;
  incomes: Array<Income>;
  monthSummary?: Maybe<MonthSummary>;
  name: Scalars['String']['output'];
  period: Scalars['YearMonth']['output'];
  publicId: Scalars['UUID']['output'];
};

export type BillingPeriodCreationBlockers = {
  __typename?: 'BillingPeriodCreationBlockers';
  alreadyExists: Scalars['Boolean']['output'];
  notForCurrentMonth: Scalars['Boolean']['output'];
  unfinishedBillingPeriods: Scalars['Boolean']['output'];
};

export type BillingPeriodResponse = {
  __typename?: 'BillingPeriodResponse';
  billingPeriod?: Maybe<BillingPeriod>;
  creationBlockers: BillingPeriodCreationBlockers;
};

export type Client = OtherParty & {
  __typename?: 'Client';
  domain: DomainSimple;
  name: Scalars['String']['output'];
  publicId: Scalars['UUID']['output'];
};

export type ClientCreationInput = {
  name: Scalars['String']['input'];
};

export type ClientUpdateInput = {
  name: Scalars['String']['input'];
  publicId: Scalars['UUID']['input'];
};

export type ConfirmPermissionRequest = {
  reference: Scalars['String']['input'];
};

export type ConstantForNFirstInstallmentRateStrategyConfig = RateStrategyConfig & {
  __typename?: 'ConstantForNFirstInstallmentRateStrategyConfig';
  becomesVariableRateAfterNInstallments: Scalars['Int']['output'];
  constantRate: Scalars['BigDecimal']['output'];
  name: Scalars['String']['output'];
  publicId: Scalars['UUID']['output'];
  variableRateMargin: Scalars['BigDecimal']['output'];
};

export type ConstantForNFirstInstallmentRateStrategyConfigCreationInput = {
  becomesVariableRateAfterNInstallments: Scalars['Int']['input'];
  constantRate: Scalars['BigDecimal']['input'];
  name: Scalars['String']['input'];
  variableRateMargin: Scalars['BigDecimal']['input'];
};

export type CreateBillingElementInput = {
  accountPublicId: Scalars['UUID']['input'];
  amount: Scalars['BigDecimal']['input'];
  bankTransactionPublicIds: Array<Scalars['UUID']['input']>;
  categoryPublicId: Scalars['UUID']['input'];
  currency: Scalars['Currency']['input'];
  date: Scalars['LocalDate']['input'];
  description: Scalars['String']['input'];
  piggyBankPublicId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateStrengthTrainingExerciseFamilyInput = {
  exerciseType: StrengthTrainingExerciseType;
  name: Scalars['String']['input'];
};

export type CreateStrengthTrainingVariantDimensionInput = {
  name: Scalars['String']['input'];
};

export type CreateStrengthTrainingVariantValueInput = {
  name: Scalars['String']['input'];
  variantDimensionPublicId: Scalars['UUID']['input'];
};

export type CreateTransferInput = {
  bankTransactionPublicIds: Array<Scalars['UUID']['input']>;
  date: Scalars['LocalDate']['input'];
  description: Scalars['String']['input'];
  fromAccountPublicId: Scalars['UUID']['input'];
  fromAmount: Scalars['BigDecimal']['input'];
  toAccountPublicId: Scalars['UUID']['input'];
  toAmount: Scalars['BigDecimal']['input'];
};

export type CreditInvoice = FinancialDocument & Invoice & {
  __typename?: 'CreditInvoice';
  amount: MonetaryAmount;
  createdAt: Scalars['LocalDate']['output'];
  description: Scalars['String']['output'];
  domain: DomainSimple;
  dueTo: Scalars['LocalDate']['output'];
  name: Scalars['String']['output'];
  otherParty: Client;
  publicId: Scalars['UUID']['output'];
  vat: MonetaryAmount;
};

export type CubeDayStats = {
  __typename?: 'CubeDayStats';
  day: Scalars['LocalDate']['output'];
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  minAo5?: Maybe<Scalars['Int']['output']>;
  minAo30?: Maybe<Scalars['Int']['output']>;
  numberOfTries: Scalars['Int']['output'];
};

export type CubeResult = {
  __typename?: 'CubeResult';
  date: Scalars['LocalDateTime']['output'];
  timeInMillis: Scalars['Int']['output'];
};

export type CubeResults = {
  __typename?: 'CubeResults';
  stats: Array<CubeDayStats>;
  todayResults: Array<CubeResult>;
  todayStats: CubeDayStats;
  topTenAllTime: Array<CubeResult>;
};


export type CubeResultsStatsArgs = {
  month: Scalars['YearMonth']['input'];
};

export type CubeResultsQuery = {
  cubeType: CubeType;
};

export enum CubeType {
  Five = 'FIVE',
  Four = 'FOUR',
  Megaminx = 'MEGAMINX',
  Pyraminx = 'PYRAMINX',
  Seven = 'SEVEN',
  Six = 'SIX',
  Skewb = 'SKEWB',
  Square_1 = 'SQUARE_1',
  Three = 'THREE',
  Two = 'TWO'
}

export type CurrencyInfo = {
  __typename?: 'CurrencyInfo';
  code: Scalars['Currency']['output'];
  description: Scalars['String']['output'];
};

export type CurrentUserProfile = {
  __typename?: 'CurrentUserProfile';
  domain: DomainSimple;
  domains: Array<DomainSimple>;
  email: Scalars['String']['output'];
  login: Scalars['String']['output'];
  name: Scalars['String']['output'];
  roles: Array<Scalars['String']['output']>;
};

export type DebitInvoice = FinancialDocument & Invoice & {
  __typename?: 'DebitInvoice';
  amount: MonetaryAmount;
  createdAt: Scalars['LocalDate']['output'];
  description: Scalars['String']['output'];
  domain: DomainSimple;
  dueTo: Scalars['LocalDate']['output'];
  name: Scalars['String']['output'];
  otherParty: Supplier;
  publicId: Scalars['UUID']['output'];
  vat: MonetaryAmount;
};

export type DeleteBankAccountAssignmentInput = {
  accountPublicId: Scalars['UUID']['input'];
};

export type Domain = {
  __typename?: 'Domain';
  name: Scalars['String']['output'];
  publicId: Scalars['UUID']['output'];
  users: Array<DomainUser>;
};

export enum DomainAccessLevel {
  Admin = 'ADMIN',
  Member = 'MEMBER'
}

export type DomainCreationInput = {
  name: Scalars['String']['input'];
};

export type DomainInvitationInput = {
  invitedUserLogin: Scalars['String']['input'];
  publicId: Scalars['UUID']['input'];
};

export type DomainInvitationResponseInput = {
  publicId: Scalars['UUID']['input'];
};

export type DomainSetAccessLevelInput = {
  domainAccessLevel: SetDomainAccessLevel;
  publicId: Scalars['UUID']['input'];
  userLogin: Scalars['String']['input'];
};

export type DomainSimple = {
  __typename?: 'DomainSimple';
  name: Scalars['String']['output'];
  publicId: Scalars['UUID']['output'];
};

export type DomainUpdateInput = {
  name: Scalars['String']['input'];
  publicId: Scalars['UUID']['input'];
};

export type DomainUser = {
  __typename?: 'DomainUser';
  domainAccessLevel: DomainAccessLevel;
  login: Scalars['String']['output'];
};

export type Expense = {
  __typename?: 'Expense';
  amount: Scalars['BigDecimal']['output'];
  category: BillingCategoryShort;
  currency: Scalars['Currency']['output'];
  date: Scalars['LocalDate']['output'];
  description: Scalars['String']['output'];
  publicId: Scalars['UUID']['output'];
};

export type FetchBankAccountDataInput = {
  bankAccountPublicId: Scalars['UUID']['input'];
};

export type FinanceManagement = {
  __typename?: 'FinanceManagement';
  accounts: Array<Account>;
  billingCategories: Array<BillingCategory>;
  id: Scalars['ID']['output'];
  piggyBanks: Array<PiggyBank>;
  supportedCurrencies: Array<CurrencyInfo>;
};


export type FinanceManagementAccountsArgs = {
  publicId?: InputMaybe<Scalars['UUID']['input']>;
};

export type FinancialDocument = {
  amount: MonetaryAmount;
  createdAt: Scalars['LocalDate']['output'];
  description: Scalars['String']['output'];
  domain: DomainSimple;
  name: Scalars['String']['output'];
  otherParty: OtherParty;
  publicId: Scalars['UUID']['output'];
};

export enum FinancialDocumentKind {
  BillOfPurchase = 'BILL_OF_PURCHASE',
  BillOfSale = 'BILL_OF_SALE',
  CreditInvoice = 'CREDIT_INVOICE',
  DebitInvoice = 'DEBIT_INVOICE'
}

export type ImportBankTransactionsInput = {
  bankTransactionPublicIds: Array<Scalars['UUID']['input']>;
  expenses: Array<CreateBillingElementInput>;
  incomes: Array<CreateBillingElementInput>;
  transfers?: InputMaybe<Array<CreateTransferInput>>;
};

export type Income = {
  __typename?: 'Income';
  amount: Scalars['BigDecimal']['output'];
  category: BillingCategoryShort;
  currency: Scalars['Currency']['output'];
  date: Scalars['LocalDate']['output'];
  description: Scalars['String']['output'];
  publicId: Scalars['UUID']['output'];
};

export type Installment = {
  __typename?: 'Installment';
  overpayment: MonetaryAmount;
  paidAt: Scalars['LocalDate']['output'];
  publicId: Scalars['UUID']['output'];
  repaidAmount: MonetaryAmount;
  repaidInterest: MonetaryAmount;
};

export type InstallmentCreationInput = {
  loanId: Scalars['UUID']['input'];
  overpayment: MonetaryAmountInput;
  paidAt: Scalars['LocalDate']['input'];
  repaidAmount: MonetaryAmountInput;
  repaidInterest: MonetaryAmountInput;
};

export type Institution = {
  __typename?: 'Institution';
  bic: Scalars['String']['output'];
  countries?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['String']['output'];
  logo: Scalars['String']['output'];
  name: Scalars['String']['output'];
  transactionTotalDays: Scalars['Int']['output'];
};

export type IntellectualPropertiesRecordsQueryInput = {
  onlyReportsHavingTasksWithNoAttachments?: Scalars['Boolean']['input'];
  onlyReportsWithoutAttachments?: Scalars['Boolean']['input'];
  yearMonthFilter?: InputMaybe<Scalars['YearMonth']['input']>;
};

export type IntellectualPropertiesRecordsResponse = {
  __typename?: 'IntellectualPropertiesRecordsResponse';
  reports: Array<IntellectualProperty>;
  stats: TimeRecordsStats;
};

export type IntellectualPropertiesReport = {
  __typename?: 'IntellectualPropertiesReport';
  countOfDifferentIPs: Scalars['Int']['output'];
  ipHours: Scalars['BigDecimal']['output'];
  ipPercentage: Scalars['BigDecimal']['output'];
  monthReports: Array<IntellectualPropertyMonthReport>;
  nonIPHours: Scalars['BigDecimal']['output'];
  year: Scalars['Year']['output'];
};

export type IntellectualProperty = {
  __typename?: 'IntellectualProperty';
  description: Scalars['String']['output'];
  domain: DomainSimple;
  id: Scalars['Int']['output'];
  tasks?: Maybe<Array<Task>>;
};

export type IntellectualPropertyData = {
  description: Scalars['String']['input'];
};

export type IntellectualPropertyMonthReport = {
  __typename?: 'IntellectualPropertyMonthReport';
  ipHours: Scalars['BigDecimal']['output'];
  ipPercentage: Scalars['BigDecimal']['output'];
  nonCategorizedTimeRecords: Array<TimeRecord>;
  nonIPHours: Scalars['BigDecimal']['output'];
  timeRecordReports: Array<TimeRecordsReport>;
  yearMonth: Scalars['YearMonth']['output'];
};

export type IntellectualPropertyReportQuery = {
  year: Scalars['Year']['input'];
};

export type IntellectualPropertyReportResponse = {
  __typename?: 'IntellectualPropertyReportResponse';
  availableYears?: Maybe<Array<Scalars['Year']['output']>>;
  report: IntellectualPropertiesReport;
  timeRecordCategories: Array<TimeRecordCategory>;
};

export type Invoice = {
  amount: MonetaryAmount;
  createdAt: Scalars['LocalDate']['output'];
  description: Scalars['String']['output'];
  domain: DomainSimple;
  dueTo: Scalars['LocalDate']['output'];
  name: Scalars['String']['output'];
  otherParty: OtherParty;
  publicId: Scalars['UUID']['output'];
  vat: MonetaryAmount;
};

export type InvoiceCreationInput = {
  amount: MonetaryAmountInput;
  createdAt: Scalars['LocalDate']['input'];
  description: Scalars['String']['input'];
  dueTo: Scalars['LocalDate']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  otherPartyId: Scalars['UUID']['input'];
  type: InvoiceType;
  vat: MonetaryAmountInput;
};

export enum InvoiceType {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type InvoiceUpdateInput = {
  amount: MonetaryAmountInput;
  createdAt: Scalars['LocalDate']['input'];
  description: Scalars['String']['input'];
  dueTo: Scalars['LocalDate']['input'];
  invoicePublicId: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  otherPartyId: Scalars['UUID']['input'];
  type: InvoiceType;
  vat: MonetaryAmountInput;
};

export type LedgerQuery = {
  yearMonth: Scalars['YearMonth']['input'];
};

export type Loan = {
  __typename?: 'Loan';
  installments: Array<Installment>;
  name: Scalars['String']['output'];
  numberOfInstallments: Scalars['Int']['output'];
  paidAmount: MonetaryAmount;
  paymentDate: Scalars['LocalDate']['output'];
  publicId: Scalars['UUID']['output'];
  rateStrategyConfig: RateStrategyConfig;
  repaymentDayStrategyConfig: RepaymentDayStrategyConfig;
};

export type LoanCalculationInstallment = {
  __typename?: 'LoanCalculationInstallment';
  installment: Scalars['BigDecimal']['output'];
  overpayment: Scalars['BigDecimal']['output'];
  paidInterest: Scalars['BigDecimal']['output'];
  paymentFrom: Scalars['LocalDate']['output'];
  paymentTo: Scalars['LocalDate']['output'];
  remainingCapitalAtTheBeginning: Scalars['BigDecimal']['output'];
  repaidCapital: Scalars['BigDecimal']['output'];
};

export type LoanCalculationParams = {
  loanAmount: Scalars['BigDecimal']['input'];
  numberOfInstallments: Scalars['Int']['input'];
  overpaymentMonthlyBudget: Scalars['BigDecimal']['input'];
  overpaymentYearlyBudget: Scalars['BigDecimal']['input'];
  rate: Scalars['BigDecimal']['input'];
  repaymentStart: Scalars['LocalDate']['input'];
  wibor: Scalars['BigDecimal']['input'];
};

export type LoanCreationInput = {
  name: Scalars['String']['input'];
  numberOfInstallments: Scalars['Int']['input'];
  paidAmount: MonetaryAmountInput;
  paymentDate: Scalars['LocalDate']['input'];
  rateStrategyConfigId: Scalars['UUID']['input'];
  repaymentDayStrategyConfigId: Scalars['UUID']['input'];
};

export type LoanDeleteInput = {
  loanId: Scalars['UUID']['input'];
};

export type LoanQuery = {
  publicId: Scalars['UUID']['input'];
};

export type LoanSimulationParams = {
  loanId: Scalars['UUID']['input'];
  monthlyBudget?: InputMaybe<MonetaryAmountInput>;
  yearlyOverpayment?: InputMaybe<MonetaryAmountInput>;
};

export type LoanUpdateInput = {
  loanId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
};

export type Loans = {
  __typename?: 'Loans';
  loans: Array<Loan>;
  rateStrategyConfigs: Array<RateStrategyConfig>;
  repaymentDayStrategyConfigs: Array<RepaymentDayStrategyConfig>;
};

export type LoginParameters = {
  domainPublicId?: InputMaybe<Scalars['UUID']['input']>;
  login: Scalars['String']['input'];
  otp: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type LoginWithGoogleTokenParameters = {
  googleToken: Scalars['String']['input'];
};

export type MfaData = {
  __typename?: 'MFAData';
  mfaCode: Scalars['String']['output'];
  qrLink: Scalars['String']['output'];
};

export type MfaParameters = {
  login: Scalars['String']['input'];
  otp: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type MonetaryAmount = {
  __typename?: 'MonetaryAmount';
  amount: Scalars['BigDecimal']['output'];
  currency: CurrencyInfo;
};

export type MonetaryAmountInput = {
  amount: Scalars['BigDecimal']['input'];
  currency: Scalars['Currency']['input'];
};

export type MonthSummary = {
  __typename?: 'MonthSummary';
  accounts: Array<MonthSummaryAccount>;
  piggyBanks: Array<MonthSummaryPiggyBank>;
  savings: Array<MonthSummarySavings>;
};

export type MonthSummaryAccount = {
  __typename?: 'MonthSummaryAccount';
  currency: Scalars['Currency']['output'];
  currentBalance: Scalars['BigDecimal']['output'];
  lastTransactionIdIncludedInBalance: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  publicId: Scalars['String']['output'];
};

export type MonthSummaryPiggyBank = {
  __typename?: 'MonthSummaryPiggyBank';
  balance: Scalars['BigDecimal']['output'];
  currency: Scalars['Currency']['output'];
  description: Scalars['String']['output'];
  monthlyTopUp: Scalars['BigDecimal']['output'];
  name: Scalars['String']['output'];
  savings: Scalars['Boolean']['output'];
};

export type MonthSummarySavings = {
  __typename?: 'MonthSummarySavings';
  amount: Scalars['BigDecimal']['output'];
  currency: Scalars['Currency']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptInvitationToDomain: Scalars['String']['output'];
  addIPR?: Maybe<IntellectualProperty>;
  addRevenueAndExpenseEntry?: Maybe<RevenueAndExpenseEntry>;
  assignBankAccountToAccount: Scalars['String']['output'];
  assignCategoryToTimeRecord: Scalars['String']['output'];
  confirmPermission: Scalars['String']['output'];
  createAccount: Account;
  createBill: FinancialDocument;
  createBillingCategory: BillingCategory;
  createBillingPeriod: BillingPeriod;
  createClient: Client;
  createConstantForNFirstInstallmentRateStrategyConfig: RateStrategyConfig;
  createDomain: DomainSimple;
  createExpense: Scalars['String']['output'];
  createIncome: Scalars['String']['output'];
  createInstallment: Installment;
  createInvoice: Invoice;
  createLoan: Loan;
  createNthDayOfMonthRepaymentDayStrategyConfig: RepaymentDayStrategyConfig;
  createPiggyBank: PiggyBank;
  createSupplier: Supplier;
  createTask: Scalars['String']['output'];
  createTimeRecord: Scalars['String']['output'];
  createTimeRecordCategory: TimeRecordCategory;
  createTransfer: Scalars['String']['output'];
  deleteAccount: Scalars['String']['output'];
  deleteBankAccountAssignment: Scalars['String']['output'];
  deleteBillingCategory: Scalars['String']['output'];
  deleteClient: Scalars['String']['output'];
  deleteFinancialDocument: Scalars['String']['output'];
  deleteIPR: Scalars['String']['output'];
  deleteInstallment: Scalars['String']['output'];
  deleteLoan: Scalars['String']['output'];
  deletePiggyBank: Scalars['String']['output'];
  deleteRateStrategyConfig: Scalars['String']['output'];
  deleteRepaymentDayStrategyConfig: Scalars['String']['output'];
  deleteSupplier: Scalars['String']['output'];
  deleteTask: Scalars['String']['output'];
  deleteTaskAttachment?: Maybe<Scalars['Boolean']['output']>;
  deleteTimeRecord: Scalars['String']['output'];
  deleteTimeRecordCategory: Scalars['String']['output'];
  finishBillingPeriod: Scalars['String']['output'];
  importBankTransactions: Scalars['String']['output'];
  inviteUserToDomain: Scalars['String']['output'];
  login: AuthenticationInfo;
  loginWithGoogleToken: AuthenticationInfo;
  mutuallyCancel: Scalars['String']['output'];
  register: MfaData;
  rejectInvitationToDomain: Scalars['String']['output'];
  reorderAccount: Scalars['String']['output'];
  saveCubeResult: Scalars['String']['output'];
  setUserDomainAccessLevel: Scalars['String']['output'];
  setupMFA: Scalars['Boolean']['output'];
  startPermissionRequest: Array<BankPermission>;
  strengthTraining: StrengthTrainingMutation;
  switchDomain: AuthenticationInfo;
  triggerFetchBankAccountData: Scalars['String']['output'];
  triggerTranslatedPJMVersesCheck: Scalars['String']['output'];
  updateAccount: Account;
  updateAccountantSettings: Scalars['String']['output'];
  updateBill: FinancialDocument;
  updateBillingCategory: BillingCategory;
  updateClient: Client;
  updateDomain: DomainSimple;
  updateIPR?: Maybe<IntellectualProperty>;
  updateInvoice: Invoice;
  updateLoan: Loan;
  updatePiggyBank: PiggyBank;
  updateSupplier: Supplier;
  updateTask: Scalars['String']['output'];
  updateTimeRecord: Scalars['String']['output'];
  updateTimeRecordCategory: Scalars['String']['output'];
  uploadTaskAttachment?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationAcceptInvitationToDomainArgs = {
  domainInvitationResponseInput: DomainInvitationResponseInput;
};


export type MutationAddIprArgs = {
  input?: InputMaybe<IntellectualPropertyData>;
};


export type MutationAddRevenueAndExpenseEntryArgs = {
  input?: InputMaybe<RevenueAndExpenseEntryInput>;
};


export type MutationAssignBankAccountToAccountArgs = {
  assignBankAccountToAccountInput: AssignBankAccountToAccountInput;
};


export type MutationAssignCategoryToTimeRecordArgs = {
  timeRecordCategoryId?: InputMaybe<Scalars['Int']['input']>;
  timeRecordId: Scalars['Int']['input'];
};


export type MutationConfirmPermissionArgs = {
  confirmPermissionRequest: ConfirmPermissionRequest;
};


export type MutationCreateAccountArgs = {
  accountCreationInput: AccountCreationInput;
};


export type MutationCreateBillArgs = {
  billCreationInput: BillCreationInput;
};


export type MutationCreateBillingCategoryArgs = {
  billingCategoryCreationInput: BillingCategoryCreationInput;
};


export type MutationCreateBillingPeriodArgs = {
  yearMonth: Scalars['YearMonth']['input'];
};


export type MutationCreateClientArgs = {
  clientCreationInput: ClientCreationInput;
};


export type MutationCreateConstantForNFirstInstallmentRateStrategyConfigArgs = {
  input: ConstantForNFirstInstallmentRateStrategyConfigCreationInput;
};


export type MutationCreateDomainArgs = {
  domainCreationInput: DomainCreationInput;
};


export type MutationCreateExpenseArgs = {
  createExpenseInput: CreateBillingElementInput;
};


export type MutationCreateIncomeArgs = {
  createIncomeInput: CreateBillingElementInput;
};


export type MutationCreateInstallmentArgs = {
  input: InstallmentCreationInput;
};


export type MutationCreateInvoiceArgs = {
  invoiceCreationInput: InvoiceCreationInput;
};


export type MutationCreateLoanArgs = {
  input?: InputMaybe<LoanCreationInput>;
};


export type MutationCreateNthDayOfMonthRepaymentDayStrategyConfigArgs = {
  input: NthDayOfMonthRepaymentDayStrategyConfigInput;
};


export type MutationCreatePiggyBankArgs = {
  piggyBankCreationInput: PiggyBankCreationInput;
};


export type MutationCreateSupplierArgs = {
  supplierCreationInput: SupplierCreationInput;
};


export type MutationCreateTaskArgs = {
  intellectualPropertyId: Scalars['Int']['input'];
  taskData: TaskData;
};


export type MutationCreateTimeRecordArgs = {
  timeRecordData: TimeRecordData;
};


export type MutationCreateTimeRecordCategoryArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateTransferArgs = {
  createTransferInput: CreateTransferInput;
};


export type MutationDeleteAccountArgs = {
  accountPublicId: Scalars['UUID']['input'];
};


export type MutationDeleteBankAccountAssignmentArgs = {
  deleteBankAccountAssignmentInput: DeleteBankAccountAssignmentInput;
};


export type MutationDeleteBillingCategoryArgs = {
  billingCategoryPublicId: Scalars['UUID']['input'];
};


export type MutationDeleteClientArgs = {
  clientPublicId: Scalars['UUID']['input'];
};


export type MutationDeleteFinancialDocumentArgs = {
  financialDocumentPublicId: Scalars['UUID']['input'];
};


export type MutationDeleteIprArgs = {
  intellectualPropertyId: Scalars['Int']['input'];
};


export type MutationDeleteInstallmentArgs = {
  installmentPublicId: Scalars['UUID']['input'];
};


export type MutationDeleteLoanArgs = {
  input?: InputMaybe<LoanDeleteInput>;
};


export type MutationDeletePiggyBankArgs = {
  piggyBankPublicId: Scalars['UUID']['input'];
};


export type MutationDeleteRateStrategyConfigArgs = {
  input: RateStrategyConfigDeleteInput;
};


export type MutationDeleteRepaymentDayStrategyConfigArgs = {
  input: RepaymentDayStrategyConfigDeleteInput;
};


export type MutationDeleteSupplierArgs = {
  supplierPublicId: Scalars['UUID']['input'];
};


export type MutationDeleteTaskArgs = {
  taskId: Scalars['Int']['input'];
};


export type MutationDeleteTaskAttachmentArgs = {
  input: TaskAttachmentDeleteData;
};


export type MutationDeleteTimeRecordArgs = {
  timeRecordId: Scalars['Int']['input'];
};


export type MutationDeleteTimeRecordCategoryArgs = {
  timeRecordId: Scalars['Int']['input'];
};


export type MutationFinishBillingPeriodArgs = {
  yearMonth: Scalars['YearMonth']['input'];
};


export type MutationImportBankTransactionsArgs = {
  importBankTransactionsInput: ImportBankTransactionsInput;
};


export type MutationInviteUserToDomainArgs = {
  domainInvitationInput: DomainInvitationInput;
};


export type MutationLoginArgs = {
  loginParameters: LoginParameters;
};


export type MutationLoginWithGoogleTokenArgs = {
  loginWithGoogleTokenParameters: LoginWithGoogleTokenParameters;
};


export type MutationMutuallyCancelArgs = {
  mutuallyCancelInput: MutuallyCancelInput;
};


export type MutationRegisterArgs = {
  registrationParameters: RegistrationParameters;
};


export type MutationRejectInvitationToDomainArgs = {
  domainInvitationResponseInput: DomainInvitationResponseInput;
};


export type MutationReorderAccountArgs = {
  accountReorderInput: AccountReorderInput;
};


export type MutationSaveCubeResultArgs = {
  saveCubeResultInput: SaveCubeResultInput;
};


export type MutationSetUserDomainAccessLevelArgs = {
  domainSetAccessLevelInput: DomainSetAccessLevelInput;
};


export type MutationSetupMfaArgs = {
  mfaParameters: MfaParameters;
};


export type MutationStartPermissionRequestArgs = {
  bankPermissionRequest: BankPermissionRequest;
};


export type MutationSwitchDomainArgs = {
  switchDomainParameters: SwitchDomainParameters;
};


export type MutationTriggerFetchBankAccountDataArgs = {
  fetchBankAccountDataInput: FetchBankAccountDataInput;
};


export type MutationUpdateAccountArgs = {
  accountUpdateInput: AccountUpdateInput;
};


export type MutationUpdateAccountantSettingsArgs = {
  accountantSettingsUpdateInput: AccountantSettingsUpdateInput;
};


export type MutationUpdateBillArgs = {
  billUpdateInput: BillUpdateInput;
};


export type MutationUpdateBillingCategoryArgs = {
  billingCategoryUpdateInput: BillingCategoryUpdateInput;
};


export type MutationUpdateClientArgs = {
  clientUpdateInput: ClientUpdateInput;
};


export type MutationUpdateDomainArgs = {
  domainUpdateInput: DomainUpdateInput;
};


export type MutationUpdateIprArgs = {
  input?: InputMaybe<IntellectualPropertyData>;
  intellectualPropertyId: Scalars['Int']['input'];
};


export type MutationUpdateInvoiceArgs = {
  invoiceUpdateInput: InvoiceUpdateInput;
};


export type MutationUpdateLoanArgs = {
  input?: InputMaybe<LoanUpdateInput>;
};


export type MutationUpdatePiggyBankArgs = {
  piggyBankUpdateInput: PiggyBankUpdateInput;
};


export type MutationUpdateSupplierArgs = {
  supplierUpdateInput: SupplierUpdateInput;
};


export type MutationUpdateTaskArgs = {
  taskData: TaskData;
  taskId: Scalars['Int']['input'];
};


export type MutationUpdateTimeRecordArgs = {
  timeRecordData: TimeRecordData;
  timeRecordId: Scalars['Int']['input'];
};


export type MutationUpdateTimeRecordCategoryArgs = {
  name: Scalars['String']['input'];
  timeRecordId: Scalars['Int']['input'];
};


export type MutationUploadTaskAttachmentArgs = {
  input: TaskAttachmentUploadData;
};

export type MutuallyCancelInput = {
  transactionsPublicId: Array<Scalars['UUID']['input']>;
};

export type NthDayOfMonthRepaymentDayStrategyConfig = RepaymentDayStrategyConfig & {
  __typename?: 'NthDayOfMonthRepaymentDayStrategyConfig';
  dayOfMonth: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  publicId: Scalars['UUID']['output'];
};

export type NthDayOfMonthRepaymentDayStrategyConfigInput = {
  dayOfMonth: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type OtherParty = {
  domain: DomainSimple;
  name: Scalars['String']['output'];
  publicId: Scalars['UUID']['output'];
};

export type PiggyBank = {
  __typename?: 'PiggyBank';
  balance: MonetaryAmount;
  description: Scalars['String']['output'];
  domain: DomainSimple;
  monthlyTopUp: MonetaryAmount;
  name: Scalars['String']['output'];
  publicId: Scalars['UUID']['output'];
  savings: Scalars['Boolean']['output'];
};

export type PiggyBankCreationInput = {
  description: Scalars['String']['input'];
  monthlyTopUp: MonetaryAmountInput;
  name: Scalars['String']['input'];
  savings: Scalars['Boolean']['input'];
};

export type PiggyBankUpdateInput = {
  balance?: InputMaybe<MonetaryAmountInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  monthlyTopUp?: InputMaybe<MonetaryAmountInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  publicId: Scalars['UUID']['input'];
  savings?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Query = {
  __typename?: 'Query';
  allClients: Array<Client>;
  allSuppliers: Array<Supplier>;
  allTimeRecordCategories: Array<TimeRecordCategory>;
  bankPermissions: BankPermissions;
  bankTransactionsToImport: Array<BankTransactionToImport>;
  billingPeriod: BillingPeriodResponse;
  cubeResults: CubeResults;
  currentUser: CurrentUserProfile;
  domainInvitations: Array<DomainSimple>;
  financeManagement: FinanceManagement;
  intellectualPropertiesRecords?: Maybe<IntellectualPropertiesRecordsResponse>;
  intellectualPropertiesReport?: Maybe<IntellectualPropertyReportResponse>;
  loans: Loans;
  monthFinancialDocuments: Array<FinancialDocument>;
  monthLedger: Array<RevenueAndExpenseEntry>;
  settings: Settings;
  simulateExistingLoan: Array<LoanCalculationInstallment>;
  simulateLoan: Array<LoanCalculationInstallment>;
  singleLoan: Loan;
  strengthTraining: StrengthTrainingQuery;
  tasks: TasksResponse;
  timeRecords: TimeRecordsResponse;
};


export type QueryBillingPeriodArgs = {
  yearMonth?: InputMaybe<Scalars['YearMonth']['input']>;
};


export type QueryCubeResultsArgs = {
  cubeResultsQuery: CubeResultsQuery;
};


export type QueryIntellectualPropertiesRecordsArgs = {
  input: IntellectualPropertiesRecordsQueryInput;
};


export type QueryIntellectualPropertiesReportArgs = {
  input: IntellectualPropertyReportQuery;
};


export type QueryMonthFinancialDocumentsArgs = {
  yearMonth: Scalars['YearMonth']['input'];
};


export type QueryMonthLedgerArgs = {
  ledgerQuery?: InputMaybe<LedgerQuery>;
};


export type QuerySimulateExistingLoanArgs = {
  loanSimulationParams?: InputMaybe<LoanSimulationParams>;
};


export type QuerySimulateLoanArgs = {
  loanCalculationParams?: InputMaybe<LoanCalculationParams>;
};


export type QuerySingleLoanArgs = {
  input?: InputMaybe<LoanQuery>;
};


export type QueryTasksArgs = {
  input: TasksQueryInput;
};


export type QueryTimeRecordsArgs = {
  input: TimeRecordsQueryInput;
};

export type RateStrategyConfig = {
  name: Scalars['String']['output'];
  publicId: Scalars['UUID']['output'];
};

export type RateStrategyConfigDeleteInput = {
  publicId: Scalars['UUID']['input'];
};

export type RegistrationParameters = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  login: Scalars['String']['input'];
  password: Scalars['String']['input'];
  repeatedPassword: Scalars['String']['input'];
};

export type RepaymentDayStrategyConfig = {
  name: Scalars['String']['output'];
  publicId: Scalars['UUID']['output'];
};

export type RepaymentDayStrategyConfigDeleteInput = {
  publicId: Scalars['UUID']['input'];
};

export type RevenueAndExpenseEntry = {
  __typename?: 'RevenueAndExpenseEntry';
  accountingDocumentNumber: Scalars['String']['output'];
  additionalCostOfPurchase: Scalars['BigDecimal']['output'];
  comments: Scalars['String']['output'];
  counterparty: Scalars['String']['output'];
  counterpartyAddress: Scalars['String']['output'];
  description: Scalars['String']['output'];
  domain: DomainSimple;
  entryDate: Scalars['LocalDate']['output'];
  entryOrder: Scalars['Int']['output'];
  otherExpense: Scalars['BigDecimal']['output'];
  otherIncome: Scalars['BigDecimal']['output'];
  providedGoodsAndServicesValue: Scalars['BigDecimal']['output'];
  publicId: Scalars['UUID']['output'];
  purchasedGoodsAndMaterialsValue: Scalars['BigDecimal']['output'];
  remunerationInCashOrInKind: Scalars['BigDecimal']['output'];
  totalExpense: Scalars['BigDecimal']['output'];
  totalIncome: Scalars['BigDecimal']['output'];
};

export type RevenueAndExpenseEntryInput = {
  accountingDocumentNumber: Scalars['String']['input'];
  additionalCostOfPurchase: Scalars['BigDecimal']['input'];
  comments: Scalars['String']['input'];
  counterparty: Scalars['String']['input'];
  counterpartyAddress: Scalars['String']['input'];
  description: Scalars['String']['input'];
  entryDate: Scalars['LocalDate']['input'];
  entryOrder: Scalars['Int']['input'];
  otherExpense: Scalars['BigDecimal']['input'];
  otherIncome: Scalars['BigDecimal']['input'];
  providedGoodsAndServicesValue: Scalars['BigDecimal']['input'];
  publicId?: InputMaybe<Scalars['UUID']['input']>;
  purchasedGoodsAndMaterialsValue: Scalars['BigDecimal']['input'];
  remunerationInCashOrInKind: Scalars['BigDecimal']['input'];
  totalExpense: Scalars['BigDecimal']['input'];
  totalIncome: Scalars['BigDecimal']['input'];
};

export type SaveCubeResultInput = {
  cubeType: CubeType;
  timeInMillis: Scalars['Int']['input'];
  timestampOfSolve: Scalars['LocalDateTime']['input'];
};

export type SetAllowedStrengthTrainingVariantValuesInput = {
  defaultValuePublicId?: InputMaybe<Scalars['UUID']['input']>;
  familyDimensionPublicId: Scalars['UUID']['input'];
  variantValuePublicIds: Array<Scalars['UUID']['input']>;
};

export enum SetDomainAccessLevel {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  Remove = 'REMOVE'
}

export type Settings = {
  __typename?: 'Settings';
  accountantSettings: AccountantSettings;
  domains: Array<Domain>;
  id: Scalars['ID']['output'];
};

export enum StrengthTrainingCatalogScope {
  Domain = 'DOMAIN',
  System = 'SYSTEM'
}

export type StrengthTrainingExerciseFamily = {
  __typename?: 'StrengthTrainingExerciseFamily';
  active: Scalars['Boolean']['output'];
  dimensions: Array<StrengthTrainingExerciseFamilyDimension>;
  exerciseType: StrengthTrainingExerciseType;
  name: Scalars['String']['output'];
  publicId: Scalars['UUID']['output'];
  scope: StrengthTrainingCatalogScope;
};

export type StrengthTrainingExerciseFamilyDimension = {
  __typename?: 'StrengthTrainingExerciseFamilyDimension';
  allowedValues: Array<StrengthTrainingExerciseFamilyVariantValue>;
  position: Scalars['Int']['output'];
  publicId: Scalars['UUID']['output'];
  required: Scalars['Boolean']['output'];
  scope: StrengthTrainingCatalogScope;
  variantDimension: StrengthTrainingVariantDimension;
};

export type StrengthTrainingExerciseFamilyVariantValue = {
  __typename?: 'StrengthTrainingExerciseFamilyVariantValue';
  defaultValue: Scalars['Boolean']['output'];
  publicId: Scalars['UUID']['output'];
  scope: StrengthTrainingCatalogScope;
  variantValue: StrengthTrainingVariantValue;
};

export enum StrengthTrainingExerciseType {
  BodyweightReps = 'BODYWEIGHT_REPS',
  Distance = 'DISTANCE',
  Duration = 'DURATION',
  WeightReps = 'WEIGHT_REPS'
}

export type StrengthTrainingMutation = {
  __typename?: 'StrengthTrainingMutation';
  assignDimensionToFamily: StrengthTrainingExerciseFamilyDimension;
  createExerciseFamily: StrengthTrainingExerciseFamily;
  createVariantDimension: StrengthTrainingVariantDimension;
  createVariantValue: StrengthTrainingVariantValue;
  setAllowedVariantValues: Array<StrengthTrainingExerciseFamilyVariantValue>;
};


export type StrengthTrainingMutationAssignDimensionToFamilyArgs = {
  input: AssignStrengthTrainingDimensionToFamilyInput;
};


export type StrengthTrainingMutationCreateExerciseFamilyArgs = {
  input: CreateStrengthTrainingExerciseFamilyInput;
};


export type StrengthTrainingMutationCreateVariantDimensionArgs = {
  input: CreateStrengthTrainingVariantDimensionInput;
};


export type StrengthTrainingMutationCreateVariantValueArgs = {
  input: CreateStrengthTrainingVariantValueInput;
};


export type StrengthTrainingMutationSetAllowedVariantValuesArgs = {
  input: SetAllowedStrengthTrainingVariantValuesInput;
};

export type StrengthTrainingQuery = {
  __typename?: 'StrengthTrainingQuery';
  exerciseFamilies: Array<StrengthTrainingExerciseFamily>;
  variantDimensions: Array<StrengthTrainingVariantDimension>;
};


export type StrengthTrainingQueryExerciseFamiliesArgs = {
  exerciseFamilyPublicId?: InputMaybe<Scalars['UUID']['input']>;
};


export type StrengthTrainingQueryVariantDimensionsArgs = {
  variantDimensionPublicId?: InputMaybe<Scalars['UUID']['input']>;
};

export type StrengthTrainingVariantDimension = {
  __typename?: 'StrengthTrainingVariantDimension';
  active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  publicId: Scalars['UUID']['output'];
  scope: StrengthTrainingCatalogScope;
  values: Array<StrengthTrainingVariantValue>;
};

export type StrengthTrainingVariantValue = {
  __typename?: 'StrengthTrainingVariantValue';
  active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  publicId: Scalars['UUID']['output'];
  scope: StrengthTrainingCatalogScope;
};

export type Supplier = OtherParty & {
  __typename?: 'Supplier';
  domain: DomainSimple;
  name: Scalars['String']['output'];
  publicId: Scalars['UUID']['output'];
};

export type SupplierCreationInput = {
  name: Scalars['String']['input'];
};

export type SupplierUpdateInput = {
  name: Scalars['String']['input'];
  publicId: Scalars['UUID']['input'];
};

export type SwitchDomainParameters = {
  domainPublicId?: InputMaybe<Scalars['UUID']['input']>;
};

export type Task = {
  __typename?: 'Task';
  attachments?: Maybe<Array<Scalars['String']['output']>>;
  coAuthors: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  timeRecords?: Maybe<Array<TimeRecord>>;
};

export type TaskAttachmentDeleteData = {
  fileName: Scalars['String']['input'];
  taskId: Scalars['Int']['input'];
};

export type TaskAttachmentUploadData = {
  file: Scalars['Upload']['input'];
  taskId: Scalars['Int']['input'];
};

export type TaskData = {
  coAuthors: Scalars['String']['input'];
  description: Scalars['String']['input'];
};

export type TasksQueryInput = {
  description?: Scalars['String']['input'];
};

export type TasksResponse = {
  __typename?: 'TasksResponse';
  tasks: Array<Task>;
};

export type TimeRecord = {
  __typename?: 'TimeRecord';
  date: Scalars['LocalDate']['output'];
  description?: Maybe<Scalars['String']['output']>;
  domain: DomainSimple;
  id: Scalars['Int']['output'];
  numberOfHours: Scalars['BigDecimal']['output'];
  timeRecordCategory?: Maybe<TimeRecordCategory>;
};

export type TimeRecordCategory = {
  __typename?: 'TimeRecordCategory';
  domain: DomainSimple;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type TimeRecordData = {
  assignmentAction: AssignmentAction;
  date: Scalars['LocalDate']['input'];
  description: Scalars['String']['input'];
  numberOfHours: Scalars['BigDecimal']['input'];
  taskId?: InputMaybe<Scalars['Int']['input']>;
};

export type TimeRecordsQueryInput = {
  yearMonthFilter?: InputMaybe<Scalars['YearMonth']['input']>;
};

export type TimeRecordsReport = {
  __typename?: 'TimeRecordsReport';
  description: Scalars['String']['output'];
  ipHours: Scalars['BigDecimal']['output'];
  nonIPHours: Scalars['BigDecimal']['output'];
};

export type TimeRecordsResponse = {
  __typename?: 'TimeRecordsResponse';
  nonIPTimeRecords: Array<TimeRecord>;
  stats: TimeRecordsStats;
  taskWithSelectedTimeRecords: Array<Task>;
};

export type TimeRecordsStats = {
  __typename?: 'TimeRecordsStats';
  firstTimeRecord: Scalars['LocalDate']['output'];
  lastTimeRecord: Scalars['LocalDate']['output'];
};

export type User = {
  __typename?: 'User';
  domainPublicId: Scalars['UUID']['output'];
  domains: Array<DomainSimple>;
  email: Scalars['String']['output'];
  login: Scalars['String']['output'];
  name: Scalars['String']['output'];
  roles: Array<Scalars['String']['output']>;
};



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = Record<PropertyKey, never>, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;




/** Mapping of interface types */
export type ResolversInterfaceTypes<_RefType extends Record<string, unknown>> = {
  FinancialDocument:
    | ( BillOfPurchase )
    | ( BillOfSale )
    | ( CreditInvoice )
    | ( DebitInvoice )
  ;
  Invoice:
    | ( CreditInvoice )
    | ( DebitInvoice )
  ;
  OtherParty:
    | ( Client )
    | ( Supplier )
  ;
  RateStrategyConfig: ( ConstantForNFirstInstallmentRateStrategyConfig );
  RepaymentDayStrategyConfig: ( NthDayOfMonthRepaymentDayStrategyConfig );
};

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  Account: ResolverTypeWrapper<Account>;
  AccountCreationInput: AccountCreationInput;
  AccountPutBetweenInput: AccountPutBetweenInput;
  AccountReorderInput: AccountReorderInput;
  AccountTransaction: ResolverTypeWrapper<AccountTransaction>;
  AccountUpdateInput: AccountUpdateInput;
  AccountantSettings: ResolverTypeWrapper<AccountantSettings>;
  AccountantSettingsUpdateInput: AccountantSettingsUpdateInput;
  AssignBankAccountToAccountInput: AssignBankAccountToAccountInput;
  AssignStrengthTrainingDimensionToFamilyInput: AssignStrengthTrainingDimensionToFamilyInput;
  AssignmentAction: AssignmentAction;
  AuthenticationInfo: ResolverTypeWrapper<AuthenticationInfo>;
  BankAccount: ResolverTypeWrapper<BankAccount>;
  BankPermission: ResolverTypeWrapper<BankPermission>;
  BankPermissionRequest: BankPermissionRequest;
  BankPermissions: ResolverTypeWrapper<BankPermissions>;
  BankTransactionToImport: ResolverTypeWrapper<BankTransactionToImport>;
  BigDecimal: ResolverTypeWrapper<Scalars['BigDecimal']['output']>;
  BillCreationInput: BillCreationInput;
  BillOfPurchase: ResolverTypeWrapper<BillOfPurchase>;
  BillOfSale: ResolverTypeWrapper<BillOfSale>;
  BillType: BillType;
  BillUpdateInput: BillUpdateInput;
  BillingCategory: ResolverTypeWrapper<BillingCategory>;
  BillingCategoryCreationInput: BillingCategoryCreationInput;
  BillingCategoryShort: ResolverTypeWrapper<BillingCategoryShort>;
  BillingCategoryUpdateInput: BillingCategoryUpdateInput;
  BillingPeriod: ResolverTypeWrapper<BillingPeriod>;
  BillingPeriodCreationBlockers: ResolverTypeWrapper<BillingPeriodCreationBlockers>;
  BillingPeriodResponse: ResolverTypeWrapper<BillingPeriodResponse>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  Client: ResolverTypeWrapper<Client>;
  ClientCreationInput: ClientCreationInput;
  ClientUpdateInput: ClientUpdateInput;
  ConfirmPermissionRequest: ConfirmPermissionRequest;
  ConstantForNFirstInstallmentRateStrategyConfig: ResolverTypeWrapper<ConstantForNFirstInstallmentRateStrategyConfig>;
  ConstantForNFirstInstallmentRateStrategyConfigCreationInput: ConstantForNFirstInstallmentRateStrategyConfigCreationInput;
  CreateBillingElementInput: CreateBillingElementInput;
  CreateStrengthTrainingExerciseFamilyInput: CreateStrengthTrainingExerciseFamilyInput;
  CreateStrengthTrainingVariantDimensionInput: CreateStrengthTrainingVariantDimensionInput;
  CreateStrengthTrainingVariantValueInput: CreateStrengthTrainingVariantValueInput;
  CreateTransferInput: CreateTransferInput;
  CreditInvoice: ResolverTypeWrapper<CreditInvoice>;
  CubeDayStats: ResolverTypeWrapper<CubeDayStats>;
  CubeResult: ResolverTypeWrapper<CubeResult>;
  CubeResults: ResolverTypeWrapper<CubeResults>;
  CubeResultsQuery: CubeResultsQuery;
  CubeType: CubeType;
  Currency: ResolverTypeWrapper<Scalars['Currency']['output']>;
  CurrencyInfo: ResolverTypeWrapper<CurrencyInfo>;
  CurrentUserProfile: ResolverTypeWrapper<CurrentUserProfile>;
  DebitInvoice: ResolverTypeWrapper<DebitInvoice>;
  DeleteBankAccountAssignmentInput: DeleteBankAccountAssignmentInput;
  Domain: ResolverTypeWrapper<Domain>;
  DomainAccessLevel: DomainAccessLevel;
  DomainCreationInput: DomainCreationInput;
  DomainInvitationInput: DomainInvitationInput;
  DomainInvitationResponseInput: DomainInvitationResponseInput;
  DomainSetAccessLevelInput: DomainSetAccessLevelInput;
  DomainSimple: ResolverTypeWrapper<DomainSimple>;
  DomainUpdateInput: DomainUpdateInput;
  DomainUser: ResolverTypeWrapper<DomainUser>;
  Expense: ResolverTypeWrapper<Expense>;
  FetchBankAccountDataInput: FetchBankAccountDataInput;
  FinanceManagement: ResolverTypeWrapper<FinanceManagement>;
  FinancialDocument: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['FinancialDocument']>;
  FinancialDocumentKind: FinancialDocumentKind;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  ImportBankTransactionsInput: ImportBankTransactionsInput;
  Income: ResolverTypeWrapper<Income>;
  Installment: ResolverTypeWrapper<Installment>;
  InstallmentCreationInput: InstallmentCreationInput;
  Institution: ResolverTypeWrapper<Institution>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  IntellectualPropertiesRecordsQueryInput: IntellectualPropertiesRecordsQueryInput;
  IntellectualPropertiesRecordsResponse: ResolverTypeWrapper<IntellectualPropertiesRecordsResponse>;
  IntellectualPropertiesReport: ResolverTypeWrapper<IntellectualPropertiesReport>;
  IntellectualProperty: ResolverTypeWrapper<IntellectualProperty>;
  IntellectualPropertyData: IntellectualPropertyData;
  IntellectualPropertyMonthReport: ResolverTypeWrapper<IntellectualPropertyMonthReport>;
  IntellectualPropertyReportQuery: IntellectualPropertyReportQuery;
  IntellectualPropertyReportResponse: ResolverTypeWrapper<IntellectualPropertyReportResponse>;
  Invoice: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Invoice']>;
  InvoiceCreationInput: InvoiceCreationInput;
  InvoiceType: InvoiceType;
  InvoiceUpdateInput: InvoiceUpdateInput;
  LedgerQuery: LedgerQuery;
  Loan: ResolverTypeWrapper<Omit<Loan, 'rateStrategyConfig' | 'repaymentDayStrategyConfig'> & { rateStrategyConfig: ResolversTypes['RateStrategyConfig'], repaymentDayStrategyConfig: ResolversTypes['RepaymentDayStrategyConfig'] }>;
  LoanCalculationInstallment: ResolverTypeWrapper<LoanCalculationInstallment>;
  LoanCalculationParams: LoanCalculationParams;
  LoanCreationInput: LoanCreationInput;
  LoanDeleteInput: LoanDeleteInput;
  LoanQuery: LoanQuery;
  LoanSimulationParams: LoanSimulationParams;
  LoanUpdateInput: LoanUpdateInput;
  Loans: ResolverTypeWrapper<Omit<Loans, 'loans' | 'rateStrategyConfigs' | 'repaymentDayStrategyConfigs'> & { loans: Array<ResolversTypes['Loan']>, rateStrategyConfigs: Array<ResolversTypes['RateStrategyConfig']>, repaymentDayStrategyConfigs: Array<ResolversTypes['RepaymentDayStrategyConfig']> }>;
  LocalDate: ResolverTypeWrapper<Scalars['LocalDate']['output']>;
  LocalDateTime: ResolverTypeWrapper<Scalars['LocalDateTime']['output']>;
  LoginParameters: LoginParameters;
  LoginWithGoogleTokenParameters: LoginWithGoogleTokenParameters;
  MFAData: ResolverTypeWrapper<MfaData>;
  MFAParameters: MfaParameters;
  MonetaryAmount: ResolverTypeWrapper<MonetaryAmount>;
  MonetaryAmountInput: MonetaryAmountInput;
  MonthSummary: ResolverTypeWrapper<MonthSummary>;
  MonthSummaryAccount: ResolverTypeWrapper<MonthSummaryAccount>;
  MonthSummaryPiggyBank: ResolverTypeWrapper<MonthSummaryPiggyBank>;
  MonthSummarySavings: ResolverTypeWrapper<MonthSummarySavings>;
  Mutation: ResolverTypeWrapper<Record<PropertyKey, never>>;
  MutuallyCancelInput: MutuallyCancelInput;
  NthDayOfMonthRepaymentDayStrategyConfig: ResolverTypeWrapper<NthDayOfMonthRepaymentDayStrategyConfig>;
  NthDayOfMonthRepaymentDayStrategyConfigInput: NthDayOfMonthRepaymentDayStrategyConfigInput;
  OtherParty: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['OtherParty']>;
  PiggyBank: ResolverTypeWrapper<PiggyBank>;
  PiggyBankCreationInput: PiggyBankCreationInput;
  PiggyBankUpdateInput: PiggyBankUpdateInput;
  Query: ResolverTypeWrapper<Record<PropertyKey, never>>;
  RateStrategyConfig: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['RateStrategyConfig']>;
  RateStrategyConfigDeleteInput: RateStrategyConfigDeleteInput;
  RegistrationParameters: RegistrationParameters;
  RepaymentDayStrategyConfig: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['RepaymentDayStrategyConfig']>;
  RepaymentDayStrategyConfigDeleteInput: RepaymentDayStrategyConfigDeleteInput;
  RevenueAndExpenseEntry: ResolverTypeWrapper<RevenueAndExpenseEntry>;
  RevenueAndExpenseEntryInput: RevenueAndExpenseEntryInput;
  SaveCubeResultInput: SaveCubeResultInput;
  SetAllowedStrengthTrainingVariantValuesInput: SetAllowedStrengthTrainingVariantValuesInput;
  SetDomainAccessLevel: SetDomainAccessLevel;
  Settings: ResolverTypeWrapper<Settings>;
  StrengthTrainingCatalogScope: StrengthTrainingCatalogScope;
  StrengthTrainingExerciseFamily: ResolverTypeWrapper<StrengthTrainingExerciseFamily>;
  StrengthTrainingExerciseFamilyDimension: ResolverTypeWrapper<StrengthTrainingExerciseFamilyDimension>;
  StrengthTrainingExerciseFamilyVariantValue: ResolverTypeWrapper<StrengthTrainingExerciseFamilyVariantValue>;
  StrengthTrainingExerciseType: StrengthTrainingExerciseType;
  StrengthTrainingMutation: ResolverTypeWrapper<StrengthTrainingMutation>;
  StrengthTrainingQuery: ResolverTypeWrapper<StrengthTrainingQuery>;
  StrengthTrainingVariantDimension: ResolverTypeWrapper<StrengthTrainingVariantDimension>;
  StrengthTrainingVariantValue: ResolverTypeWrapper<StrengthTrainingVariantValue>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  Supplier: ResolverTypeWrapper<Supplier>;
  SupplierCreationInput: SupplierCreationInput;
  SupplierUpdateInput: SupplierUpdateInput;
  SwitchDomainParameters: SwitchDomainParameters;
  Task: ResolverTypeWrapper<Task>;
  TaskAttachmentDeleteData: TaskAttachmentDeleteData;
  TaskAttachmentUploadData: TaskAttachmentUploadData;
  TaskData: TaskData;
  TasksQueryInput: TasksQueryInput;
  TasksResponse: ResolverTypeWrapper<TasksResponse>;
  TimeRecord: ResolverTypeWrapper<TimeRecord>;
  TimeRecordCategory: ResolverTypeWrapper<TimeRecordCategory>;
  TimeRecordData: TimeRecordData;
  TimeRecordsQueryInput: TimeRecordsQueryInput;
  TimeRecordsReport: ResolverTypeWrapper<TimeRecordsReport>;
  TimeRecordsResponse: ResolverTypeWrapper<TimeRecordsResponse>;
  TimeRecordsStats: ResolverTypeWrapper<TimeRecordsStats>;
  URL: ResolverTypeWrapper<Scalars['URL']['output']>;
  UUID: ResolverTypeWrapper<Scalars['UUID']['output']>;
  Upload: ResolverTypeWrapper<Scalars['Upload']['output']>;
  User: ResolverTypeWrapper<User>;
  Year: ResolverTypeWrapper<Scalars['Year']['output']>;
  YearMonth: ResolverTypeWrapper<Scalars['YearMonth']['output']>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Account: Account;
  AccountCreationInput: AccountCreationInput;
  AccountPutBetweenInput: AccountPutBetweenInput;
  AccountReorderInput: AccountReorderInput;
  AccountTransaction: AccountTransaction;
  AccountUpdateInput: AccountUpdateInput;
  AccountantSettings: AccountantSettings;
  AccountantSettingsUpdateInput: AccountantSettingsUpdateInput;
  AssignBankAccountToAccountInput: AssignBankAccountToAccountInput;
  AssignStrengthTrainingDimensionToFamilyInput: AssignStrengthTrainingDimensionToFamilyInput;
  AuthenticationInfo: AuthenticationInfo;
  BankAccount: BankAccount;
  BankPermission: BankPermission;
  BankPermissionRequest: BankPermissionRequest;
  BankPermissions: BankPermissions;
  BankTransactionToImport: BankTransactionToImport;
  BigDecimal: Scalars['BigDecimal']['output'];
  BillCreationInput: BillCreationInput;
  BillOfPurchase: BillOfPurchase;
  BillOfSale: BillOfSale;
  BillUpdateInput: BillUpdateInput;
  BillingCategory: BillingCategory;
  BillingCategoryCreationInput: BillingCategoryCreationInput;
  BillingCategoryShort: BillingCategoryShort;
  BillingCategoryUpdateInput: BillingCategoryUpdateInput;
  BillingPeriod: BillingPeriod;
  BillingPeriodCreationBlockers: BillingPeriodCreationBlockers;
  BillingPeriodResponse: BillingPeriodResponse;
  Boolean: Scalars['Boolean']['output'];
  Client: Client;
  ClientCreationInput: ClientCreationInput;
  ClientUpdateInput: ClientUpdateInput;
  ConfirmPermissionRequest: ConfirmPermissionRequest;
  ConstantForNFirstInstallmentRateStrategyConfig: ConstantForNFirstInstallmentRateStrategyConfig;
  ConstantForNFirstInstallmentRateStrategyConfigCreationInput: ConstantForNFirstInstallmentRateStrategyConfigCreationInput;
  CreateBillingElementInput: CreateBillingElementInput;
  CreateStrengthTrainingExerciseFamilyInput: CreateStrengthTrainingExerciseFamilyInput;
  CreateStrengthTrainingVariantDimensionInput: CreateStrengthTrainingVariantDimensionInput;
  CreateStrengthTrainingVariantValueInput: CreateStrengthTrainingVariantValueInput;
  CreateTransferInput: CreateTransferInput;
  CreditInvoice: CreditInvoice;
  CubeDayStats: CubeDayStats;
  CubeResult: CubeResult;
  CubeResults: CubeResults;
  CubeResultsQuery: CubeResultsQuery;
  Currency: Scalars['Currency']['output'];
  CurrencyInfo: CurrencyInfo;
  CurrentUserProfile: CurrentUserProfile;
  DebitInvoice: DebitInvoice;
  DeleteBankAccountAssignmentInput: DeleteBankAccountAssignmentInput;
  Domain: Domain;
  DomainCreationInput: DomainCreationInput;
  DomainInvitationInput: DomainInvitationInput;
  DomainInvitationResponseInput: DomainInvitationResponseInput;
  DomainSetAccessLevelInput: DomainSetAccessLevelInput;
  DomainSimple: DomainSimple;
  DomainUpdateInput: DomainUpdateInput;
  DomainUser: DomainUser;
  Expense: Expense;
  FetchBankAccountDataInput: FetchBankAccountDataInput;
  FinanceManagement: FinanceManagement;
  FinancialDocument: ResolversInterfaceTypes<ResolversParentTypes>['FinancialDocument'];
  ID: Scalars['ID']['output'];
  ImportBankTransactionsInput: ImportBankTransactionsInput;
  Income: Income;
  Installment: Installment;
  InstallmentCreationInput: InstallmentCreationInput;
  Institution: Institution;
  Int: Scalars['Int']['output'];
  IntellectualPropertiesRecordsQueryInput: IntellectualPropertiesRecordsQueryInput;
  IntellectualPropertiesRecordsResponse: IntellectualPropertiesRecordsResponse;
  IntellectualPropertiesReport: IntellectualPropertiesReport;
  IntellectualProperty: IntellectualProperty;
  IntellectualPropertyData: IntellectualPropertyData;
  IntellectualPropertyMonthReport: IntellectualPropertyMonthReport;
  IntellectualPropertyReportQuery: IntellectualPropertyReportQuery;
  IntellectualPropertyReportResponse: IntellectualPropertyReportResponse;
  Invoice: ResolversInterfaceTypes<ResolversParentTypes>['Invoice'];
  InvoiceCreationInput: InvoiceCreationInput;
  InvoiceUpdateInput: InvoiceUpdateInput;
  LedgerQuery: LedgerQuery;
  Loan: Omit<Loan, 'rateStrategyConfig' | 'repaymentDayStrategyConfig'> & { rateStrategyConfig: ResolversParentTypes['RateStrategyConfig'], repaymentDayStrategyConfig: ResolversParentTypes['RepaymentDayStrategyConfig'] };
  LoanCalculationInstallment: LoanCalculationInstallment;
  LoanCalculationParams: LoanCalculationParams;
  LoanCreationInput: LoanCreationInput;
  LoanDeleteInput: LoanDeleteInput;
  LoanQuery: LoanQuery;
  LoanSimulationParams: LoanSimulationParams;
  LoanUpdateInput: LoanUpdateInput;
  Loans: Omit<Loans, 'loans' | 'rateStrategyConfigs' | 'repaymentDayStrategyConfigs'> & { loans: Array<ResolversParentTypes['Loan']>, rateStrategyConfigs: Array<ResolversParentTypes['RateStrategyConfig']>, repaymentDayStrategyConfigs: Array<ResolversParentTypes['RepaymentDayStrategyConfig']> };
  LocalDate: Scalars['LocalDate']['output'];
  LocalDateTime: Scalars['LocalDateTime']['output'];
  LoginParameters: LoginParameters;
  LoginWithGoogleTokenParameters: LoginWithGoogleTokenParameters;
  MFAData: MfaData;
  MFAParameters: MfaParameters;
  MonetaryAmount: MonetaryAmount;
  MonetaryAmountInput: MonetaryAmountInput;
  MonthSummary: MonthSummary;
  MonthSummaryAccount: MonthSummaryAccount;
  MonthSummaryPiggyBank: MonthSummaryPiggyBank;
  MonthSummarySavings: MonthSummarySavings;
  Mutation: Record<PropertyKey, never>;
  MutuallyCancelInput: MutuallyCancelInput;
  NthDayOfMonthRepaymentDayStrategyConfig: NthDayOfMonthRepaymentDayStrategyConfig;
  NthDayOfMonthRepaymentDayStrategyConfigInput: NthDayOfMonthRepaymentDayStrategyConfigInput;
  OtherParty: ResolversInterfaceTypes<ResolversParentTypes>['OtherParty'];
  PiggyBank: PiggyBank;
  PiggyBankCreationInput: PiggyBankCreationInput;
  PiggyBankUpdateInput: PiggyBankUpdateInput;
  Query: Record<PropertyKey, never>;
  RateStrategyConfig: ResolversInterfaceTypes<ResolversParentTypes>['RateStrategyConfig'];
  RateStrategyConfigDeleteInput: RateStrategyConfigDeleteInput;
  RegistrationParameters: RegistrationParameters;
  RepaymentDayStrategyConfig: ResolversInterfaceTypes<ResolversParentTypes>['RepaymentDayStrategyConfig'];
  RepaymentDayStrategyConfigDeleteInput: RepaymentDayStrategyConfigDeleteInput;
  RevenueAndExpenseEntry: RevenueAndExpenseEntry;
  RevenueAndExpenseEntryInput: RevenueAndExpenseEntryInput;
  SaveCubeResultInput: SaveCubeResultInput;
  SetAllowedStrengthTrainingVariantValuesInput: SetAllowedStrengthTrainingVariantValuesInput;
  Settings: Settings;
  StrengthTrainingExerciseFamily: StrengthTrainingExerciseFamily;
  StrengthTrainingExerciseFamilyDimension: StrengthTrainingExerciseFamilyDimension;
  StrengthTrainingExerciseFamilyVariantValue: StrengthTrainingExerciseFamilyVariantValue;
  StrengthTrainingMutation: StrengthTrainingMutation;
  StrengthTrainingQuery: StrengthTrainingQuery;
  StrengthTrainingVariantDimension: StrengthTrainingVariantDimension;
  StrengthTrainingVariantValue: StrengthTrainingVariantValue;
  String: Scalars['String']['output'];
  Supplier: Supplier;
  SupplierCreationInput: SupplierCreationInput;
  SupplierUpdateInput: SupplierUpdateInput;
  SwitchDomainParameters: SwitchDomainParameters;
  Task: Task;
  TaskAttachmentDeleteData: TaskAttachmentDeleteData;
  TaskAttachmentUploadData: TaskAttachmentUploadData;
  TaskData: TaskData;
  TasksQueryInput: TasksQueryInput;
  TasksResponse: TasksResponse;
  TimeRecord: TimeRecord;
  TimeRecordCategory: TimeRecordCategory;
  TimeRecordData: TimeRecordData;
  TimeRecordsQueryInput: TimeRecordsQueryInput;
  TimeRecordsReport: TimeRecordsReport;
  TimeRecordsResponse: TimeRecordsResponse;
  TimeRecordsStats: TimeRecordsStats;
  URL: Scalars['URL']['output'];
  UUID: Scalars['UUID']['output'];
  Upload: Scalars['Upload']['output'];
  User: User;
  Year: Scalars['Year']['output'];
  YearMonth: Scalars['YearMonth']['output'];
};

export type AccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['Account'] = ResolversParentTypes['Account']> = {
  balanceIndex?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bankAccount?: Resolver<Maybe<ResolversTypes['BankAccount']>, ParentType, ContextType>;
  creditLimit?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  currentBalance?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  domain?: Resolver<Maybe<ResolversTypes['DomainSimple']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  publicId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  transactions?: Resolver<Array<ResolversTypes['AccountTransaction']>, ParentType, ContextType, Partial<AccountTransactionsArgs>>;
  visible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type AccountTransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountTransaction'] = ResolversParentTypes['AccountTransaction']> = {
  credit?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  debit?: Resolver<Maybe<ResolversTypes['MonetaryAmount']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  destination?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  publicId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  timeOfTransaction?: Resolver<ResolversTypes['LocalDateTime'], ParentType, ContextType>;
};

export type AccountantSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountantSettings'] = ResolversParentTypes['AccountantSettings']> = {
  isCompany?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type AuthenticationInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthenticationInfo'] = ResolversParentTypes['AuthenticationInfo']> = {
  jwt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
};

export type BankAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankAccount'] = ResolversParentTypes['BankAccount']> = {
  iban?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publicId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
};

export type BankPermissionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankPermission'] = ResolversParentTypes['BankPermission']> = {
  bankAccounts?: Resolver<Array<ResolversTypes['BankAccount']>, ParentType, ContextType>;
  confirmationLink?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['LocalDateTime'], ParentType, ContextType>;
  givenAt?: Resolver<Maybe<ResolversTypes['LocalDateTime']>, ParentType, ContextType>;
  institution?: Resolver<Maybe<ResolversTypes['Institution']>, ParentType, ContextType>;
  institutionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publicId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  reference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requisitionId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  ssn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  withdrawnAt?: Resolver<Maybe<ResolversTypes['LocalDateTime']>, ParentType, ContextType>;
};

export type BankPermissionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankPermissions'] = ResolversParentTypes['BankPermissions']> = {
  availableInstitutions?: Resolver<Array<ResolversTypes['Institution']>, ParentType, ContextType, RequireFields<BankPermissionsAvailableInstitutionsArgs, 'country'>>;
  bankAccountsNotAssignedToAccount?: Resolver<Array<ResolversTypes['BankAccount']>, ParentType, ContextType>;
  granted?: Resolver<Array<ResolversTypes['BankPermission']>, ParentType, ContextType>;
  toProcess?: Resolver<Array<ResolversTypes['BankPermission']>, ParentType, ContextType>;
  toRecreate?: Resolver<Array<ResolversTypes['Institution']>, ParentType, ContextType>;
};

export type BankTransactionToImportResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankTransactionToImport'] = ResolversParentTypes['BankTransactionToImport']> = {
  conversionRate?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  credit?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  creditBankAccountPublicId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  creditTransactionPublicId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  debit?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  debitBankAccountPublicId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  debitTransactionPublicId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  destinationAccountPublicId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sourceAccountPublicId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  timeOfTransaction?: Resolver<ResolversTypes['LocalDateTime'], ParentType, ContextType>;
  transactionPublicId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
};

export interface BigDecimalScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['BigDecimal'], any> {
  name: 'BigDecimal';
}

export type BillOfPurchaseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BillOfPurchase'] = ResolversParentTypes['BillOfPurchase']> = {
  amount?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['LocalDate'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  domain?: Resolver<ResolversTypes['DomainSimple'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  otherParty?: Resolver<ResolversTypes['Supplier'], ParentType, ContextType>;
  publicId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BillOfSaleResolvers<ContextType = any, ParentType extends ResolversParentTypes['BillOfSale'] = ResolversParentTypes['BillOfSale']> = {
  amount?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['LocalDate'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  domain?: Resolver<ResolversTypes['DomainSimple'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  otherParty?: Resolver<ResolversTypes['Client'], ParentType, ContextType>;
  publicId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BillingCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['BillingCategory'] = ResolversParentTypes['BillingCategory']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  domain?: Resolver<ResolversTypes['DomainSimple'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publicId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
};

export type BillingCategoryShortResolvers<ContextType = any, ParentType extends ResolversParentTypes['BillingCategoryShort'] = ResolversParentTypes['BillingCategoryShort']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type BillingPeriodResolvers<ContextType = any, ParentType extends ResolversParentTypes['BillingPeriod'] = ResolversParentTypes['BillingPeriod']> = {
  expenses?: Resolver<Array<ResolversTypes['Expense']>, ParentType, ContextType>;
  incomes?: Resolver<Array<ResolversTypes['Income']>, ParentType, ContextType>;
  monthSummary?: Resolver<Maybe<ResolversTypes['MonthSummary']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  period?: Resolver<ResolversTypes['YearMonth'], ParentType, ContextType>;
  publicId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
};

export type BillingPeriodCreationBlockersResolvers<ContextType = any, ParentType extends ResolversParentTypes['BillingPeriodCreationBlockers'] = ResolversParentTypes['BillingPeriodCreationBlockers']> = {
  alreadyExists?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  notForCurrentMonth?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  unfinishedBillingPeriods?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type BillingPeriodResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BillingPeriodResponse'] = ResolversParentTypes['BillingPeriodResponse']> = {
  billingPeriod?: Resolver<Maybe<ResolversTypes['BillingPeriod']>, ParentType, ContextType>;
  creationBlockers?: Resolver<ResolversTypes['BillingPeriodCreationBlockers'], ParentType, ContextType>;
};

export type ClientResolvers<ContextType = any, ParentType extends ResolversParentTypes['Client'] = ResolversParentTypes['Client']> = {
  domain?: Resolver<ResolversTypes['DomainSimple'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publicId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConstantForNFirstInstallmentRateStrategyConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConstantForNFirstInstallmentRateStrategyConfig'] = ResolversParentTypes['ConstantForNFirstInstallmentRateStrategyConfig']> = {
  becomesVariableRateAfterNInstallments?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  constantRate?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publicId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  variableRateMargin?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreditInvoiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreditInvoice'] = ResolversParentTypes['CreditInvoice']> = {
  amount?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['LocalDate'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  domain?: Resolver<ResolversTypes['DomainSimple'], ParentType, ContextType>;
  dueTo?: Resolver<ResolversTypes['LocalDate'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  otherParty?: Resolver<ResolversTypes['Client'], ParentType, ContextType>;
  publicId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  vat?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CubeDayStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CubeDayStats'] = ResolversParentTypes['CubeDayStats']> = {
  day?: Resolver<ResolversTypes['LocalDate'], ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  minAo5?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  minAo30?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numberOfTries?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type CubeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CubeResult'] = ResolversParentTypes['CubeResult']> = {
  date?: Resolver<ResolversTypes['LocalDateTime'], ParentType, ContextType>;
  timeInMillis?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type CubeResultsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CubeResults'] = ResolversParentTypes['CubeResults']> = {
  stats?: Resolver<Array<ResolversTypes['CubeDayStats']>, ParentType, ContextType, RequireFields<CubeResultsStatsArgs, 'month'>>;
  todayResults?: Resolver<Array<ResolversTypes['CubeResult']>, ParentType, ContextType>;
  todayStats?: Resolver<ResolversTypes['CubeDayStats'], ParentType, ContextType>;
  topTenAllTime?: Resolver<Array<ResolversTypes['CubeResult']>, ParentType, ContextType>;
};

export interface CurrencyScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Currency'], any> {
  name: 'Currency';
}

export type CurrencyInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrencyInfo'] = ResolversParentTypes['CurrencyInfo']> = {
  code?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type CurrentUserProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrentUserProfile'] = ResolversParentTypes['CurrentUserProfile']> = {
  domain?: Resolver<ResolversTypes['DomainSimple'], ParentType, ContextType>;
  domains?: Resolver<Array<ResolversTypes['DomainSimple']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  login?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  roles?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
};

export type DebitInvoiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['DebitInvoice'] = ResolversParentTypes['DebitInvoice']> = {
  amount?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['LocalDate'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  domain?: Resolver<ResolversTypes['DomainSimple'], ParentType, ContextType>;
  dueTo?: Resolver<ResolversTypes['LocalDate'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  otherParty?: Resolver<ResolversTypes['Supplier'], ParentType, ContextType>;
  publicId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  vat?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomainResolvers<ContextType = any, ParentType extends ResolversParentTypes['Domain'] = ResolversParentTypes['Domain']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publicId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  users?: Resolver<Array<ResolversTypes['DomainUser']>, ParentType, ContextType>;
};

export type DomainSimpleResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomainSimple'] = ResolversParentTypes['DomainSimple']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publicId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
};

export type DomainUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomainUser'] = ResolversParentTypes['DomainUser']> = {
  domainAccessLevel?: Resolver<ResolversTypes['DomainAccessLevel'], ParentType, ContextType>;
  login?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ExpenseResolvers<ContextType = any, ParentType extends ResolversParentTypes['Expense'] = ResolversParentTypes['Expense']> = {
  amount?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  category?: Resolver<ResolversTypes['BillingCategoryShort'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['LocalDate'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publicId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
};

export type FinanceManagementResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinanceManagement'] = ResolversParentTypes['FinanceManagement']> = {
  accounts?: Resolver<Array<ResolversTypes['Account']>, ParentType, ContextType, Partial<FinanceManagementAccountsArgs>>;
  billingCategories?: Resolver<Array<ResolversTypes['BillingCategory']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  piggyBanks?: Resolver<Array<ResolversTypes['PiggyBank']>, ParentType, ContextType>;
  supportedCurrencies?: Resolver<Array<ResolversTypes['CurrencyInfo']>, ParentType, ContextType>;
};

export type FinancialDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialDocument'] = ResolversParentTypes['FinancialDocument']> = {
  __resolveType: TypeResolveFn<'BillOfPurchase' | 'BillOfSale' | 'CreditInvoice' | 'DebitInvoice', ParentType, ContextType>;
};

export type IncomeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Income'] = ResolversParentTypes['Income']> = {
  amount?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  category?: Resolver<ResolversTypes['BillingCategoryShort'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['LocalDate'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publicId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
};

export type InstallmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Installment'] = ResolversParentTypes['Installment']> = {
  overpayment?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  paidAt?: Resolver<ResolversTypes['LocalDate'], ParentType, ContextType>;
  publicId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  repaidAmount?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  repaidInterest?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
};

export type InstitutionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Institution'] = ResolversParentTypes['Institution']> = {
  bic?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  countries?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  logo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionTotalDays?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type IntellectualPropertiesRecordsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntellectualPropertiesRecordsResponse'] = ResolversParentTypes['IntellectualPropertiesRecordsResponse']> = {
  reports?: Resolver<Array<ResolversTypes['IntellectualProperty']>, ParentType, ContextType>;
  stats?: Resolver<ResolversTypes['TimeRecordsStats'], ParentType, ContextType>;
};

export type IntellectualPropertiesReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntellectualPropertiesReport'] = ResolversParentTypes['IntellectualPropertiesReport']> = {
  countOfDifferentIPs?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  ipHours?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  ipPercentage?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  monthReports?: Resolver<Array<ResolversTypes['IntellectualPropertyMonthReport']>, ParentType, ContextType>;
  nonIPHours?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  year?: Resolver<ResolversTypes['Year'], ParentType, ContextType>;
};

export type IntellectualPropertyResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntellectualProperty'] = ResolversParentTypes['IntellectualProperty']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  domain?: Resolver<ResolversTypes['DomainSimple'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tasks?: Resolver<Maybe<Array<ResolversTypes['Task']>>, ParentType, ContextType>;
};

export type IntellectualPropertyMonthReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntellectualPropertyMonthReport'] = ResolversParentTypes['IntellectualPropertyMonthReport']> = {
  ipHours?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  ipPercentage?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  nonCategorizedTimeRecords?: Resolver<Array<ResolversTypes['TimeRecord']>, ParentType, ContextType>;
  nonIPHours?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  timeRecordReports?: Resolver<Array<ResolversTypes['TimeRecordsReport']>, ParentType, ContextType>;
  yearMonth?: Resolver<ResolversTypes['YearMonth'], ParentType, ContextType>;
};

export type IntellectualPropertyReportResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntellectualPropertyReportResponse'] = ResolversParentTypes['IntellectualPropertyReportResponse']> = {
  availableYears?: Resolver<Maybe<Array<ResolversTypes['Year']>>, ParentType, ContextType>;
  report?: Resolver<ResolversTypes['IntellectualPropertiesReport'], ParentType, ContextType>;
  timeRecordCategories?: Resolver<Array<ResolversTypes['TimeRecordCategory']>, ParentType, ContextType>;
};

export type InvoiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Invoice'] = ResolversParentTypes['Invoice']> = {
  __resolveType: TypeResolveFn<'CreditInvoice' | 'DebitInvoice', ParentType, ContextType>;
};

export type LoanResolvers<ContextType = any, ParentType extends ResolversParentTypes['Loan'] = ResolversParentTypes['Loan']> = {
  installments?: Resolver<Array<ResolversTypes['Installment']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  numberOfInstallments?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  paidAmount?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  paymentDate?: Resolver<ResolversTypes['LocalDate'], ParentType, ContextType>;
  publicId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  rateStrategyConfig?: Resolver<ResolversTypes['RateStrategyConfig'], ParentType, ContextType>;
  repaymentDayStrategyConfig?: Resolver<ResolversTypes['RepaymentDayStrategyConfig'], ParentType, ContextType>;
};

export type LoanCalculationInstallmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoanCalculationInstallment'] = ResolversParentTypes['LoanCalculationInstallment']> = {
  installment?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  overpayment?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  paidInterest?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  paymentFrom?: Resolver<ResolversTypes['LocalDate'], ParentType, ContextType>;
  paymentTo?: Resolver<ResolversTypes['LocalDate'], ParentType, ContextType>;
  remainingCapitalAtTheBeginning?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  repaidCapital?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
};

export type LoansResolvers<ContextType = any, ParentType extends ResolversParentTypes['Loans'] = ResolversParentTypes['Loans']> = {
  loans?: Resolver<Array<ResolversTypes['Loan']>, ParentType, ContextType>;
  rateStrategyConfigs?: Resolver<Array<ResolversTypes['RateStrategyConfig']>, ParentType, ContextType>;
  repaymentDayStrategyConfigs?: Resolver<Array<ResolversTypes['RepaymentDayStrategyConfig']>, ParentType, ContextType>;
};

export interface LocalDateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['LocalDate'], any> {
  name: 'LocalDate';
}

export interface LocalDateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['LocalDateTime'], any> {
  name: 'LocalDateTime';
}

export type MfaDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['MFAData'] = ResolversParentTypes['MFAData']> = {
  mfaCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  qrLink?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type MonetaryAmountResolvers<ContextType = any, ParentType extends ResolversParentTypes['MonetaryAmount'] = ResolversParentTypes['MonetaryAmount']> = {
  amount?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['CurrencyInfo'], ParentType, ContextType>;
};

export type MonthSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['MonthSummary'] = ResolversParentTypes['MonthSummary']> = {
  accounts?: Resolver<Array<ResolversTypes['MonthSummaryAccount']>, ParentType, ContextType>;
  piggyBanks?: Resolver<Array<ResolversTypes['MonthSummaryPiggyBank']>, ParentType, ContextType>;
  savings?: Resolver<Array<ResolversTypes['MonthSummarySavings']>, ParentType, ContextType>;
};

export type MonthSummaryAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['MonthSummaryAccount'] = ResolversParentTypes['MonthSummaryAccount']> = {
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  currentBalance?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  lastTransactionIdIncludedInBalance?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publicId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type MonthSummaryPiggyBankResolvers<ContextType = any, ParentType extends ResolversParentTypes['MonthSummaryPiggyBank'] = ResolversParentTypes['MonthSummaryPiggyBank']> = {
  balance?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  monthlyTopUp?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  savings?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type MonthSummarySavingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MonthSummarySavings'] = ResolversParentTypes['MonthSummarySavings']> = {
  amount?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  acceptInvitationToDomain?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationAcceptInvitationToDomainArgs, 'domainInvitationResponseInput'>>;
  addIPR?: Resolver<Maybe<ResolversTypes['IntellectualProperty']>, ParentType, ContextType, Partial<MutationAddIprArgs>>;
  addRevenueAndExpenseEntry?: Resolver<Maybe<ResolversTypes['RevenueAndExpenseEntry']>, ParentType, ContextType, Partial<MutationAddRevenueAndExpenseEntryArgs>>;
  assignBankAccountToAccount?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationAssignBankAccountToAccountArgs, 'assignBankAccountToAccountInput'>>;
  assignCategoryToTimeRecord?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationAssignCategoryToTimeRecordArgs, 'timeRecordId'>>;
  confirmPermission?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationConfirmPermissionArgs, 'confirmPermissionRequest'>>;
  createAccount?: Resolver<ResolversTypes['Account'], ParentType, ContextType, RequireFields<MutationCreateAccountArgs, 'accountCreationInput'>>;
  createBill?: Resolver<ResolversTypes['FinancialDocument'], ParentType, ContextType, RequireFields<MutationCreateBillArgs, 'billCreationInput'>>;
  createBillingCategory?: Resolver<ResolversTypes['BillingCategory'], ParentType, ContextType, RequireFields<MutationCreateBillingCategoryArgs, 'billingCategoryCreationInput'>>;
  createBillingPeriod?: Resolver<ResolversTypes['BillingPeriod'], ParentType, ContextType, RequireFields<MutationCreateBillingPeriodArgs, 'yearMonth'>>;
  createClient?: Resolver<ResolversTypes['Client'], ParentType, ContextType, RequireFields<MutationCreateClientArgs, 'clientCreationInput'>>;
  createConstantForNFirstInstallmentRateStrategyConfig?: Resolver<ResolversTypes['RateStrategyConfig'], ParentType, ContextType, RequireFields<MutationCreateConstantForNFirstInstallmentRateStrategyConfigArgs, 'input'>>;
  createDomain?: Resolver<ResolversTypes['DomainSimple'], ParentType, ContextType, RequireFields<MutationCreateDomainArgs, 'domainCreationInput'>>;
  createExpense?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationCreateExpenseArgs, 'createExpenseInput'>>;
  createIncome?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationCreateIncomeArgs, 'createIncomeInput'>>;
  createInstallment?: Resolver<ResolversTypes['Installment'], ParentType, ContextType, RequireFields<MutationCreateInstallmentArgs, 'input'>>;
  createInvoice?: Resolver<ResolversTypes['Invoice'], ParentType, ContextType, RequireFields<MutationCreateInvoiceArgs, 'invoiceCreationInput'>>;
  createLoan?: Resolver<ResolversTypes['Loan'], ParentType, ContextType, Partial<MutationCreateLoanArgs>>;
  createNthDayOfMonthRepaymentDayStrategyConfig?: Resolver<ResolversTypes['RepaymentDayStrategyConfig'], ParentType, ContextType, RequireFields<MutationCreateNthDayOfMonthRepaymentDayStrategyConfigArgs, 'input'>>;
  createPiggyBank?: Resolver<ResolversTypes['PiggyBank'], ParentType, ContextType, RequireFields<MutationCreatePiggyBankArgs, 'piggyBankCreationInput'>>;
  createSupplier?: Resolver<ResolversTypes['Supplier'], ParentType, ContextType, RequireFields<MutationCreateSupplierArgs, 'supplierCreationInput'>>;
  createTask?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationCreateTaskArgs, 'intellectualPropertyId' | 'taskData'>>;
  createTimeRecord?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationCreateTimeRecordArgs, 'timeRecordData'>>;
  createTimeRecordCategory?: Resolver<ResolversTypes['TimeRecordCategory'], ParentType, ContextType, RequireFields<MutationCreateTimeRecordCategoryArgs, 'name'>>;
  createTransfer?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationCreateTransferArgs, 'createTransferInput'>>;
  deleteAccount?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationDeleteAccountArgs, 'accountPublicId'>>;
  deleteBankAccountAssignment?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationDeleteBankAccountAssignmentArgs, 'deleteBankAccountAssignmentInput'>>;
  deleteBillingCategory?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationDeleteBillingCategoryArgs, 'billingCategoryPublicId'>>;
  deleteClient?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationDeleteClientArgs, 'clientPublicId'>>;
  deleteFinancialDocument?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationDeleteFinancialDocumentArgs, 'financialDocumentPublicId'>>;
  deleteIPR?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationDeleteIprArgs, 'intellectualPropertyId'>>;
  deleteInstallment?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationDeleteInstallmentArgs, 'installmentPublicId'>>;
  deleteLoan?: Resolver<ResolversTypes['String'], ParentType, ContextType, Partial<MutationDeleteLoanArgs>>;
  deletePiggyBank?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationDeletePiggyBankArgs, 'piggyBankPublicId'>>;
  deleteRateStrategyConfig?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationDeleteRateStrategyConfigArgs, 'input'>>;
  deleteRepaymentDayStrategyConfig?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationDeleteRepaymentDayStrategyConfigArgs, 'input'>>;
  deleteSupplier?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationDeleteSupplierArgs, 'supplierPublicId'>>;
  deleteTask?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationDeleteTaskArgs, 'taskId'>>;
  deleteTaskAttachment?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeleteTaskAttachmentArgs, 'input'>>;
  deleteTimeRecord?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationDeleteTimeRecordArgs, 'timeRecordId'>>;
  deleteTimeRecordCategory?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationDeleteTimeRecordCategoryArgs, 'timeRecordId'>>;
  finishBillingPeriod?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationFinishBillingPeriodArgs, 'yearMonth'>>;
  importBankTransactions?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationImportBankTransactionsArgs, 'importBankTransactionsInput'>>;
  inviteUserToDomain?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationInviteUserToDomainArgs, 'domainInvitationInput'>>;
  login?: Resolver<ResolversTypes['AuthenticationInfo'], ParentType, ContextType, RequireFields<MutationLoginArgs, 'loginParameters'>>;
  loginWithGoogleToken?: Resolver<ResolversTypes['AuthenticationInfo'], ParentType, ContextType, RequireFields<MutationLoginWithGoogleTokenArgs, 'loginWithGoogleTokenParameters'>>;
  mutuallyCancel?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationMutuallyCancelArgs, 'mutuallyCancelInput'>>;
  register?: Resolver<ResolversTypes['MFAData'], ParentType, ContextType, RequireFields<MutationRegisterArgs, 'registrationParameters'>>;
  rejectInvitationToDomain?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationRejectInvitationToDomainArgs, 'domainInvitationResponseInput'>>;
  reorderAccount?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationReorderAccountArgs, 'accountReorderInput'>>;
  saveCubeResult?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationSaveCubeResultArgs, 'saveCubeResultInput'>>;
  setUserDomainAccessLevel?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationSetUserDomainAccessLevelArgs, 'domainSetAccessLevelInput'>>;
  setupMFA?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSetupMfaArgs, 'mfaParameters'>>;
  startPermissionRequest?: Resolver<Array<ResolversTypes['BankPermission']>, ParentType, ContextType, RequireFields<MutationStartPermissionRequestArgs, 'bankPermissionRequest'>>;
  strengthTraining?: Resolver<ResolversTypes['StrengthTrainingMutation'], ParentType, ContextType>;
  switchDomain?: Resolver<ResolversTypes['AuthenticationInfo'], ParentType, ContextType, RequireFields<MutationSwitchDomainArgs, 'switchDomainParameters'>>;
  triggerFetchBankAccountData?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationTriggerFetchBankAccountDataArgs, 'fetchBankAccountDataInput'>>;
  triggerTranslatedPJMVersesCheck?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updateAccount?: Resolver<ResolversTypes['Account'], ParentType, ContextType, RequireFields<MutationUpdateAccountArgs, 'accountUpdateInput'>>;
  updateAccountantSettings?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationUpdateAccountantSettingsArgs, 'accountantSettingsUpdateInput'>>;
  updateBill?: Resolver<ResolversTypes['FinancialDocument'], ParentType, ContextType, RequireFields<MutationUpdateBillArgs, 'billUpdateInput'>>;
  updateBillingCategory?: Resolver<ResolversTypes['BillingCategory'], ParentType, ContextType, RequireFields<MutationUpdateBillingCategoryArgs, 'billingCategoryUpdateInput'>>;
  updateClient?: Resolver<ResolversTypes['Client'], ParentType, ContextType, RequireFields<MutationUpdateClientArgs, 'clientUpdateInput'>>;
  updateDomain?: Resolver<ResolversTypes['DomainSimple'], ParentType, ContextType, RequireFields<MutationUpdateDomainArgs, 'domainUpdateInput'>>;
  updateIPR?: Resolver<Maybe<ResolversTypes['IntellectualProperty']>, ParentType, ContextType, RequireFields<MutationUpdateIprArgs, 'intellectualPropertyId'>>;
  updateInvoice?: Resolver<ResolversTypes['Invoice'], ParentType, ContextType, RequireFields<MutationUpdateInvoiceArgs, 'invoiceUpdateInput'>>;
  updateLoan?: Resolver<ResolversTypes['Loan'], ParentType, ContextType, Partial<MutationUpdateLoanArgs>>;
  updatePiggyBank?: Resolver<ResolversTypes['PiggyBank'], ParentType, ContextType, RequireFields<MutationUpdatePiggyBankArgs, 'piggyBankUpdateInput'>>;
  updateSupplier?: Resolver<ResolversTypes['Supplier'], ParentType, ContextType, RequireFields<MutationUpdateSupplierArgs, 'supplierUpdateInput'>>;
  updateTask?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationUpdateTaskArgs, 'taskData' | 'taskId'>>;
  updateTimeRecord?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationUpdateTimeRecordArgs, 'timeRecordData' | 'timeRecordId'>>;
  updateTimeRecordCategory?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationUpdateTimeRecordCategoryArgs, 'name' | 'timeRecordId'>>;
  uploadTaskAttachment?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationUploadTaskAttachmentArgs, 'input'>>;
};

export type NthDayOfMonthRepaymentDayStrategyConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['NthDayOfMonthRepaymentDayStrategyConfig'] = ResolversParentTypes['NthDayOfMonthRepaymentDayStrategyConfig']> = {
  dayOfMonth?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publicId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OtherPartyResolvers<ContextType = any, ParentType extends ResolversParentTypes['OtherParty'] = ResolversParentTypes['OtherParty']> = {
  __resolveType: TypeResolveFn<'Client' | 'Supplier', ParentType, ContextType>;
};

export type PiggyBankResolvers<ContextType = any, ParentType extends ResolversParentTypes['PiggyBank'] = ResolversParentTypes['PiggyBank']> = {
  balance?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  domain?: Resolver<ResolversTypes['DomainSimple'], ParentType, ContextType>;
  monthlyTopUp?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publicId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  savings?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  allClients?: Resolver<Array<ResolversTypes['Client']>, ParentType, ContextType>;
  allSuppliers?: Resolver<Array<ResolversTypes['Supplier']>, ParentType, ContextType>;
  allTimeRecordCategories?: Resolver<Array<ResolversTypes['TimeRecordCategory']>, ParentType, ContextType>;
  bankPermissions?: Resolver<ResolversTypes['BankPermissions'], ParentType, ContextType>;
  bankTransactionsToImport?: Resolver<Array<ResolversTypes['BankTransactionToImport']>, ParentType, ContextType>;
  billingPeriod?: Resolver<ResolversTypes['BillingPeriodResponse'], ParentType, ContextType, Partial<QueryBillingPeriodArgs>>;
  cubeResults?: Resolver<ResolversTypes['CubeResults'], ParentType, ContextType, RequireFields<QueryCubeResultsArgs, 'cubeResultsQuery'>>;
  currentUser?: Resolver<ResolversTypes['CurrentUserProfile'], ParentType, ContextType>;
  domainInvitations?: Resolver<Array<ResolversTypes['DomainSimple']>, ParentType, ContextType>;
  financeManagement?: Resolver<ResolversTypes['FinanceManagement'], ParentType, ContextType>;
  intellectualPropertiesRecords?: Resolver<Maybe<ResolversTypes['IntellectualPropertiesRecordsResponse']>, ParentType, ContextType, RequireFields<QueryIntellectualPropertiesRecordsArgs, 'input'>>;
  intellectualPropertiesReport?: Resolver<Maybe<ResolversTypes['IntellectualPropertyReportResponse']>, ParentType, ContextType, RequireFields<QueryIntellectualPropertiesReportArgs, 'input'>>;
  loans?: Resolver<ResolversTypes['Loans'], ParentType, ContextType>;
  monthFinancialDocuments?: Resolver<Array<ResolversTypes['FinancialDocument']>, ParentType, ContextType, RequireFields<QueryMonthFinancialDocumentsArgs, 'yearMonth'>>;
  monthLedger?: Resolver<Array<ResolversTypes['RevenueAndExpenseEntry']>, ParentType, ContextType, Partial<QueryMonthLedgerArgs>>;
  settings?: Resolver<ResolversTypes['Settings'], ParentType, ContextType>;
  simulateExistingLoan?: Resolver<Array<ResolversTypes['LoanCalculationInstallment']>, ParentType, ContextType, Partial<QuerySimulateExistingLoanArgs>>;
  simulateLoan?: Resolver<Array<ResolversTypes['LoanCalculationInstallment']>, ParentType, ContextType, Partial<QuerySimulateLoanArgs>>;
  singleLoan?: Resolver<ResolversTypes['Loan'], ParentType, ContextType, Partial<QuerySingleLoanArgs>>;
  strengthTraining?: Resolver<ResolversTypes['StrengthTrainingQuery'], ParentType, ContextType>;
  tasks?: Resolver<ResolversTypes['TasksResponse'], ParentType, ContextType, RequireFields<QueryTasksArgs, 'input'>>;
  timeRecords?: Resolver<ResolversTypes['TimeRecordsResponse'], ParentType, ContextType, RequireFields<QueryTimeRecordsArgs, 'input'>>;
};

export type RateStrategyConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['RateStrategyConfig'] = ResolversParentTypes['RateStrategyConfig']> = {
  __resolveType: TypeResolveFn<'ConstantForNFirstInstallmentRateStrategyConfig', ParentType, ContextType>;
};

export type RepaymentDayStrategyConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['RepaymentDayStrategyConfig'] = ResolversParentTypes['RepaymentDayStrategyConfig']> = {
  __resolveType: TypeResolveFn<'NthDayOfMonthRepaymentDayStrategyConfig', ParentType, ContextType>;
};

export type RevenueAndExpenseEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['RevenueAndExpenseEntry'] = ResolversParentTypes['RevenueAndExpenseEntry']> = {
  accountingDocumentNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  additionalCostOfPurchase?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  comments?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  counterparty?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  counterpartyAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  domain?: Resolver<ResolversTypes['DomainSimple'], ParentType, ContextType>;
  entryDate?: Resolver<ResolversTypes['LocalDate'], ParentType, ContextType>;
  entryOrder?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  otherExpense?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  otherIncome?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  providedGoodsAndServicesValue?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  publicId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  purchasedGoodsAndMaterialsValue?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  remunerationInCashOrInKind?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  totalExpense?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  totalIncome?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
};

export type SettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Settings'] = ResolversParentTypes['Settings']> = {
  accountantSettings?: Resolver<ResolversTypes['AccountantSettings'], ParentType, ContextType>;
  domains?: Resolver<Array<ResolversTypes['Domain']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type StrengthTrainingExerciseFamilyResolvers<ContextType = any, ParentType extends ResolversParentTypes['StrengthTrainingExerciseFamily'] = ResolversParentTypes['StrengthTrainingExerciseFamily']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  dimensions?: Resolver<Array<ResolversTypes['StrengthTrainingExerciseFamilyDimension']>, ParentType, ContextType>;
  exerciseType?: Resolver<ResolversTypes['StrengthTrainingExerciseType'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publicId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  scope?: Resolver<ResolversTypes['StrengthTrainingCatalogScope'], ParentType, ContextType>;
};

export type StrengthTrainingExerciseFamilyDimensionResolvers<ContextType = any, ParentType extends ResolversParentTypes['StrengthTrainingExerciseFamilyDimension'] = ResolversParentTypes['StrengthTrainingExerciseFamilyDimension']> = {
  allowedValues?: Resolver<Array<ResolversTypes['StrengthTrainingExerciseFamilyVariantValue']>, ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  publicId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  required?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  scope?: Resolver<ResolversTypes['StrengthTrainingCatalogScope'], ParentType, ContextType>;
  variantDimension?: Resolver<ResolversTypes['StrengthTrainingVariantDimension'], ParentType, ContextType>;
};

export type StrengthTrainingExerciseFamilyVariantValueResolvers<ContextType = any, ParentType extends ResolversParentTypes['StrengthTrainingExerciseFamilyVariantValue'] = ResolversParentTypes['StrengthTrainingExerciseFamilyVariantValue']> = {
  defaultValue?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  publicId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  scope?: Resolver<ResolversTypes['StrengthTrainingCatalogScope'], ParentType, ContextType>;
  variantValue?: Resolver<ResolversTypes['StrengthTrainingVariantValue'], ParentType, ContextType>;
};

export type StrengthTrainingMutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['StrengthTrainingMutation'] = ResolversParentTypes['StrengthTrainingMutation']> = {
  assignDimensionToFamily?: Resolver<ResolversTypes['StrengthTrainingExerciseFamilyDimension'], ParentType, ContextType, RequireFields<StrengthTrainingMutationAssignDimensionToFamilyArgs, 'input'>>;
  createExerciseFamily?: Resolver<ResolversTypes['StrengthTrainingExerciseFamily'], ParentType, ContextType, RequireFields<StrengthTrainingMutationCreateExerciseFamilyArgs, 'input'>>;
  createVariantDimension?: Resolver<ResolversTypes['StrengthTrainingVariantDimension'], ParentType, ContextType, RequireFields<StrengthTrainingMutationCreateVariantDimensionArgs, 'input'>>;
  createVariantValue?: Resolver<ResolversTypes['StrengthTrainingVariantValue'], ParentType, ContextType, RequireFields<StrengthTrainingMutationCreateVariantValueArgs, 'input'>>;
  setAllowedVariantValues?: Resolver<Array<ResolversTypes['StrengthTrainingExerciseFamilyVariantValue']>, ParentType, ContextType, RequireFields<StrengthTrainingMutationSetAllowedVariantValuesArgs, 'input'>>;
};

export type StrengthTrainingQueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['StrengthTrainingQuery'] = ResolversParentTypes['StrengthTrainingQuery']> = {
  exerciseFamilies?: Resolver<Array<ResolversTypes['StrengthTrainingExerciseFamily']>, ParentType, ContextType, Partial<StrengthTrainingQueryExerciseFamiliesArgs>>;
  variantDimensions?: Resolver<Array<ResolversTypes['StrengthTrainingVariantDimension']>, ParentType, ContextType, Partial<StrengthTrainingQueryVariantDimensionsArgs>>;
};

export type StrengthTrainingVariantDimensionResolvers<ContextType = any, ParentType extends ResolversParentTypes['StrengthTrainingVariantDimension'] = ResolversParentTypes['StrengthTrainingVariantDimension']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publicId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  scope?: Resolver<ResolversTypes['StrengthTrainingCatalogScope'], ParentType, ContextType>;
  values?: Resolver<Array<ResolversTypes['StrengthTrainingVariantValue']>, ParentType, ContextType>;
};

export type StrengthTrainingVariantValueResolvers<ContextType = any, ParentType extends ResolversParentTypes['StrengthTrainingVariantValue'] = ResolversParentTypes['StrengthTrainingVariantValue']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publicId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  scope?: Resolver<ResolversTypes['StrengthTrainingCatalogScope'], ParentType, ContextType>;
};

export type SupplierResolvers<ContextType = any, ParentType extends ResolversParentTypes['Supplier'] = ResolversParentTypes['Supplier']> = {
  domain?: Resolver<ResolversTypes['DomainSimple'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publicId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskResolvers<ContextType = any, ParentType extends ResolversParentTypes['Task'] = ResolversParentTypes['Task']> = {
  attachments?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  coAuthors?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  timeRecords?: Resolver<Maybe<Array<ResolversTypes['TimeRecord']>>, ParentType, ContextType>;
};

export type TasksResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TasksResponse'] = ResolversParentTypes['TasksResponse']> = {
  tasks?: Resolver<Array<ResolversTypes['Task']>, ParentType, ContextType>;
};

export type TimeRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['TimeRecord'] = ResolversParentTypes['TimeRecord']> = {
  date?: Resolver<ResolversTypes['LocalDate'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  domain?: Resolver<ResolversTypes['DomainSimple'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  numberOfHours?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  timeRecordCategory?: Resolver<Maybe<ResolversTypes['TimeRecordCategory']>, ParentType, ContextType>;
};

export type TimeRecordCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['TimeRecordCategory'] = ResolversParentTypes['TimeRecordCategory']> = {
  domain?: Resolver<ResolversTypes['DomainSimple'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type TimeRecordsReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['TimeRecordsReport'] = ResolversParentTypes['TimeRecordsReport']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ipHours?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
  nonIPHours?: Resolver<ResolversTypes['BigDecimal'], ParentType, ContextType>;
};

export type TimeRecordsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TimeRecordsResponse'] = ResolversParentTypes['TimeRecordsResponse']> = {
  nonIPTimeRecords?: Resolver<Array<ResolversTypes['TimeRecord']>, ParentType, ContextType>;
  stats?: Resolver<ResolversTypes['TimeRecordsStats'], ParentType, ContextType>;
  taskWithSelectedTimeRecords?: Resolver<Array<ResolversTypes['Task']>, ParentType, ContextType>;
};

export type TimeRecordsStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TimeRecordsStats'] = ResolversParentTypes['TimeRecordsStats']> = {
  firstTimeRecord?: Resolver<ResolversTypes['LocalDate'], ParentType, ContextType>;
  lastTimeRecord?: Resolver<ResolversTypes['LocalDate'], ParentType, ContextType>;
};

export interface UrlScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['URL'], any> {
  name: 'URL';
}

export interface UuidScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['UUID'], any> {
  name: 'UUID';
}

export interface UploadScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Upload'], any> {
  name: 'Upload';
}

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  domainPublicId?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  domains?: Resolver<Array<ResolversTypes['DomainSimple']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  login?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  roles?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
};

export interface YearScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Year'], any> {
  name: 'Year';
}

export interface YearMonthScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['YearMonth'], any> {
  name: 'YearMonth';
}

export type Resolvers<ContextType = any> = {
  Account?: AccountResolvers<ContextType>;
  AccountTransaction?: AccountTransactionResolvers<ContextType>;
  AccountantSettings?: AccountantSettingsResolvers<ContextType>;
  AuthenticationInfo?: AuthenticationInfoResolvers<ContextType>;
  BankAccount?: BankAccountResolvers<ContextType>;
  BankPermission?: BankPermissionResolvers<ContextType>;
  BankPermissions?: BankPermissionsResolvers<ContextType>;
  BankTransactionToImport?: BankTransactionToImportResolvers<ContextType>;
  BigDecimal?: GraphQLScalarType;
  BillOfPurchase?: BillOfPurchaseResolvers<ContextType>;
  BillOfSale?: BillOfSaleResolvers<ContextType>;
  BillingCategory?: BillingCategoryResolvers<ContextType>;
  BillingCategoryShort?: BillingCategoryShortResolvers<ContextType>;
  BillingPeriod?: BillingPeriodResolvers<ContextType>;
  BillingPeriodCreationBlockers?: BillingPeriodCreationBlockersResolvers<ContextType>;
  BillingPeriodResponse?: BillingPeriodResponseResolvers<ContextType>;
  Client?: ClientResolvers<ContextType>;
  ConstantForNFirstInstallmentRateStrategyConfig?: ConstantForNFirstInstallmentRateStrategyConfigResolvers<ContextType>;
  CreditInvoice?: CreditInvoiceResolvers<ContextType>;
  CubeDayStats?: CubeDayStatsResolvers<ContextType>;
  CubeResult?: CubeResultResolvers<ContextType>;
  CubeResults?: CubeResultsResolvers<ContextType>;
  Currency?: GraphQLScalarType;
  CurrencyInfo?: CurrencyInfoResolvers<ContextType>;
  CurrentUserProfile?: CurrentUserProfileResolvers<ContextType>;
  DebitInvoice?: DebitInvoiceResolvers<ContextType>;
  Domain?: DomainResolvers<ContextType>;
  DomainSimple?: DomainSimpleResolvers<ContextType>;
  DomainUser?: DomainUserResolvers<ContextType>;
  Expense?: ExpenseResolvers<ContextType>;
  FinanceManagement?: FinanceManagementResolvers<ContextType>;
  FinancialDocument?: FinancialDocumentResolvers<ContextType>;
  Income?: IncomeResolvers<ContextType>;
  Installment?: InstallmentResolvers<ContextType>;
  Institution?: InstitutionResolvers<ContextType>;
  IntellectualPropertiesRecordsResponse?: IntellectualPropertiesRecordsResponseResolvers<ContextType>;
  IntellectualPropertiesReport?: IntellectualPropertiesReportResolvers<ContextType>;
  IntellectualProperty?: IntellectualPropertyResolvers<ContextType>;
  IntellectualPropertyMonthReport?: IntellectualPropertyMonthReportResolvers<ContextType>;
  IntellectualPropertyReportResponse?: IntellectualPropertyReportResponseResolvers<ContextType>;
  Invoice?: InvoiceResolvers<ContextType>;
  Loan?: LoanResolvers<ContextType>;
  LoanCalculationInstallment?: LoanCalculationInstallmentResolvers<ContextType>;
  Loans?: LoansResolvers<ContextType>;
  LocalDate?: GraphQLScalarType;
  LocalDateTime?: GraphQLScalarType;
  MFAData?: MfaDataResolvers<ContextType>;
  MonetaryAmount?: MonetaryAmountResolvers<ContextType>;
  MonthSummary?: MonthSummaryResolvers<ContextType>;
  MonthSummaryAccount?: MonthSummaryAccountResolvers<ContextType>;
  MonthSummaryPiggyBank?: MonthSummaryPiggyBankResolvers<ContextType>;
  MonthSummarySavings?: MonthSummarySavingsResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  NthDayOfMonthRepaymentDayStrategyConfig?: NthDayOfMonthRepaymentDayStrategyConfigResolvers<ContextType>;
  OtherParty?: OtherPartyResolvers<ContextType>;
  PiggyBank?: PiggyBankResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  RateStrategyConfig?: RateStrategyConfigResolvers<ContextType>;
  RepaymentDayStrategyConfig?: RepaymentDayStrategyConfigResolvers<ContextType>;
  RevenueAndExpenseEntry?: RevenueAndExpenseEntryResolvers<ContextType>;
  Settings?: SettingsResolvers<ContextType>;
  StrengthTrainingExerciseFamily?: StrengthTrainingExerciseFamilyResolvers<ContextType>;
  StrengthTrainingExerciseFamilyDimension?: StrengthTrainingExerciseFamilyDimensionResolvers<ContextType>;
  StrengthTrainingExerciseFamilyVariantValue?: StrengthTrainingExerciseFamilyVariantValueResolvers<ContextType>;
  StrengthTrainingMutation?: StrengthTrainingMutationResolvers<ContextType>;
  StrengthTrainingQuery?: StrengthTrainingQueryResolvers<ContextType>;
  StrengthTrainingVariantDimension?: StrengthTrainingVariantDimensionResolvers<ContextType>;
  StrengthTrainingVariantValue?: StrengthTrainingVariantValueResolvers<ContextType>;
  Supplier?: SupplierResolvers<ContextType>;
  Task?: TaskResolvers<ContextType>;
  TasksResponse?: TasksResponseResolvers<ContextType>;
  TimeRecord?: TimeRecordResolvers<ContextType>;
  TimeRecordCategory?: TimeRecordCategoryResolvers<ContextType>;
  TimeRecordsReport?: TimeRecordsReportResolvers<ContextType>;
  TimeRecordsResponse?: TimeRecordsResponseResolvers<ContextType>;
  TimeRecordsStats?: TimeRecordsStatsResolvers<ContextType>;
  URL?: GraphQLScalarType;
  UUID?: GraphQLScalarType;
  Upload?: GraphQLScalarType;
  User?: UserResolvers<ContextType>;
  Year?: GraphQLScalarType;
  YearMonth?: GraphQLScalarType;
};


export type GetFinanceManagementWithNotAssignedBankAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFinanceManagementWithNotAssignedBankAccountsQuery = { __typename?: 'Query', financeManagement: { __typename?: 'FinanceManagement', id: string, supportedCurrencies: Array<{ __typename?: 'CurrencyInfo', code: string, description: string }>, accounts: Array<{ __typename?: 'Account', publicId: string, order: number, name: string, balanceIndex?: number | null, visible: boolean, currentBalance: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, creditLimit: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, bankAccount?: { __typename?: 'BankAccount', publicId: string, iban: string } | null, domain?: { __typename?: 'DomainSimple', publicId: string, name: string } | null }>, billingCategories: Array<{ __typename?: 'BillingCategory', publicId: string, name: string, description: string, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }>, piggyBanks: Array<{ __typename?: 'PiggyBank', publicId: string, name: string, description: string, savings: boolean, balance: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, monthlyTopUp: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }> }, bankPermissions: { __typename?: 'BankPermissions', bankAccountsNotAssignedToAccount: Array<{ __typename?: 'BankAccount', publicId: string, iban: string }> } };

export type CreateAccountMutationVariables = Exact<{
  name: Scalars['String']['input'];
  balanceIndex?: InputMaybe<Scalars['Int']['input']>;
  bankAccountPublicId?: InputMaybe<Scalars['UUID']['input']>;
  visible: Scalars['Boolean']['input'];
  creditLimitAmount: Scalars['BigDecimal']['input'];
  creditLimitCurrency: Scalars['Currency']['input'];
}>;


export type CreateAccountMutation = { __typename?: 'Mutation', createAccount: { __typename?: 'Account', publicId: string, order: number, name: string, balanceIndex?: number | null, visible: boolean, currentBalance: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, creditLimit: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, bankAccount?: { __typename?: 'BankAccount', publicId: string, iban: string } | null, domain?: { __typename?: 'DomainSimple', publicId: string, name: string } | null } };

export type UpdateAccountMutationVariables = Exact<{
  publicId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  balanceIndex?: InputMaybe<Scalars['Int']['input']>;
  bankAccountPublicId?: InputMaybe<Scalars['UUID']['input']>;
  visible: Scalars['Boolean']['input'];
  creditLimitAmount: Scalars['BigDecimal']['input'];
  creditLimitCurrency: Scalars['Currency']['input'];
}>;


export type UpdateAccountMutation = { __typename?: 'Mutation', updateAccount: { __typename?: 'Account', publicId: string, order: number, name: string, balanceIndex?: number | null, visible: boolean, currentBalance: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, creditLimit: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, bankAccount?: { __typename?: 'BankAccount', publicId: string, iban: string } | null, domain?: { __typename?: 'DomainSimple', publicId: string, name: string } | null } };

export type DeleteAccountMutationVariables = Exact<{
  publicId: Scalars['UUID']['input'];
}>;


export type DeleteAccountMutation = { __typename?: 'Mutation', deleteAccount: string };

export type ReorderAccountMutationVariables = Exact<{
  accountPublicId: Scalars['UUID']['input'];
  accountBeforePublicId?: InputMaybe<Scalars['UUID']['input']>;
  accountAfterPublicId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type ReorderAccountMutation = { __typename?: 'Mutation', reorderAccount: string };

export type AssignBankAccountToAccountMutationVariables = Exact<{
  bankAccountPublicId: Scalars['UUID']['input'];
  accountPublicId: Scalars['UUID']['input'];
}>;


export type AssignBankAccountToAccountMutation = { __typename?: 'Mutation', assignBankAccountToAccount: string };

export type DeleteBankAccountAssignmentMutationVariables = Exact<{
  accountPublicId: Scalars['UUID']['input'];
}>;


export type DeleteBankAccountAssignmentMutation = { __typename?: 'Mutation', deleteBankAccountAssignment: string };

export type AccountTransactionShortFragment = { __typename?: 'AccountTransaction', publicId: string, description: string, timeOfTransaction: string, debit?: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', description: string, code: string } } | null, credit?: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', description: string, code: string } } | null, destination?: { __typename?: 'Account', publicId: string } | null, source?: { __typename?: 'Account', publicId: string } | null };

export type GetAccountTransactionsQueryVariables = Exact<{
  publicId?: InputMaybe<Scalars['UUID']['input']>;
  yearMonth?: InputMaybe<Scalars['YearMonth']['input']>;
}>;


export type GetAccountTransactionsQuery = { __typename?: 'Query', financeManagement: { __typename?: 'FinanceManagement', id: string, accounts: Array<{ __typename?: 'Account', transactions: Array<{ __typename?: 'AccountTransaction', publicId: string, description: string, timeOfTransaction: string, debit?: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', description: string, code: string } } | null, credit?: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', description: string, code: string } } | null, destination?: { __typename?: 'Account', publicId: string } | null, source?: { __typename?: 'Account', publicId: string } | null }> }> } };

export type GetFinanceManagementQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFinanceManagementQuery = { __typename?: 'Query', financeManagement: { __typename?: 'FinanceManagement', id: string, supportedCurrencies: Array<{ __typename?: 'CurrencyInfo', code: string, description: string }>, accounts: Array<{ __typename?: 'Account', publicId: string, order: number, name: string, balanceIndex?: number | null, visible: boolean, currentBalance: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, creditLimit: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, bankAccount?: { __typename?: 'BankAccount', publicId: string, iban: string } | null, domain?: { __typename?: 'DomainSimple', publicId: string, name: string } | null }>, billingCategories: Array<{ __typename?: 'BillingCategory', publicId: string, name: string, description: string, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }>, piggyBanks: Array<{ __typename?: 'PiggyBank', publicId: string, name: string, description: string, savings: boolean, balance: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, monthlyTopUp: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }> } };

export type BillingPeriodQueryQueryVariables = Exact<{
  yearMonth?: InputMaybe<Scalars['YearMonth']['input']>;
}>;


export type BillingPeriodQueryQuery = { __typename?: 'Query', billingPeriod: { __typename?: 'BillingPeriodResponse', billingPeriod?: { __typename?: 'BillingPeriod', publicId: string, name: string, period: string, incomes: Array<{ __typename?: 'Income', publicId: string, description: string, amount: number, currency: string, date: string, category: { __typename?: 'BillingCategoryShort', name: string, description: string } }>, expenses: Array<{ __typename?: 'Expense', publicId: string, description: string, amount: number, currency: string, date: string, category: { __typename?: 'BillingCategoryShort', name: string, description: string } }>, monthSummary?: { __typename?: 'MonthSummary', savings: Array<{ __typename?: 'MonthSummarySavings', amount: number, currency: string }>, accounts: Array<{ __typename?: 'MonthSummaryAccount', publicId: string, name: string, currency: string, currentBalance: number, lastTransactionIdIncludedInBalance: number }>, piggyBanks: Array<{ __typename?: 'MonthSummaryPiggyBank', name: string, description: string, balance: number, currency: string, savings: boolean, monthlyTopUp: number }> } | null } | null, creationBlockers: { __typename?: 'BillingPeriodCreationBlockers', alreadyExists: boolean, notForCurrentMonth: boolean, unfinishedBillingPeriods: boolean } } };

export type CreateBillingPeriodMutationVariables = Exact<{
  yearMonth: Scalars['YearMonth']['input'];
}>;


export type CreateBillingPeriodMutation = { __typename?: 'Mutation', createBillingPeriod: { __typename?: 'BillingPeriod', publicId: string, name: string, period: string, incomes: Array<{ __typename?: 'Income', publicId: string, description: string, amount: number, currency: string, date: string, category: { __typename?: 'BillingCategoryShort', name: string, description: string } }>, expenses: Array<{ __typename?: 'Expense', publicId: string, description: string, amount: number, currency: string, date: string, category: { __typename?: 'BillingCategoryShort', name: string, description: string } }>, monthSummary?: { __typename?: 'MonthSummary', savings: Array<{ __typename?: 'MonthSummarySavings', amount: number, currency: string }>, accounts: Array<{ __typename?: 'MonthSummaryAccount', publicId: string, name: string, currency: string, currentBalance: number, lastTransactionIdIncludedInBalance: number }>, piggyBanks: Array<{ __typename?: 'MonthSummaryPiggyBank', name: string, description: string, balance: number, currency: string, savings: boolean, monthlyTopUp: number }> } | null } };

export type FinishBillingPeriodMutationVariables = Exact<{
  yearMonth: Scalars['YearMonth']['input'];
}>;


export type FinishBillingPeriodMutation = { __typename?: 'Mutation', finishBillingPeriod: string };

export type CreateIncomeMutationVariables = Exact<{
  accountPublicId: Scalars['UUID']['input'];
  description: Scalars['String']['input'];
  amount: Scalars['BigDecimal']['input'];
  currency: Scalars['Currency']['input'];
  categoryPublicId: Scalars['UUID']['input'];
  date: Scalars['LocalDate']['input'];
  piggyBankPublicId?: InputMaybe<Scalars['UUID']['input']>;
  bankTransactionPublicIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type CreateIncomeMutation = { __typename?: 'Mutation', createIncome: string };

export type CreateExpenseMutationVariables = Exact<{
  accountPublicId: Scalars['UUID']['input'];
  description: Scalars['String']['input'];
  amount: Scalars['BigDecimal']['input'];
  currency: Scalars['Currency']['input'];
  categoryPublicId: Scalars['UUID']['input'];
  date: Scalars['LocalDate']['input'];
  piggyBankPublicId?: InputMaybe<Scalars['UUID']['input']>;
  bankTransactionPublicIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type CreateExpenseMutation = { __typename?: 'Mutation', createExpense: string };

export type CreateTransferMutationVariables = Exact<{
  fromAccountPublicId: Scalars['UUID']['input'];
  toAccountPublicId: Scalars['UUID']['input'];
  fromAmount: Scalars['BigDecimal']['input'];
  toAmount: Scalars['BigDecimal']['input'];
  description: Scalars['String']['input'];
  date: Scalars['LocalDate']['input'];
  bankTransactionPublicIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type CreateTransferMutation = { __typename?: 'Mutation', createTransfer: string };

export type MutuallyCancelMutationVariables = Exact<{
  transactionsPublicId: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type MutuallyCancelMutation = { __typename?: 'Mutation', mutuallyCancel: string };

export type BankTransactionsToImportQueryVariables = Exact<{ [key: string]: never; }>;


export type BankTransactionsToImportQuery = { __typename?: 'Query', bankTransactionsToImport: Array<{ __typename?: 'BankTransactionToImport', id: number, conversionRate: number, credit: number, debit: number, description: string, timeOfTransaction: string, destinationAccountPublicId?: string | null, sourceAccountPublicId?: string | null, creditBankAccountPublicId?: string | null, debitBankAccountPublicId?: string | null, transactionPublicId: string, creditTransactionPublicId?: string | null, debitTransactionPublicId?: string | null }>, financeManagement: { __typename?: 'FinanceManagement', id: string, accounts: Array<{ __typename?: 'Account', publicId: string, order: number, name: string, balanceIndex?: number | null, visible: boolean, currentBalance: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, creditLimit: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, bankAccount?: { __typename?: 'BankAccount', publicId: string, iban: string } | null, domain?: { __typename?: 'DomainSimple', publicId: string, name: string } | null }>, billingCategories: Array<{ __typename?: 'BillingCategory', publicId: string, name: string, description: string, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }>, piggyBanks: Array<{ __typename?: 'PiggyBank', publicId: string, name: string, description: string, savings: boolean, balance: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, monthlyTopUp: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }> } };

export type ImportBankTransactionsMutationVariables = Exact<{
  bankTransactionPublicIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  expenses: Array<CreateBillingElementInput> | CreateBillingElementInput;
  incomes: Array<CreateBillingElementInput> | CreateBillingElementInput;
  transfers: Array<CreateTransferInput> | CreateTransferInput;
}>;


export type ImportBankTransactionsMutation = { __typename?: 'Mutation', importBankTransactions: string };

export type GetAvailableInstitutionsQueryVariables = Exact<{
  country: Scalars['String']['input'];
}>;


export type GetAvailableInstitutionsQuery = { __typename?: 'Query', bankPermissions: { __typename?: 'BankPermissions', availableInstitutions: Array<{ __typename?: 'Institution', id: string, name: string, bic: string, transactionTotalDays: number, countries?: Array<string | null> | null, logo: string }> } };

export type GetBankPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBankPermissionsQuery = { __typename?: 'Query', bankPermissions: { __typename?: 'BankPermissions', granted: Array<{ __typename?: 'BankPermission', publicId: string, createdAt: string, givenAt?: string | null, withdrawnAt?: string | null, institutionId: string, reference?: string | null, ssn?: string | null, confirmationLink?: string | null, requisitionId: string, bankAccounts: Array<{ __typename?: 'BankAccount', publicId: string, iban: string }>, institution?: { __typename?: 'Institution', id: string, name: string, bic: string, transactionTotalDays: number, countries?: Array<string | null> | null, logo: string } | null }>, toProcess: Array<{ __typename?: 'BankPermission', publicId: string, createdAt: string, givenAt?: string | null, withdrawnAt?: string | null, institutionId: string, reference?: string | null, ssn?: string | null, confirmationLink?: string | null, requisitionId: string, bankAccounts: Array<{ __typename?: 'BankAccount', publicId: string, iban: string }>, institution?: { __typename?: 'Institution', id: string, name: string, bic: string, transactionTotalDays: number, countries?: Array<string | null> | null, logo: string } | null }>, toRecreate: Array<{ __typename?: 'Institution', id: string, name: string, bic: string, transactionTotalDays: number, countries?: Array<string | null> | null, logo: string }> } };

export type StartPermissionRequestMutationVariables = Exact<{
  institutionId: Scalars['String']['input'];
  maxHistoricalDays: Scalars['Int']['input'];
  redirect: Scalars['URL']['input'];
  userLanguage: Scalars['String']['input'];
}>;


export type StartPermissionRequestMutation = { __typename?: 'Mutation', startPermissionRequest: Array<{ __typename?: 'BankPermission', publicId: string, createdAt: string, givenAt?: string | null, withdrawnAt?: string | null, institutionId: string, reference?: string | null, ssn?: string | null, confirmationLink?: string | null, requisitionId: string, bankAccounts: Array<{ __typename?: 'BankAccount', publicId: string, iban: string }> }> };

export type ConfirmPermissionMutationVariables = Exact<{
  reference: Scalars['String']['input'];
}>;


export type ConfirmPermissionMutation = { __typename?: 'Mutation', confirmPermission: string };

export type TriggerFetchBankAccountDataMutationVariables = Exact<{
  bankAccountPublicId: Scalars['UUID']['input'];
}>;


export type TriggerFetchBankAccountDataMutation = { __typename?: 'Mutation', triggerFetchBankAccountData: string };

export type CreateBillingCategoryMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
}>;


export type CreateBillingCategoryMutation = { __typename?: 'Mutation', createBillingCategory: { __typename?: 'BillingCategory', publicId: string, name: string, description: string, domain: { __typename?: 'DomainSimple', publicId: string, name: string } } };

export type UpdateBillingCategoryMutationVariables = Exact<{
  publicId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
}>;


export type UpdateBillingCategoryMutation = { __typename?: 'Mutation', updateBillingCategory: { __typename?: 'BillingCategory', publicId: string, name: string, description: string, domain: { __typename?: 'DomainSimple', publicId: string, name: string } } };

export type DeleteBillingCategoryMutationVariables = Exact<{
  publicId: Scalars['UUID']['input'];
}>;


export type DeleteBillingCategoryMutation = { __typename?: 'Mutation', deleteBillingCategory: string };

export type GetAllClientsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllClientsQuery = { __typename?: 'Query', allClients: Array<{ __typename?: 'Client', publicId: string, name: string, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }> };

export type GetAllSuppliersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSuppliersQuery = { __typename?: 'Query', allSuppliers: Array<{ __typename?: 'Supplier', publicId: string, name: string, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }> };

export type MonthFinancialDocumentsQueryVariables = Exact<{
  yearMonth: Scalars['YearMonth']['input'];
}>;


export type MonthFinancialDocumentsQuery = { __typename?: 'Query', monthFinancialDocuments: Array<
    | { __typename?: 'BillOfPurchase', publicId: string, name: string, createdAt: string, description: string, otherParty: { __typename?: 'Supplier', publicId: string, name: string, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }, amount: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }
    | { __typename?: 'BillOfSale', publicId: string, name: string, createdAt: string, description: string, otherParty: { __typename?: 'Client', publicId: string, name: string, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }, amount: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }
    | { __typename?: 'CreditInvoice', publicId: string, name: string, createdAt: string, description: string, otherParty: { __typename?: 'Client', publicId: string, name: string, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }, amount: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }
    | { __typename?: 'DebitInvoice', publicId: string, name: string, createdAt: string, description: string, otherParty: { __typename?: 'Supplier', publicId: string, name: string, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }, amount: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }
  > };

export type CreateClientMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateClientMutation = { __typename?: 'Mutation', createClient: { __typename?: 'Client', publicId: string, name: string, domain: { __typename?: 'DomainSimple', publicId: string, name: string } } };

export type UpdateClientMutationVariables = Exact<{
  publicId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateClientMutation = { __typename?: 'Mutation', updateClient: { __typename?: 'Client', publicId: string, name: string, domain: { __typename?: 'DomainSimple', publicId: string, name: string } } };

export type DeleteClientMutationVariables = Exact<{
  clientPublicId: Scalars['UUID']['input'];
}>;


export type DeleteClientMutation = { __typename?: 'Mutation', deleteClient: string };

export type CreateSupplierMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateSupplierMutation = { __typename?: 'Mutation', createSupplier: { __typename?: 'Supplier', publicId: string, name: string, domain: { __typename?: 'DomainSimple', publicId: string, name: string } } };

export type UpdateSupplierMutationVariables = Exact<{
  publicId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateSupplierMutation = { __typename?: 'Mutation', updateSupplier: { __typename?: 'Supplier', publicId: string, name: string, domain: { __typename?: 'DomainSimple', publicId: string, name: string } } };

export type DeleteSupplierMutationVariables = Exact<{
  supplierPublicId: Scalars['UUID']['input'];
}>;


export type DeleteSupplierMutation = { __typename?: 'Mutation', deleteSupplier: string };

export type CreateBillMutationVariables = Exact<{
  createdAt: Scalars['LocalDate']['input'];
  otherPartyId: Scalars['UUID']['input'];
  billType: BillType;
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  amount: Scalars['BigDecimal']['input'];
  currency: Scalars['Currency']['input'];
}>;


export type CreateBillMutation = { __typename?: 'Mutation', createBill:
    | { __typename?: 'BillOfPurchase', publicId: string, name: string, createdAt: string, description: string, otherParty: { __typename?: 'Supplier', publicId: string, name: string, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }, amount: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }
    | { __typename?: 'BillOfSale', publicId: string, name: string, createdAt: string, description: string, otherParty: { __typename?: 'Client', publicId: string, name: string, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }, amount: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }
    | { __typename?: 'CreditInvoice', publicId: string, name: string, createdAt: string, description: string, otherParty: { __typename?: 'Client', publicId: string, name: string, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }, amount: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }
    | { __typename?: 'DebitInvoice', publicId: string, name: string, createdAt: string, description: string, otherParty: { __typename?: 'Supplier', publicId: string, name: string, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }, amount: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }
   };

export type UpdateBillMutationVariables = Exact<{
  billPublicId: Scalars['UUID']['input'];
  createdAt: Scalars['LocalDate']['input'];
  otherPartyId: Scalars['UUID']['input'];
  billType: BillType;
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  amount: Scalars['BigDecimal']['input'];
  currency: Scalars['Currency']['input'];
}>;


export type UpdateBillMutation = { __typename?: 'Mutation', updateBill:
    | { __typename?: 'BillOfPurchase', publicId: string, name: string, createdAt: string, description: string, otherParty: { __typename?: 'Supplier', publicId: string, name: string, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }, amount: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }
    | { __typename?: 'BillOfSale', publicId: string, name: string, createdAt: string, description: string, otherParty: { __typename?: 'Client', publicId: string, name: string, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }, amount: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }
    | { __typename?: 'CreditInvoice', publicId: string, name: string, createdAt: string, description: string, otherParty: { __typename?: 'Client', publicId: string, name: string, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }, amount: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }
    | { __typename?: 'DebitInvoice', publicId: string, name: string, createdAt: string, description: string, otherParty: { __typename?: 'Supplier', publicId: string, name: string, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }, amount: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }
   };

export type CreateInvoiceMutationVariables = Exact<{
  createdAt: Scalars['LocalDate']['input'];
  dueTo: Scalars['LocalDate']['input'];
  otherPartyId: Scalars['UUID']['input'];
  invoiceType: InvoiceType;
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  amount: Scalars['BigDecimal']['input'];
  vat: Scalars['BigDecimal']['input'];
  currency: Scalars['Currency']['input'];
}>;


export type CreateInvoiceMutation = { __typename?: 'Mutation', createInvoice:
    | { __typename?: 'CreditInvoice', publicId: string, name: string, createdAt: string, dueTo: string, description: string, otherParty: { __typename?: 'Client', publicId: string, name: string, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }, amount: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, vat: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }
    | { __typename?: 'DebitInvoice', publicId: string, name: string, createdAt: string, dueTo: string, description: string, otherParty: { __typename?: 'Supplier', publicId: string, name: string, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }, amount: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, vat: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }
   };

export type UpdateInvoiceMutationVariables = Exact<{
  invoicePublicId: Scalars['UUID']['input'];
  createdAt: Scalars['LocalDate']['input'];
  dueTo: Scalars['LocalDate']['input'];
  otherPartyId: Scalars['UUID']['input'];
  invoiceType: InvoiceType;
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  amount: Scalars['BigDecimal']['input'];
  vat: Scalars['BigDecimal']['input'];
  currency: Scalars['Currency']['input'];
}>;


export type UpdateInvoiceMutation = { __typename?: 'Mutation', updateInvoice:
    | { __typename?: 'CreditInvoice', publicId: string, name: string, createdAt: string, dueTo: string, description: string, otherParty: { __typename?: 'Client', publicId: string, name: string, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }, amount: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, vat: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }
    | { __typename?: 'DebitInvoice', publicId: string, name: string, createdAt: string, dueTo: string, description: string, otherParty: { __typename?: 'Supplier', publicId: string, name: string, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }, amount: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, vat: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }
   };

export type DeleteFinancialDocumentMutationVariables = Exact<{
  financialDocumentPublicId: Scalars['UUID']['input'];
}>;


export type DeleteFinancialDocumentMutation = { __typename?: 'Mutation', deleteFinancialDocument: string };

export type CreatePiggyBankMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  monthlyTopUp: Scalars['BigDecimal']['input'];
  currency: Scalars['Currency']['input'];
  savings: Scalars['Boolean']['input'];
}>;


export type CreatePiggyBankMutation = { __typename?: 'Mutation', createPiggyBank: { __typename?: 'PiggyBank', publicId: string, name: string, description: string, savings: boolean, balance: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, monthlyTopUp: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, domain: { __typename?: 'DomainSimple', publicId: string, name: string } } };

export type UpdatePiggyBankMutationVariables = Exact<{
  publicId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  balance: Scalars['BigDecimal']['input'];
  monthlyTopUp: Scalars['BigDecimal']['input'];
  currency: Scalars['Currency']['input'];
  savings: Scalars['Boolean']['input'];
}>;


export type UpdatePiggyBankMutation = { __typename?: 'Mutation', updatePiggyBank: { __typename?: 'PiggyBank', publicId: string, name: string, description: string, savings: boolean, balance: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, monthlyTopUp: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, domain: { __typename?: 'DomainSimple', publicId: string, name: string } } };

export type DeletePiggyBankMutationVariables = Exact<{
  publicId: Scalars['UUID']['input'];
}>;


export type DeletePiggyBankMutation = { __typename?: 'Mutation', deletePiggyBank: string };

export type GetAccountantSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountantSettingsQuery = { __typename?: 'Query', settings: { __typename?: 'Settings', id: string, accountantSettings: { __typename?: 'AccountantSettings', isCompany: boolean } } };

export type UpdateAccountantSettingsMutationVariables = Exact<{
  isCompany: Scalars['Boolean']['input'];
}>;


export type UpdateAccountantSettingsMutation = { __typename?: 'Mutation', updateAccountantSettings: string };

export type CreateDomainMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateDomainMutation = { __typename?: 'Mutation', createDomain: { __typename?: 'DomainSimple', publicId: string, name: string } };

export type UpdateDomainMutationVariables = Exact<{
  domainPublicId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateDomainMutation = { __typename?: 'Mutation', updateDomain: { __typename?: 'DomainSimple', publicId: string, name: string } };

export type InviteUserToDomainMutationVariables = Exact<{
  domainPublicId: Scalars['UUID']['input'];
  invitedUserLogin: Scalars['String']['input'];
}>;


export type InviteUserToDomainMutation = { __typename?: 'Mutation', inviteUserToDomain: string };

export type AcceptInvitationToDomainMutationVariables = Exact<{
  domainPublicId: Scalars['UUID']['input'];
}>;


export type AcceptInvitationToDomainMutation = { __typename?: 'Mutation', acceptInvitationToDomain: string };

export type RejectInvitationToDomainMutationVariables = Exact<{
  domainPublicId: Scalars['UUID']['input'];
}>;


export type RejectInvitationToDomainMutation = { __typename?: 'Mutation', rejectInvitationToDomain: string };

export type SetUserDomainAccessLevelMutationVariables = Exact<{
  domainPublicId: Scalars['UUID']['input'];
  userLogin: Scalars['String']['input'];
  domainAccessLevel: SetDomainAccessLevel;
}>;


export type SetUserDomainAccessLevelMutation = { __typename?: 'Mutation', setUserDomainAccessLevel: string };

export type DomainsDataQueryVariables = Exact<{ [key: string]: never; }>;


export type DomainsDataQuery = { __typename?: 'Query', domainInvitations: Array<{ __typename?: 'DomainSimple', publicId: string, name: string }>, settings: { __typename?: 'Settings', id: string, domains: Array<{ __typename?: 'Domain', publicId: string, name: string, users: Array<{ __typename?: 'DomainUser', login: string, domainAccessLevel: DomainAccessLevel }> }> } };

export type GetCubeResultsQueryVariables = Exact<{
  cubeType: CubeType;
}>;


export type GetCubeResultsQuery = { __typename?: 'Query', cubeResults: { __typename?: 'CubeResults', todayStats: { __typename?: 'CubeDayStats', min?: number | null, numberOfTries: number }, todayResults: Array<{ __typename?: 'CubeResult', timeInMillis: number, date: string }> } };

export type GetCubeStatsQueryVariables = Exact<{
  cubeType: CubeType;
  month: Scalars['YearMonth']['input'];
}>;


export type GetCubeStatsQuery = { __typename?: 'Query', cubeResults: { __typename?: 'CubeResults', topTenAllTime: Array<{ __typename?: 'CubeResult', timeInMillis: number, date: string }>, stats: Array<{ __typename?: 'CubeDayStats', day: string, min?: number | null, max?: number | null, minAo5?: number | null, minAo30?: number | null, numberOfTries: number }> } };

export type StoreCubeResultMutationVariables = Exact<{
  cubeType: CubeType;
  timeInMillis: Scalars['Int']['input'];
  timestampOfSolve: Scalars['LocalDateTime']['input'];
}>;


export type StoreCubeResultMutation = { __typename?: 'Mutation', saveCubeResult: string };

export type GetIntellectualPropertiesReportQueryVariables = Exact<{
  year: Scalars['Year']['input'];
}>;


export type GetIntellectualPropertiesReportQuery = { __typename?: 'Query', intellectualPropertiesReport?: { __typename?: 'IntellectualPropertyReportResponse', availableYears?: Array<number> | null, timeRecordCategories: Array<{ __typename?: 'TimeRecordCategory', id: number, name: string }>, report: { __typename?: 'IntellectualPropertiesReport', year: number, countOfDifferentIPs: number, ipHours: number, nonIPHours: number, ipPercentage: number, monthReports: Array<{ __typename?: 'IntellectualPropertyMonthReport', yearMonth: string, nonIPHours: number, ipPercentage: number, ipHours: number, timeRecordReports: Array<{ __typename?: 'TimeRecordsReport', ipHours: number, nonIPHours: number, description: string }>, nonCategorizedTimeRecords: Array<{ __typename?: 'TimeRecord', id: number, numberOfHours: number, description?: string | null }> }> } } | null };

export type IntellectualPropertiesRecordsQueryVariables = Exact<{
  yearMonthFilter?: InputMaybe<Scalars['YearMonth']['input']>;
  onlyReportsWithoutAttachments: Scalars['Boolean']['input'];
  onlyReportsHavingTasksWithNoAttachments: Scalars['Boolean']['input'];
}>;


export type IntellectualPropertiesRecordsQuery = { __typename?: 'Query', intellectualPropertiesRecords?: { __typename?: 'IntellectualPropertiesRecordsResponse', reports: Array<{ __typename?: 'IntellectualProperty', id: number, description: string, tasks?: Array<{ __typename?: 'Task', id: number, attachments?: Array<string> | null, coAuthors: string, description: string, timeRecords?: Array<{ __typename?: 'TimeRecord', id: number, date: string, numberOfHours: number, description?: string | null, timeRecordCategory?: { __typename?: 'TimeRecordCategory', id: number, name: string, domain: { __typename?: 'DomainSimple', publicId: string, name: string } } | null, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }> | null }> | null, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }>, stats: { __typename?: 'TimeRecordsStats', firstTimeRecord: string, lastTimeRecord: string } } | null };

export type AllTimeRecordCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTimeRecordCategoriesQuery = { __typename?: 'Query', allTimeRecordCategories: Array<{ __typename?: 'TimeRecordCategory', id: number, name: string, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }> };

export type SearchTasksQueryVariables = Exact<{
  descriptionLike: Scalars['String']['input'];
}>;


export type SearchTasksQuery = { __typename?: 'Query', tasks: { __typename?: 'TasksResponse', tasks: Array<{ __typename?: 'Task', id: number, description: string }> } };

export type TimeRecordsQueryVariables = Exact<{
  yearMonthFilter?: InputMaybe<Scalars['YearMonth']['input']>;
}>;


export type TimeRecordsQuery = { __typename?: 'Query', timeRecords: { __typename?: 'TimeRecordsResponse', taskWithSelectedTimeRecords: Array<{ __typename?: 'Task', id: number, attachments?: Array<string> | null, coAuthors: string, description: string, timeRecords?: Array<{ __typename?: 'TimeRecord', id: number, date: string, numberOfHours: number, description?: string | null, timeRecordCategory?: { __typename?: 'TimeRecordCategory', id: number, name: string, domain: { __typename?: 'DomainSimple', publicId: string, name: string } } | null, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }> | null }>, nonIPTimeRecords: Array<{ __typename?: 'TimeRecord', id: number, date: string, numberOfHours: number, description?: string | null, timeRecordCategory?: { __typename?: 'TimeRecordCategory', id: number, name: string, domain: { __typename?: 'DomainSimple', publicId: string, name: string } } | null, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }>, stats: { __typename?: 'TimeRecordsStats', firstTimeRecord: string, lastTimeRecord: string } } };

export type CreateIntellectualPropertyReportMutationVariables = Exact<{
  description: Scalars['String']['input'];
}>;


export type CreateIntellectualPropertyReportMutation = { __typename?: 'Mutation', addIPR?: { __typename?: 'IntellectualProperty', id: number, description: string, tasks?: Array<{ __typename?: 'Task', id: number, attachments?: Array<string> | null, coAuthors: string, description: string, timeRecords?: Array<{ __typename?: 'TimeRecord', id: number, date: string, numberOfHours: number, description?: string | null, timeRecordCategory?: { __typename?: 'TimeRecordCategory', id: number, name: string, domain: { __typename?: 'DomainSimple', publicId: string, name: string } } | null, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }> | null }> | null, domain: { __typename?: 'DomainSimple', publicId: string, name: string } } | null };

export type UpdateIntellectualPropertyReportMutationVariables = Exact<{
  intellectualPropertyId: Scalars['Int']['input'];
  description: Scalars['String']['input'];
}>;


export type UpdateIntellectualPropertyReportMutation = { __typename?: 'Mutation', updateIPR?: { __typename?: 'IntellectualProperty', id: number, description: string, tasks?: Array<{ __typename?: 'Task', id: number, attachments?: Array<string> | null, coAuthors: string, description: string, timeRecords?: Array<{ __typename?: 'TimeRecord', id: number, date: string, numberOfHours: number, description?: string | null, timeRecordCategory?: { __typename?: 'TimeRecordCategory', id: number, name: string, domain: { __typename?: 'DomainSimple', publicId: string, name: string } } | null, domain: { __typename?: 'DomainSimple', publicId: string, name: string } }> | null }> | null, domain: { __typename?: 'DomainSimple', publicId: string, name: string } } | null };

export type DeleteIntellectualPropertyReportMutationVariables = Exact<{
  intellectualPropertyId: Scalars['Int']['input'];
}>;


export type DeleteIntellectualPropertyReportMutation = { __typename?: 'Mutation', deleteIPR: string };

export type CreateTaskMutationVariables = Exact<{
  intellectualPropertyId: Scalars['Int']['input'];
  coAuthors: Scalars['String']['input'];
  description: Scalars['String']['input'];
}>;


export type CreateTaskMutation = { __typename?: 'Mutation', createTask: string };

export type UpdateTaskMutationVariables = Exact<{
  taskId: Scalars['Int']['input'];
  coAuthors: Scalars['String']['input'];
  description: Scalars['String']['input'];
}>;


export type UpdateTaskMutation = { __typename?: 'Mutation', updateTask: string };

export type DeleteTaskMutationVariables = Exact<{
  taskId: Scalars['Int']['input'];
}>;


export type DeleteTaskMutation = { __typename?: 'Mutation', deleteTask: string };

export type UploadTaskAttachmentMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  taskId: Scalars['Int']['input'];
}>;


export type UploadTaskAttachmentMutation = { __typename?: 'Mutation', uploadTaskAttachment?: boolean | null };

export type DeleteTaskAttachmentMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
  taskId: Scalars['Int']['input'];
}>;


export type DeleteTaskAttachmentMutation = { __typename?: 'Mutation', deleteTaskAttachment?: boolean | null };

export type CreateTimeRecordMutationVariables = Exact<{
  assignmentAction: AssignmentAction;
  date: Scalars['LocalDate']['input'];
  description: Scalars['String']['input'];
  numberOfHours: Scalars['BigDecimal']['input'];
  taskId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateTimeRecordMutation = { __typename?: 'Mutation', createTimeRecord: string };

export type UpdateTimeRecordMutationVariables = Exact<{
  assignmentAction: AssignmentAction;
  date: Scalars['LocalDate']['input'];
  description: Scalars['String']['input'];
  numberOfHours: Scalars['BigDecimal']['input'];
  taskId?: InputMaybe<Scalars['Int']['input']>;
  timeRecordId: Scalars['Int']['input'];
}>;


export type UpdateTimeRecordMutation = { __typename?: 'Mutation', updateTimeRecord: string };

export type DeleteTimeRecordMutationVariables = Exact<{
  timeRecordId: Scalars['Int']['input'];
}>;


export type DeleteTimeRecordMutation = { __typename?: 'Mutation', deleteTimeRecord: string };

export type AssignCategoryToTimeRecordMutationVariables = Exact<{
  timeRecordCategoryId?: InputMaybe<Scalars['Int']['input']>;
  timeRecordId: Scalars['Int']['input'];
}>;


export type AssignCategoryToTimeRecordMutation = { __typename?: 'Mutation', assignCategoryToTimeRecord: string };

export type CreateTimeRecordCategoryMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateTimeRecordCategoryMutation = { __typename?: 'Mutation', createTimeRecordCategory: { __typename?: 'TimeRecordCategory', id: number, name: string } };

export type DeleteTimeRecordCategoryMutationVariables = Exact<{
  timeRecordCategoryId: Scalars['Int']['input'];
}>;


export type DeleteTimeRecordCategoryMutation = { __typename?: 'Mutation', deleteTimeRecordCategory: string };

export type UpdateTimeRecordCategoryMutationVariables = Exact<{
  timeRecordCategoryId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateTimeRecordCategoryMutation = { __typename?: 'Mutation', updateTimeRecordCategory: string };

export type GetLoansQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLoansQuery = { __typename?: 'Query', loans: { __typename?: 'Loans', rateStrategyConfigs: Array<{ __typename: 'ConstantForNFirstInstallmentRateStrategyConfig', constantRate: number, becomesVariableRateAfterNInstallments: number, variableRateMargin: number, publicId: string, name: string }>, repaymentDayStrategyConfigs: Array<{ __typename: 'NthDayOfMonthRepaymentDayStrategyConfig', dayOfMonth: number, publicId: string, name: string }>, loans: Array<{ __typename?: 'Loan', publicId: string, name: string, paymentDate: string, numberOfInstallments: number, rateStrategyConfig: { __typename: 'ConstantForNFirstInstallmentRateStrategyConfig', constantRate: number, becomesVariableRateAfterNInstallments: number, variableRateMargin: number, publicId: string, name: string }, repaymentDayStrategyConfig: { __typename: 'NthDayOfMonthRepaymentDayStrategyConfig', dayOfMonth: number, publicId: string, name: string }, paidAmount: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, installments: Array<{ __typename?: 'Installment', publicId: string, paidAt: string, repaidInterest: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, repaidAmount: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, overpayment: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } } }> }> } };

export type SingleLoanQueryVariables = Exact<{
  loanId: Scalars['UUID']['input'];
}>;


export type SingleLoanQuery = { __typename?: 'Query', singleLoan: { __typename?: 'Loan', publicId: string, name: string, paymentDate: string, numberOfInstallments: number, rateStrategyConfig: { __typename: 'ConstantForNFirstInstallmentRateStrategyConfig', constantRate: number, becomesVariableRateAfterNInstallments: number, variableRateMargin: number, publicId: string, name: string }, repaymentDayStrategyConfig: { __typename: 'NthDayOfMonthRepaymentDayStrategyConfig', dayOfMonth: number, publicId: string, name: string }, paidAmount: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, installments: Array<{ __typename?: 'Installment', publicId: string, paidAt: string, repaidInterest: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, repaidAmount: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, overpayment: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } } }> } };

export type CreateLoanMutationVariables = Exact<{
  name: Scalars['String']['input'];
  paymentDate: Scalars['LocalDate']['input'];
  numberOfInstallments: Scalars['Int']['input'];
  paidAmount: Scalars['BigDecimal']['input'];
  paidCurrency: Scalars['Currency']['input'];
  rateStrategyConfigId: Scalars['UUID']['input'];
  repaymentDayStrategyConfigId: Scalars['UUID']['input'];
}>;


export type CreateLoanMutation = { __typename?: 'Mutation', createLoan: { __typename?: 'Loan', publicId: string, paymentDate: string, name: string, numberOfInstallments: number, rateStrategyConfig: { __typename: 'ConstantForNFirstInstallmentRateStrategyConfig', constantRate: number, becomesVariableRateAfterNInstallments: number, variableRateMargin: number, publicId: string, name: string }, repaymentDayStrategyConfig: { __typename: 'NthDayOfMonthRepaymentDayStrategyConfig', dayOfMonth: number, publicId: string, name: string }, paidAmount: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } } } };

export type UpdateLoanMutationVariables = Exact<{
  loanId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateLoanMutation = { __typename?: 'Mutation', updateLoan: { __typename?: 'Loan', publicId: string, paymentDate: string, name: string, numberOfInstallments: number, rateStrategyConfig: { __typename: 'ConstantForNFirstInstallmentRateStrategyConfig', constantRate: number, becomesVariableRateAfterNInstallments: number, variableRateMargin: number, publicId: string, name: string }, repaymentDayStrategyConfig: { __typename: 'NthDayOfMonthRepaymentDayStrategyConfig', dayOfMonth: number, publicId: string, name: string }, paidAmount: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } } } };

export type DeleteLoanMutationVariables = Exact<{
  loanId: Scalars['UUID']['input'];
}>;


export type DeleteLoanMutation = { __typename?: 'Mutation', deleteLoan: string };

export type CreateInstallmentMutationVariables = Exact<{
  loanId: Scalars['UUID']['input'];
  paidAt: Scalars['LocalDate']['input'];
  repaidInterest: Scalars['BigDecimal']['input'];
  repaidAmount: Scalars['BigDecimal']['input'];
  overpayment: Scalars['BigDecimal']['input'];
  currency: Scalars['Currency']['input'];
}>;


export type CreateInstallmentMutation = { __typename?: 'Mutation', createInstallment: { __typename?: 'Installment', publicId: string, paidAt: string, repaidInterest: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, repaidAmount: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } }, overpayment: { __typename?: 'MonetaryAmount', amount: number, currency: { __typename?: 'CurrencyInfo', code: string, description: string } } } };

export type DeleteInstallmentMutationVariables = Exact<{
  installmentPublicId: Scalars['UUID']['input'];
}>;


export type DeleteInstallmentMutation = { __typename?: 'Mutation', deleteInstallment: string };

export type CreateNthDayOfMonthRepaymentDayStrategyConfigMutationVariables = Exact<{
  name: Scalars['String']['input'];
  dayOfMonth: Scalars['Int']['input'];
}>;


export type CreateNthDayOfMonthRepaymentDayStrategyConfigMutation = { __typename?: 'Mutation', createNthDayOfMonthRepaymentDayStrategyConfig: { __typename?: 'NthDayOfMonthRepaymentDayStrategyConfig', dayOfMonth: number, publicId: string, name: string } };

export type DeleteRateStrategyConfigMutationVariables = Exact<{
  publicId: Scalars['UUID']['input'];
}>;


export type DeleteRateStrategyConfigMutation = { __typename?: 'Mutation', deleteRateStrategyConfig: string };

export type CreateConstantForNFirstInstallmentRateStrategyConfigMutationVariables = Exact<{
  name: Scalars['String']['input'];
  constantRate: Scalars['BigDecimal']['input'];
  variableRateMargin: Scalars['BigDecimal']['input'];
  becomesVariableRateAfterNInstallments: Scalars['Int']['input'];
}>;


export type CreateConstantForNFirstInstallmentRateStrategyConfigMutation = { __typename?: 'Mutation', createConstantForNFirstInstallmentRateStrategyConfig: { __typename?: 'ConstantForNFirstInstallmentRateStrategyConfig', constantRate: number, becomesVariableRateAfterNInstallments: number, variableRateMargin: number, publicId: string, name: string } };

export type DeleteRepaymentDayStrategyConfigMutationVariables = Exact<{
  publicId: Scalars['UUID']['input'];
}>;


export type DeleteRepaymentDayStrategyConfigMutation = { __typename?: 'Mutation', deleteRepaymentDayStrategyConfig: string };

export type SimulateLoanQueryVariables = Exact<{
  loanAmount: Scalars['BigDecimal']['input'];
  repaymentStart: Scalars['LocalDate']['input'];
  rate: Scalars['BigDecimal']['input'];
  wibor: Scalars['BigDecimal']['input'];
  numberOfInstallments: Scalars['Int']['input'];
  overpaymentMonthlyBudget: Scalars['BigDecimal']['input'];
  overpaymentYearlyBudget: Scalars['BigDecimal']['input'];
}>;


export type SimulateLoanQuery = { __typename?: 'Query', simulateLoan: Array<{ __typename?: 'LoanCalculationInstallment', installment: number, repaidCapital: number, paidInterest: number, overpayment: number, paymentFrom: string, paymentTo: string, remainingCapitalAtTheBeginning: number }> };

export type SimulateExistingLoanQueryVariables = Exact<{
  loanId: Scalars['UUID']['input'];
  monthlyBudget?: InputMaybe<MonetaryAmountInput>;
  yearlyOverpayment?: InputMaybe<MonetaryAmountInput>;
}>;


export type SimulateExistingLoanQuery = { __typename?: 'Query', simulateExistingLoan: Array<{ __typename?: 'LoanCalculationInstallment', installment: number, repaidCapital: number, paidInterest: number, overpayment: number, paymentFrom: string, paymentTo: string, remainingCapitalAtTheBeginning: number }> };

export type PerformLoginMutationVariables = Exact<{
  login: Scalars['String']['input'];
  password: Scalars['String']['input'];
  otp: Scalars['String']['input'];
}>;


export type PerformLoginMutation = { __typename?: 'Mutation', login: { __typename?: 'AuthenticationInfo', jwt: string, user: { __typename?: 'User', login: string, name: string, email: string, roles: Array<string>, domainPublicId: string, domains: Array<{ __typename?: 'DomainSimple', publicId: string, name: string }> } } };

export type LoginWithGoogleMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type LoginWithGoogleMutation = { __typename?: 'Mutation', loginWithGoogleToken: { __typename?: 'AuthenticationInfo', jwt: string, user: { __typename?: 'User', login: string, name: string, email: string, roles: Array<string>, domainPublicId: string, domains: Array<{ __typename?: 'DomainSimple', publicId: string, name: string }> } } };

export type SwitchDomainMutationVariables = Exact<{
  domainPublicId: Scalars['UUID']['input'];
}>;


export type SwitchDomainMutation = { __typename?: 'Mutation', switchDomain: { __typename?: 'AuthenticationInfo', jwt: string, user: { __typename?: 'User', login: string, name: string, email: string, domainPublicId: string, roles: Array<string>, domains: Array<{ __typename?: 'DomainSimple', name: string, publicId: string }> } } };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'CurrentUserProfile', login: string, name: string, email: string, roles: Array<string>, domain: { __typename?: 'DomainSimple', publicId: string, name: string }, domains: Array<{ __typename?: 'DomainSimple', publicId: string, name: string }> } };

export type PerformRegistrationMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  login: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  repeatedPassword: Scalars['String']['input'];
}>;


export type PerformRegistrationMutation = { __typename?: 'Mutation', register: { __typename?: 'MFAData', mfaCode: string, qrLink: string } };

export type SetupMfaMutationVariables = Exact<{
  login: Scalars['String']['input'];
  password: Scalars['String']['input'];
  otp: Scalars['String']['input'];
}>;


export type SetupMfaMutation = { __typename?: 'Mutation', setupMFA: boolean };

export type GetStrengthTrainingExerciseCatalogQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStrengthTrainingExerciseCatalogQuery = { __typename?: 'Query', strengthTraining: { __typename?: 'StrengthTrainingQuery', exerciseFamilies: Array<{ __typename?: 'StrengthTrainingExerciseFamily', publicId: string, name: string, scope: StrengthTrainingCatalogScope, exerciseType: StrengthTrainingExerciseType, active: boolean, dimensions: Array<{ __typename?: 'StrengthTrainingExerciseFamilyDimension', publicId: string, scope: StrengthTrainingCatalogScope, position: number, required: boolean, variantDimension: { __typename?: 'StrengthTrainingVariantDimension', publicId: string, scope: StrengthTrainingCatalogScope, name: string }, allowedValues: Array<{ __typename?: 'StrengthTrainingExerciseFamilyVariantValue', publicId: string, scope: StrengthTrainingCatalogScope, defaultValue: boolean, variantValue: { __typename?: 'StrengthTrainingVariantValue', publicId: string, scope: StrengthTrainingCatalogScope, name: string } }> }> }>, variantDimensions: Array<{ __typename?: 'StrengthTrainingVariantDimension', publicId: string, name: string, scope: StrengthTrainingCatalogScope, active: boolean, values: Array<{ __typename?: 'StrengthTrainingVariantValue', publicId: string, name: string, scope: StrengthTrainingCatalogScope, active: boolean }> }> } };

export type CreateStrengthTrainingExerciseFamilyMutationVariables = Exact<{
  name: Scalars['String']['input'];
  exerciseType: StrengthTrainingExerciseType;
}>;


export type CreateStrengthTrainingExerciseFamilyMutation = { __typename?: 'Mutation', strengthTraining: { __typename?: 'StrengthTrainingMutation', createExerciseFamily: { __typename?: 'StrengthTrainingExerciseFamily', publicId: string, name: string, scope: StrengthTrainingCatalogScope, exerciseType: StrengthTrainingExerciseType, active: boolean } } };

export type CreateStrengthTrainingVariantDimensionMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateStrengthTrainingVariantDimensionMutation = { __typename?: 'Mutation', strengthTraining: { __typename?: 'StrengthTrainingMutation', createVariantDimension: { __typename?: 'StrengthTrainingVariantDimension', publicId: string, name: string, scope: StrengthTrainingCatalogScope, active: boolean } } };

export type CreateStrengthTrainingVariantValueMutationVariables = Exact<{
  variantDimensionPublicId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
}>;


export type CreateStrengthTrainingVariantValueMutation = { __typename?: 'Mutation', strengthTraining: { __typename?: 'StrengthTrainingMutation', createVariantValue: { __typename?: 'StrengthTrainingVariantValue', publicId: string, name: string, scope: StrengthTrainingCatalogScope, active: boolean } } };

export type AssignStrengthTrainingDimensionToFamilyMutationVariables = Exact<{
  exerciseFamilyPublicId: Scalars['UUID']['input'];
  variantDimensionPublicId: Scalars['UUID']['input'];
  position: Scalars['Int']['input'];
  required: Scalars['Boolean']['input'];
}>;


export type AssignStrengthTrainingDimensionToFamilyMutation = { __typename?: 'Mutation', strengthTraining: { __typename?: 'StrengthTrainingMutation', assignDimensionToFamily: { __typename?: 'StrengthTrainingExerciseFamilyDimension', publicId: string, position: number, required: boolean, variantDimension: { __typename?: 'StrengthTrainingVariantDimension', name: string } } } };

export type SetAllowedStrengthTrainingVariantValuesMutationVariables = Exact<{
  familyDimensionPublicId: Scalars['UUID']['input'];
  variantValuePublicIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  defaultValuePublicId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type SetAllowedStrengthTrainingVariantValuesMutation = { __typename?: 'Mutation', strengthTraining: { __typename?: 'StrengthTrainingMutation', setAllowedVariantValues: Array<{ __typename?: 'StrengthTrainingExerciseFamilyVariantValue', publicId: string, defaultValue: boolean, variantValue: { __typename?: 'StrengthTrainingVariantValue', publicId: string, name: string } }> } };

export const namedOperations = {
  Query: {
    GetFinanceManagementWithNotAssignedBankAccounts: 'GetFinanceManagementWithNotAssignedBankAccounts',
    GetAccountTransactions: 'GetAccountTransactions',
    GetFinanceManagement: 'GetFinanceManagement',
    BillingPeriodQuery: 'BillingPeriodQuery',
    BankTransactionsToImport: 'BankTransactionsToImport',
    GetAvailableInstitutions: 'GetAvailableInstitutions',
    GetBankPermissions: 'GetBankPermissions',
    GetAllClients: 'GetAllClients',
    GetAllSuppliers: 'GetAllSuppliers',
    MonthFinancialDocuments: 'MonthFinancialDocuments',
    GetAccountantSettings: 'GetAccountantSettings',
    DomainsData: 'DomainsData',
    GetCubeResults: 'GetCubeResults',
    GetCubeStats: 'GetCubeStats',
    GetIntellectualPropertiesReport: 'GetIntellectualPropertiesReport',
    IntellectualPropertiesRecords: 'IntellectualPropertiesRecords',
    AllTimeRecordCategories: 'AllTimeRecordCategories',
    SearchTasks: 'SearchTasks',
    TimeRecords: 'TimeRecords',
    GetLoans: 'GetLoans',
    SingleLoan: 'SingleLoan',
    SimulateLoan: 'SimulateLoan',
    SimulateExistingLoan: 'SimulateExistingLoan',
    GetCurrentUser: 'GetCurrentUser',
    GetStrengthTrainingExerciseCatalog: 'GetStrengthTrainingExerciseCatalog'
  },
  Mutation: {
    CreateAccount: 'CreateAccount',
    UpdateAccount: 'UpdateAccount',
    DeleteAccount: 'DeleteAccount',
    ReorderAccount: 'ReorderAccount',
    AssignBankAccountToAccount: 'AssignBankAccountToAccount',
    DeleteBankAccountAssignment: 'DeleteBankAccountAssignment',
    CreateBillingPeriod: 'CreateBillingPeriod',
    FinishBillingPeriod: 'FinishBillingPeriod',
    CreateIncome: 'CreateIncome',
    CreateExpense: 'CreateExpense',
    CreateTransfer: 'CreateTransfer',
    MutuallyCancel: 'MutuallyCancel',
    ImportBankTransactions: 'ImportBankTransactions',
    StartPermissionRequest: 'StartPermissionRequest',
    ConfirmPermission: 'ConfirmPermission',
    TriggerFetchBankAccountData: 'TriggerFetchBankAccountData',
    CreateBillingCategory: 'CreateBillingCategory',
    UpdateBillingCategory: 'UpdateBillingCategory',
    DeleteBillingCategory: 'DeleteBillingCategory',
    CreateClient: 'CreateClient',
    UpdateClient: 'UpdateClient',
    DeleteClient: 'DeleteClient',
    CreateSupplier: 'CreateSupplier',
    UpdateSupplier: 'UpdateSupplier',
    DeleteSupplier: 'DeleteSupplier',
    createBill: 'createBill',
    UpdateBill: 'UpdateBill',
    CreateInvoice: 'CreateInvoice',
    UpdateInvoice: 'UpdateInvoice',
    deleteFinancialDocument: 'deleteFinancialDocument',
    CreatePiggyBank: 'CreatePiggyBank',
    UpdatePiggyBank: 'UpdatePiggyBank',
    DeletePiggyBank: 'DeletePiggyBank',
    UpdateAccountantSettings: 'UpdateAccountantSettings',
    CreateDomain: 'CreateDomain',
    UpdateDomain: 'UpdateDomain',
    InviteUserToDomain: 'InviteUserToDomain',
    AcceptInvitationToDomain: 'AcceptInvitationToDomain',
    RejectInvitationToDomain: 'RejectInvitationToDomain',
    SetUserDomainAccessLevel: 'SetUserDomainAccessLevel',
    StoreCubeResult: 'StoreCubeResult',
    CreateIntellectualPropertyReport: 'CreateIntellectualPropertyReport',
    UpdateIntellectualPropertyReport: 'UpdateIntellectualPropertyReport',
    DeleteIntellectualPropertyReport: 'DeleteIntellectualPropertyReport',
    CreateTask: 'CreateTask',
    UpdateTask: 'UpdateTask',
    DeleteTask: 'DeleteTask',
    UploadTaskAttachment: 'UploadTaskAttachment',
    DeleteTaskAttachment: 'DeleteTaskAttachment',
    CreateTimeRecord: 'CreateTimeRecord',
    UpdateTimeRecord: 'UpdateTimeRecord',
    DeleteTimeRecord: 'DeleteTimeRecord',
    AssignCategoryToTimeRecord: 'AssignCategoryToTimeRecord',
    CreateTimeRecordCategory: 'CreateTimeRecordCategory',
    DeleteTimeRecordCategory: 'DeleteTimeRecordCategory',
    UpdateTimeRecordCategory: 'UpdateTimeRecordCategory',
    CreateLoan: 'CreateLoan',
    UpdateLoan: 'UpdateLoan',
    DeleteLoan: 'DeleteLoan',
    CreateInstallment: 'CreateInstallment',
    DeleteInstallment: 'DeleteInstallment',
    CreateNthDayOfMonthRepaymentDayStrategyConfig: 'CreateNthDayOfMonthRepaymentDayStrategyConfig',
    DeleteRateStrategyConfig: 'DeleteRateStrategyConfig',
    CreateConstantForNFirstInstallmentRateStrategyConfig: 'CreateConstantForNFirstInstallmentRateStrategyConfig',
    DeleteRepaymentDayStrategyConfig: 'DeleteRepaymentDayStrategyConfig',
    PerformLogin: 'PerformLogin',
    LoginWithGoogle: 'LoginWithGoogle',
    SwitchDomain: 'SwitchDomain',
    PerformRegistration: 'PerformRegistration',
    SetupMFA: 'SetupMFA',
    CreateStrengthTrainingExerciseFamily: 'CreateStrengthTrainingExerciseFamily',
    CreateStrengthTrainingVariantDimension: 'CreateStrengthTrainingVariantDimension',
    CreateStrengthTrainingVariantValue: 'CreateStrengthTrainingVariantValue',
    AssignStrengthTrainingDimensionToFamily: 'AssignStrengthTrainingDimensionToFamily',
    SetAllowedStrengthTrainingVariantValues: 'SetAllowedStrengthTrainingVariantValues'
  },
  Fragment: {
    AccountTransactionShort: 'AccountTransactionShort'
  }
}
export const AccountTransactionShort = gql`
    fragment AccountTransactionShort on AccountTransaction {
  publicId
  description
  debit {
    amount
    currency {
      description
      code
    }
  }
  credit {
    amount
    currency {
      description
      code
    }
  }
  destination {
    publicId
  }
  source {
    publicId
  }
  timeOfTransaction
}
    `;
export const GetFinanceManagementWithNotAssignedBankAccounts = gql`
    query GetFinanceManagementWithNotAssignedBankAccounts {
  financeManagement {
    id
    supportedCurrencies {
      code
      description
    }
    accounts {
      publicId
      order
      name
      currentBalance {
        amount
        currency {
          code
          description
        }
      }
      creditLimit {
        amount
        currency {
          code
          description
        }
      }
      balanceIndex
      visible
      bankAccount {
        publicId
        iban
      }
      domain {
        publicId
        name
      }
    }
    billingCategories {
      publicId
      name
      description
      domain {
        publicId
        name
      }
    }
    piggyBanks {
      publicId
      name
      description
      balance {
        amount
        currency {
          code
          description
        }
      }
      monthlyTopUp {
        amount
        currency {
          code
          description
        }
      }
      savings
      domain {
        publicId
        name
      }
    }
  }
  bankPermissions {
    bankAccountsNotAssignedToAccount {
      publicId
      iban
    }
  }
}
    `;
export const CreateAccount = gql`
    mutation CreateAccount($name: String!, $balanceIndex: Int, $bankAccountPublicId: UUID, $visible: Boolean!, $creditLimitAmount: BigDecimal!, $creditLimitCurrency: Currency!) {
  createAccount(
    accountCreationInput: {name: $name, balanceIndex: $balanceIndex, bankAccountPublicId: $bankAccountPublicId, visible: $visible, creditLimit: {amount: $creditLimitAmount, currency: $creditLimitCurrency}}
  ) {
    publicId
    order
    name
    currentBalance {
      amount
      currency {
        code
        description
      }
    }
    creditLimit {
      amount
      currency {
        code
        description
      }
    }
    balanceIndex
    visible
    bankAccount {
      publicId
      iban
    }
    domain {
      publicId
      name
    }
  }
}
    `;
export const UpdateAccount = gql`
    mutation UpdateAccount($publicId: UUID!, $name: String!, $balanceIndex: Int, $bankAccountPublicId: UUID, $visible: Boolean!, $creditLimitAmount: BigDecimal!, $creditLimitCurrency: Currency!) {
  updateAccount(
    accountUpdateInput: {publicId: $publicId, name: $name, balanceIndex: $balanceIndex, bankAccountPublicId: $bankAccountPublicId, visible: $visible, creditLimit: {amount: $creditLimitAmount, currency: $creditLimitCurrency}}
  ) {
    publicId
    order
    name
    currentBalance {
      amount
      currency {
        code
        description
      }
    }
    creditLimit {
      amount
      currency {
        code
        description
      }
    }
    balanceIndex
    visible
    bankAccount {
      publicId
      iban
    }
    domain {
      publicId
      name
    }
  }
}
    `;
export const DeleteAccount = gql`
    mutation DeleteAccount($publicId: UUID!) {
  deleteAccount(accountPublicId: $publicId)
}
    `;
export const ReorderAccount = gql`
    mutation ReorderAccount($accountPublicId: UUID!, $accountBeforePublicId: UUID, $accountAfterPublicId: UUID) {
  reorderAccount(
    accountReorderInput: {accountPublicId: $accountPublicId, putBetween: {beforeAccountPublicId: $accountBeforePublicId, afterAccountPublicId: $accountAfterPublicId}}
  )
}
    `;
export const AssignBankAccountToAccount = gql`
    mutation AssignBankAccountToAccount($bankAccountPublicId: UUID!, $accountPublicId: UUID!) {
  assignBankAccountToAccount(
    assignBankAccountToAccountInput: {accountPublicId: $accountPublicId, bankAccountPublicId: $bankAccountPublicId}
  )
}
    `;
export const DeleteBankAccountAssignment = gql`
    mutation DeleteBankAccountAssignment($accountPublicId: UUID!) {
  deleteBankAccountAssignment(
    deleteBankAccountAssignmentInput: {accountPublicId: $accountPublicId}
  )
}
    `;
export const GetAccountTransactions = gql`
    query GetAccountTransactions($publicId: UUID, $yearMonth: YearMonth) {
  financeManagement {
    id
    accounts(publicId: $publicId) {
      transactions(yearMonth: $yearMonth) {
        ...AccountTransactionShort
      }
    }
  }
}
    ${AccountTransactionShort}`;
export const GetFinanceManagement = gql`
    query GetFinanceManagement {
  financeManagement {
    id
    supportedCurrencies {
      code
      description
    }
    accounts {
      publicId
      order
      name
      currentBalance {
        amount
        currency {
          code
          description
        }
      }
      creditLimit {
        amount
        currency {
          code
          description
        }
      }
      balanceIndex
      visible
      bankAccount {
        publicId
        iban
      }
      domain {
        publicId
        name
      }
    }
    billingCategories {
      publicId
      name
      description
      domain {
        publicId
        name
      }
    }
    piggyBanks {
      publicId
      name
      description
      balance {
        amount
        currency {
          code
          description
        }
      }
      monthlyTopUp {
        amount
        currency {
          code
          description
        }
      }
      savings
      domain {
        publicId
        name
      }
    }
  }
}
    `;
export const BillingPeriodQuery = gql`
    query BillingPeriodQuery($yearMonth: YearMonth) {
  billingPeriod(yearMonth: $yearMonth) {
    billingPeriod {
      publicId
      name
      period
      incomes {
        publicId
        description
        amount
        currency
        category {
          name
          description
        }
        date
      }
      expenses {
        publicId
        description
        amount
        currency
        category {
          name
          description
        }
        date
      }
      monthSummary {
        savings {
          amount
          currency
        }
        accounts {
          publicId
          name
          currency
          currentBalance
          lastTransactionIdIncludedInBalance
        }
        piggyBanks {
          name
          description
          balance
          currency
          savings
          monthlyTopUp
        }
      }
    }
    creationBlockers {
      alreadyExists
      notForCurrentMonth
      unfinishedBillingPeriods
    }
  }
}
    `;
export const CreateBillingPeriod = gql`
    mutation CreateBillingPeriod($yearMonth: YearMonth!) {
  createBillingPeriod(yearMonth: $yearMonth) {
    publicId
    name
    period
    incomes {
      publicId
      description
      amount
      currency
      category {
        name
        description
      }
      date
    }
    expenses {
      publicId
      description
      amount
      currency
      category {
        name
        description
      }
      date
    }
    monthSummary {
      savings {
        amount
        currency
      }
      accounts {
        publicId
        name
        currency
        currentBalance
        lastTransactionIdIncludedInBalance
      }
      piggyBanks {
        name
        description
        balance
        currency
        savings
        monthlyTopUp
      }
    }
  }
}
    `;
export const FinishBillingPeriod = gql`
    mutation FinishBillingPeriod($yearMonth: YearMonth!) {
  finishBillingPeriod(yearMonth: $yearMonth)
}
    `;
export const CreateIncome = gql`
    mutation CreateIncome($accountPublicId: UUID!, $description: String!, $amount: BigDecimal!, $currency: Currency!, $categoryPublicId: UUID!, $date: LocalDate!, $piggyBankPublicId: UUID, $bankTransactionPublicIds: [UUID!]!) {
  createIncome(
    createIncomeInput: {accountPublicId: $accountPublicId, description: $description, amount: $amount, currency: $currency, categoryPublicId: $categoryPublicId, date: $date, piggyBankPublicId: $piggyBankPublicId, bankTransactionPublicIds: $bankTransactionPublicIds}
  )
}
    `;
export const CreateExpense = gql`
    mutation CreateExpense($accountPublicId: UUID!, $description: String!, $amount: BigDecimal!, $currency: Currency!, $categoryPublicId: UUID!, $date: LocalDate!, $piggyBankPublicId: UUID, $bankTransactionPublicIds: [UUID!]!) {
  createExpense(
    createExpenseInput: {accountPublicId: $accountPublicId, description: $description, amount: $amount, currency: $currency, categoryPublicId: $categoryPublicId, date: $date, piggyBankPublicId: $piggyBankPublicId, bankTransactionPublicIds: $bankTransactionPublicIds}
  )
}
    `;
export const CreateTransfer = gql`
    mutation CreateTransfer($fromAccountPublicId: UUID!, $toAccountPublicId: UUID!, $fromAmount: BigDecimal!, $toAmount: BigDecimal!, $description: String!, $date: LocalDate!, $bankTransactionPublicIds: [UUID!]!) {
  createTransfer(
    createTransferInput: {fromAccountPublicId: $fromAccountPublicId, toAccountPublicId: $toAccountPublicId, fromAmount: $fromAmount, toAmount: $toAmount, description: $description, date: $date, bankTransactionPublicIds: $bankTransactionPublicIds}
  )
}
    `;
export const MutuallyCancel = gql`
    mutation MutuallyCancel($transactionsPublicId: [UUID!]!) {
  mutuallyCancel(
    mutuallyCancelInput: {transactionsPublicId: $transactionsPublicId}
  )
}
    `;
export const BankTransactionsToImport = gql`
    query BankTransactionsToImport {
  bankTransactionsToImport {
    id
    conversionRate
    credit
    debit
    description
    timeOfTransaction
    destinationAccountPublicId
    sourceAccountPublicId
    creditBankAccountPublicId
    debitBankAccountPublicId
    transactionPublicId
    creditTransactionPublicId
    debitTransactionPublicId
  }
  financeManagement {
    id
    accounts {
      publicId
      order
      name
      currentBalance {
        amount
        currency {
          code
          description
        }
      }
      creditLimit {
        amount
        currency {
          code
          description
        }
      }
      balanceIndex
      visible
      bankAccount {
        publicId
        iban
      }
      domain {
        publicId
        name
      }
    }
    billingCategories {
      publicId
      name
      description
      domain {
        publicId
        name
      }
    }
    piggyBanks {
      publicId
      name
      description
      balance {
        amount
        currency {
          code
          description
        }
      }
      monthlyTopUp {
        amount
        currency {
          code
          description
        }
      }
      savings
      domain {
        publicId
        name
      }
    }
  }
}
    `;
export const ImportBankTransactions = gql`
    mutation ImportBankTransactions($bankTransactionPublicIds: [UUID!]!, $expenses: [CreateBillingElementInput!]!, $incomes: [CreateBillingElementInput!]!, $transfers: [CreateTransferInput!]!) {
  importBankTransactions(
    importBankTransactionsInput: {bankTransactionPublicIds: $bankTransactionPublicIds, expenses: $expenses, incomes: $incomes, transfers: $transfers}
  )
}
    `;
export const GetAvailableInstitutions = gql`
    query GetAvailableInstitutions($country: String!) {
  bankPermissions {
    availableInstitutions(country: $country) {
      id
      name
      bic
      transactionTotalDays
      countries
      logo
    }
  }
}
    `;
export const GetBankPermissions = gql`
    query GetBankPermissions {
  bankPermissions {
    granted {
      publicId
      createdAt
      givenAt
      withdrawnAt
      bankAccounts {
        publicId
        iban
      }
      institutionId
      institution {
        id
        name
        bic
        transactionTotalDays
        countries
        logo
      }
      reference
      ssn
      confirmationLink
      requisitionId
    }
    toProcess {
      publicId
      createdAt
      givenAt
      withdrawnAt
      bankAccounts {
        publicId
        iban
      }
      institutionId
      institution {
        id
        name
        bic
        transactionTotalDays
        countries
        logo
      }
      reference
      ssn
      confirmationLink
      requisitionId
    }
    toRecreate {
      id
      name
      bic
      transactionTotalDays
      countries
      logo
    }
  }
}
    `;
export const StartPermissionRequest = gql`
    mutation StartPermissionRequest($institutionId: String!, $maxHistoricalDays: Int!, $redirect: URL!, $userLanguage: String!) {
  startPermissionRequest(
    bankPermissionRequest: {institutionId: $institutionId, maxHistoricalDays: $maxHistoricalDays, redirect: $redirect, userLanguage: $userLanguage}
  ) {
    publicId
    createdAt
    givenAt
    withdrawnAt
    bankAccounts {
      publicId
      iban
    }
    institutionId
    reference
    ssn
    confirmationLink
    requisitionId
  }
}
    `;
export const ConfirmPermission = gql`
    mutation ConfirmPermission($reference: String!) {
  confirmPermission(confirmPermissionRequest: {reference: $reference})
}
    `;
export const TriggerFetchBankAccountData = gql`
    mutation TriggerFetchBankAccountData($bankAccountPublicId: UUID!) {
  triggerFetchBankAccountData(
    fetchBankAccountDataInput: {bankAccountPublicId: $bankAccountPublicId}
  )
}
    `;
export const CreateBillingCategory = gql`
    mutation CreateBillingCategory($name: String!, $description: String!) {
  createBillingCategory(
    billingCategoryCreationInput: {name: $name, description: $description}
  ) {
    publicId
    name
    description
    domain {
      publicId
      name
    }
  }
}
    `;
export const UpdateBillingCategory = gql`
    mutation UpdateBillingCategory($publicId: UUID!, $name: String!, $description: String!) {
  updateBillingCategory(
    billingCategoryUpdateInput: {publicId: $publicId, name: $name, description: $description}
  ) {
    publicId
    name
    description
    domain {
      publicId
      name
    }
  }
}
    `;
export const DeleteBillingCategory = gql`
    mutation DeleteBillingCategory($publicId: UUID!) {
  deleteBillingCategory(billingCategoryPublicId: $publicId)
}
    `;
export const GetAllClients = gql`
    query GetAllClients {
  allClients {
    publicId
    name
    domain {
      publicId
      name
    }
  }
}
    `;
export const GetAllSuppliers = gql`
    query GetAllSuppliers {
  allSuppliers {
    publicId
    name
    domain {
      publicId
      name
    }
  }
}
    `;
export const MonthFinancialDocuments = gql`
    query MonthFinancialDocuments($yearMonth: YearMonth!) {
  monthFinancialDocuments(yearMonth: $yearMonth) {
    publicId
    name
    otherParty {
      publicId
      name
      domain {
        publicId
        name
      }
    }
    amount {
      amount
      currency {
        code
        description
      }
    }
    createdAt
    description
    domain {
      publicId
      name
    }
  }
}
    `;
export const CreateClient = gql`
    mutation CreateClient($name: String!) {
  createClient(clientCreationInput: {name: $name}) {
    publicId
    name
    domain {
      publicId
      name
    }
  }
}
    `;
export const UpdateClient = gql`
    mutation UpdateClient($publicId: UUID!, $name: String!) {
  updateClient(clientUpdateInput: {publicId: $publicId, name: $name}) {
    publicId
    name
    domain {
      publicId
      name
    }
  }
}
    `;
export const DeleteClient = gql`
    mutation DeleteClient($clientPublicId: UUID!) {
  deleteClient(clientPublicId: $clientPublicId)
}
    `;
export const CreateSupplier = gql`
    mutation CreateSupplier($name: String!) {
  createSupplier(supplierCreationInput: {name: $name}) {
    publicId
    name
    domain {
      publicId
      name
    }
  }
}
    `;
export const UpdateSupplier = gql`
    mutation UpdateSupplier($publicId: UUID!, $name: String!) {
  updateSupplier(supplierUpdateInput: {publicId: $publicId, name: $name}) {
    publicId
    name
    domain {
      publicId
      name
    }
  }
}
    `;
export const DeleteSupplier = gql`
    mutation DeleteSupplier($supplierPublicId: UUID!) {
  deleteSupplier(supplierPublicId: $supplierPublicId)
}
    `;
export const CreateBill = gql`
    mutation createBill($createdAt: LocalDate!, $otherPartyId: UUID!, $billType: BillType!, $name: String!, $description: String!, $amount: BigDecimal!, $currency: Currency!) {
  createBill(
    billCreationInput: {createdAt: $createdAt, otherPartyId: $otherPartyId, type: $billType, name: $name, description: $description, amount: {amount: $amount, currency: $currency}}
  ) {
    publicId
    name
    otherParty {
      publicId
      name
      domain {
        publicId
        name
      }
    }
    amount {
      amount
      currency {
        code
        description
      }
    }
    createdAt
    description
    domain {
      publicId
      name
    }
  }
}
    `;
export const UpdateBill = gql`
    mutation UpdateBill($billPublicId: UUID!, $createdAt: LocalDate!, $otherPartyId: UUID!, $billType: BillType!, $name: String!, $description: String!, $amount: BigDecimal!, $currency: Currency!) {
  updateBill(
    billUpdateInput: {billPublicId: $billPublicId, createdAt: $createdAt, otherPartyId: $otherPartyId, type: $billType, name: $name, description: $description, amount: {amount: $amount, currency: $currency}}
  ) {
    publicId
    name
    otherParty {
      publicId
      name
      domain {
        publicId
        name
      }
    }
    amount {
      amount
      currency {
        code
        description
      }
    }
    createdAt
    description
    domain {
      publicId
      name
    }
  }
}
    `;
export const CreateInvoice = gql`
    mutation CreateInvoice($createdAt: LocalDate!, $dueTo: LocalDate!, $otherPartyId: UUID!, $invoiceType: InvoiceType!, $name: String!, $description: String!, $amount: BigDecimal!, $vat: BigDecimal!, $currency: Currency!) {
  createInvoice(
    invoiceCreationInput: {createdAt: $createdAt, dueTo: $dueTo, otherPartyId: $otherPartyId, type: $invoiceType, name: $name, description: $description, amount: {amount: $amount, currency: $currency}, vat: {amount: $vat, currency: $currency}}
  ) {
    publicId
    name
    otherParty {
      publicId
      name
      domain {
        publicId
        name
      }
    }
    amount {
      amount
      currency {
        code
        description
      }
    }
    vat {
      amount
      currency {
        code
        description
      }
    }
    createdAt
    dueTo
    description
    domain {
      publicId
      name
    }
  }
}
    `;
export const UpdateInvoice = gql`
    mutation UpdateInvoice($invoicePublicId: UUID!, $createdAt: LocalDate!, $dueTo: LocalDate!, $otherPartyId: UUID!, $invoiceType: InvoiceType!, $name: String!, $description: String!, $amount: BigDecimal!, $vat: BigDecimal!, $currency: Currency!) {
  updateInvoice(
    invoiceUpdateInput: {invoicePublicId: $invoicePublicId, createdAt: $createdAt, dueTo: $dueTo, otherPartyId: $otherPartyId, type: $invoiceType, name: $name, description: $description, amount: {amount: $amount, currency: $currency}, vat: {amount: $vat, currency: $currency}}
  ) {
    publicId
    name
    otherParty {
      publicId
      name
      domain {
        publicId
        name
      }
    }
    amount {
      amount
      currency {
        code
        description
      }
    }
    vat {
      amount
      currency {
        code
        description
      }
    }
    createdAt
    dueTo
    description
    domain {
      publicId
      name
    }
  }
}
    `;
export const DeleteFinancialDocument = gql`
    mutation deleteFinancialDocument($financialDocumentPublicId: UUID!) {
  deleteFinancialDocument(financialDocumentPublicId: $financialDocumentPublicId)
}
    `;
export const CreatePiggyBank = gql`
    mutation CreatePiggyBank($name: String!, $description: String!, $monthlyTopUp: BigDecimal!, $currency: Currency!, $savings: Boolean!) {
  createPiggyBank(
    piggyBankCreationInput: {name: $name, description: $description, monthlyTopUp: {amount: $monthlyTopUp, currency: $currency}, savings: $savings}
  ) {
    publicId
    name
    description
    balance {
      amount
      currency {
        code
        description
      }
    }
    monthlyTopUp {
      amount
      currency {
        code
        description
      }
    }
    savings
    domain {
      publicId
      name
    }
  }
}
    `;
export const UpdatePiggyBank = gql`
    mutation UpdatePiggyBank($publicId: UUID!, $name: String!, $description: String!, $balance: BigDecimal!, $monthlyTopUp: BigDecimal!, $currency: Currency!, $savings: Boolean!) {
  updatePiggyBank(
    piggyBankUpdateInput: {publicId: $publicId, name: $name, description: $description, balance: {amount: $balance, currency: $currency}, monthlyTopUp: {amount: $monthlyTopUp, currency: $currency}, savings: $savings}
  ) {
    publicId
    name
    description
    balance {
      amount
      currency {
        code
        description
      }
    }
    monthlyTopUp {
      amount
      currency {
        code
        description
      }
    }
    savings
    domain {
      publicId
      name
    }
  }
}
    `;
export const DeletePiggyBank = gql`
    mutation DeletePiggyBank($publicId: UUID!) {
  deletePiggyBank(piggyBankPublicId: $publicId)
}
    `;
export const GetAccountantSettings = gql`
    query GetAccountantSettings {
  settings {
    id
    accountantSettings {
      isCompany
    }
  }
}
    `;
export const UpdateAccountantSettings = gql`
    mutation UpdateAccountantSettings($isCompany: Boolean!) {
  updateAccountantSettings(accountantSettingsUpdateInput: {isCompany: $isCompany})
}
    `;
export const CreateDomain = gql`
    mutation CreateDomain($name: String!) {
  createDomain(domainCreationInput: {name: $name}) {
    publicId
    name
  }
}
    `;
export const UpdateDomain = gql`
    mutation UpdateDomain($domainPublicId: UUID!, $name: String!) {
  updateDomain(domainUpdateInput: {publicId: $domainPublicId, name: $name}) {
    publicId
    name
  }
}
    `;
export const InviteUserToDomain = gql`
    mutation InviteUserToDomain($domainPublicId: UUID!, $invitedUserLogin: String!) {
  inviteUserToDomain(
    domainInvitationInput: {publicId: $domainPublicId, invitedUserLogin: $invitedUserLogin}
  )
}
    `;
export const AcceptInvitationToDomain = gql`
    mutation AcceptInvitationToDomain($domainPublicId: UUID!) {
  acceptInvitationToDomain(
    domainInvitationResponseInput: {publicId: $domainPublicId}
  )
}
    `;
export const RejectInvitationToDomain = gql`
    mutation RejectInvitationToDomain($domainPublicId: UUID!) {
  rejectInvitationToDomain(
    domainInvitationResponseInput: {publicId: $domainPublicId}
  )
}
    `;
export const SetUserDomainAccessLevel = gql`
    mutation SetUserDomainAccessLevel($domainPublicId: UUID!, $userLogin: String!, $domainAccessLevel: SetDomainAccessLevel!) {
  setUserDomainAccessLevel(
    domainSetAccessLevelInput: {publicId: $domainPublicId, userLogin: $userLogin, domainAccessLevel: $domainAccessLevel}
  )
}
    `;
export const DomainsData = gql`
    query DomainsData {
  domainInvitations {
    publicId
    name
  }
  settings {
    id
    domains {
      publicId
      name
      users {
        login
        domainAccessLevel
      }
    }
  }
}
    `;
export const GetCubeResults = gql`
    query GetCubeResults($cubeType: CubeType!) {
  cubeResults(cubeResultsQuery: {cubeType: $cubeType}) {
    todayStats {
      min
      numberOfTries
    }
    todayResults {
      timeInMillis
      date
    }
  }
}
    `;
export const GetCubeStats = gql`
    query GetCubeStats($cubeType: CubeType!, $month: YearMonth!) {
  cubeResults(cubeResultsQuery: {cubeType: $cubeType}) {
    topTenAllTime {
      timeInMillis
      date
    }
    stats(month: $month) {
      day
      min
      max
      minAo5
      minAo30
      numberOfTries
    }
  }
}
    `;
export const StoreCubeResult = gql`
    mutation StoreCubeResult($cubeType: CubeType!, $timeInMillis: Int!, $timestampOfSolve: LocalDateTime!) {
  saveCubeResult(
    saveCubeResultInput: {cubeType: $cubeType, timeInMillis: $timeInMillis, timestampOfSolve: $timestampOfSolve}
  )
}
    `;
export const GetIntellectualPropertiesReport = gql`
    query GetIntellectualPropertiesReport($year: Year!) {
  intellectualPropertiesReport(input: {year: $year}) {
    availableYears
    timeRecordCategories {
      id
      name
    }
    report {
      year
      countOfDifferentIPs
      ipHours
      nonIPHours
      ipPercentage
      monthReports {
        yearMonth
        nonIPHours
        ipPercentage
        ipHours
        timeRecordReports {
          ipHours
          nonIPHours
          description
        }
        nonCategorizedTimeRecords {
          id
          numberOfHours
          description
        }
      }
    }
  }
}
    `;
export const IntellectualPropertiesRecords = gql`
    query IntellectualPropertiesRecords($yearMonthFilter: YearMonth, $onlyReportsWithoutAttachments: Boolean!, $onlyReportsHavingTasksWithNoAttachments: Boolean!) {
  intellectualPropertiesRecords(
    input: {yearMonthFilter: $yearMonthFilter, onlyReportsWithoutAttachments: $onlyReportsWithoutAttachments, onlyReportsHavingTasksWithNoAttachments: $onlyReportsHavingTasksWithNoAttachments}
  ) {
    reports {
      id
      description
      tasks {
        id
        attachments
        coAuthors
        description
        timeRecords {
          id
          date
          numberOfHours
          description
          timeRecordCategory {
            id
            name
            domain {
              publicId
              name
            }
          }
          domain {
            publicId
            name
          }
        }
      }
      domain {
        publicId
        name
      }
    }
    stats {
      firstTimeRecord
      lastTimeRecord
    }
  }
}
    `;
export const AllTimeRecordCategories = gql`
    query AllTimeRecordCategories {
  allTimeRecordCategories {
    id
    name
    domain {
      publicId
      name
    }
  }
}
    `;
export const SearchTasks = gql`
    query SearchTasks($descriptionLike: String!) {
  tasks(input: {description: $descriptionLike}) {
    tasks {
      id
      description
    }
  }
}
    `;
export const TimeRecords = gql`
    query TimeRecords($yearMonthFilter: YearMonth) {
  timeRecords(input: {yearMonthFilter: $yearMonthFilter}) {
    taskWithSelectedTimeRecords {
      id
      attachments
      coAuthors
      description
      timeRecords {
        id
        date
        numberOfHours
        description
        timeRecordCategory {
          id
          name
          domain {
            publicId
            name
          }
        }
        domain {
          publicId
          name
        }
      }
    }
    nonIPTimeRecords {
      id
      date
      numberOfHours
      description
      timeRecordCategory {
        id
        name
        domain {
          publicId
          name
        }
      }
      domain {
        publicId
        name
      }
    }
    stats {
      firstTimeRecord
      lastTimeRecord
    }
  }
}
    `;
export const CreateIntellectualPropertyReport = gql`
    mutation CreateIntellectualPropertyReport($description: String!) {
  addIPR(input: {description: $description}) {
    id
    description
    tasks {
      id
      attachments
      coAuthors
      description
      timeRecords {
        id
        date
        numberOfHours
        description
        timeRecordCategory {
          id
          name
          domain {
            publicId
            name
          }
        }
        domain {
          publicId
          name
        }
      }
    }
    domain {
      publicId
      name
    }
  }
}
    `;
export const UpdateIntellectualPropertyReport = gql`
    mutation UpdateIntellectualPropertyReport($intellectualPropertyId: Int!, $description: String!) {
  updateIPR(
    intellectualPropertyId: $intellectualPropertyId
    input: {description: $description}
  ) {
    id
    description
    tasks {
      id
      attachments
      coAuthors
      description
      timeRecords {
        id
        date
        numberOfHours
        description
        timeRecordCategory {
          id
          name
          domain {
            publicId
            name
          }
        }
        domain {
          publicId
          name
        }
      }
    }
    domain {
      publicId
      name
    }
  }
}
    `;
export const DeleteIntellectualPropertyReport = gql`
    mutation DeleteIntellectualPropertyReport($intellectualPropertyId: Int!) {
  deleteIPR(intellectualPropertyId: $intellectualPropertyId)
}
    `;
export const CreateTask = gql`
    mutation CreateTask($intellectualPropertyId: Int!, $coAuthors: String!, $description: String!) {
  createTask(
    intellectualPropertyId: $intellectualPropertyId
    taskData: {coAuthors: $coAuthors, description: $description}
  )
}
    `;
export const UpdateTask = gql`
    mutation UpdateTask($taskId: Int!, $coAuthors: String!, $description: String!) {
  updateTask(
    taskId: $taskId
    taskData: {coAuthors: $coAuthors, description: $description}
  )
}
    `;
export const DeleteTask = gql`
    mutation DeleteTask($taskId: Int!) {
  deleteTask(taskId: $taskId)
}
    `;
export const UploadTaskAttachment = gql`
    mutation UploadTaskAttachment($file: Upload!, $taskId: Int!) {
  uploadTaskAttachment(input: {file: $file, taskId: $taskId})
}
    `;
export const DeleteTaskAttachment = gql`
    mutation DeleteTaskAttachment($fileName: String!, $taskId: Int!) {
  deleteTaskAttachment(input: {fileName: $fileName, taskId: $taskId})
}
    `;
export const CreateTimeRecord = gql`
    mutation CreateTimeRecord($assignmentAction: AssignmentAction!, $date: LocalDate!, $description: String!, $numberOfHours: BigDecimal!, $taskId: Int) {
  createTimeRecord(
    timeRecordData: {assignmentAction: $assignmentAction, date: $date, description: $description, numberOfHours: $numberOfHours, taskId: $taskId}
  )
}
    `;
export const UpdateTimeRecord = gql`
    mutation UpdateTimeRecord($assignmentAction: AssignmentAction!, $date: LocalDate!, $description: String!, $numberOfHours: BigDecimal!, $taskId: Int, $timeRecordId: Int!) {
  updateTimeRecord(
    timeRecordData: {assignmentAction: $assignmentAction, date: $date, description: $description, numberOfHours: $numberOfHours, taskId: $taskId}
    timeRecordId: $timeRecordId
  )
}
    `;
export const DeleteTimeRecord = gql`
    mutation DeleteTimeRecord($timeRecordId: Int!) {
  deleteTimeRecord(timeRecordId: $timeRecordId)
}
    `;
export const AssignCategoryToTimeRecord = gql`
    mutation AssignCategoryToTimeRecord($timeRecordCategoryId: Int, $timeRecordId: Int!) {
  assignCategoryToTimeRecord(
    timeRecordCategoryId: $timeRecordCategoryId
    timeRecordId: $timeRecordId
  )
}
    `;
export const CreateTimeRecordCategory = gql`
    mutation CreateTimeRecordCategory($name: String!) {
  createTimeRecordCategory(name: $name) {
    id
    name
  }
}
    `;
export const DeleteTimeRecordCategory = gql`
    mutation DeleteTimeRecordCategory($timeRecordCategoryId: Int!) {
  deleteTimeRecordCategory(timeRecordId: $timeRecordCategoryId)
}
    `;
export const UpdateTimeRecordCategory = gql`
    mutation UpdateTimeRecordCategory($timeRecordCategoryId: Int!, $name: String!) {
  updateTimeRecordCategory(name: $name, timeRecordId: $timeRecordCategoryId)
}
    `;
export const GetLoans = gql`
    query GetLoans {
  loans {
    rateStrategyConfigs {
      __typename
      publicId
      name
      ... on ConstantForNFirstInstallmentRateStrategyConfig {
        constantRate
        becomesVariableRateAfterNInstallments
        variableRateMargin
      }
    }
    repaymentDayStrategyConfigs {
      __typename
      publicId
      name
      ... on NthDayOfMonthRepaymentDayStrategyConfig {
        dayOfMonth
      }
    }
    loans {
      publicId
      name
      paymentDate
      numberOfInstallments
      rateStrategyConfig {
        __typename
        publicId
        name
        ... on ConstantForNFirstInstallmentRateStrategyConfig {
          constantRate
          becomesVariableRateAfterNInstallments
          variableRateMargin
        }
      }
      repaymentDayStrategyConfig {
        __typename
        publicId
        name
        ... on NthDayOfMonthRepaymentDayStrategyConfig {
          dayOfMonth
        }
      }
      paidAmount {
        amount
        currency {
          code
          description
        }
      }
      installments {
        publicId
        paidAt
        repaidInterest {
          amount
          currency {
            code
            description
          }
        }
        repaidAmount {
          amount
          currency {
            code
            description
          }
        }
        overpayment {
          amount
          currency {
            code
            description
          }
        }
      }
    }
  }
}
    `;
export const SingleLoan = gql`
    query SingleLoan($loanId: UUID!) {
  singleLoan(input: {publicId: $loanId}) {
    publicId
    name
    paymentDate
    numberOfInstallments
    rateStrategyConfig {
      __typename
      publicId
      name
      ... on ConstantForNFirstInstallmentRateStrategyConfig {
        constantRate
        becomesVariableRateAfterNInstallments
        variableRateMargin
      }
    }
    repaymentDayStrategyConfig {
      __typename
      publicId
      name
      ... on NthDayOfMonthRepaymentDayStrategyConfig {
        dayOfMonth
      }
    }
    paidAmount {
      amount
      currency {
        code
        description
      }
    }
    installments {
      publicId
      paidAt
      repaidInterest {
        amount
        currency {
          code
          description
        }
      }
      repaidAmount {
        amount
        currency {
          code
          description
        }
      }
      overpayment {
        amount
        currency {
          code
          description
        }
      }
    }
  }
}
    `;
export const CreateLoan = gql`
    mutation CreateLoan($name: String!, $paymentDate: LocalDate!, $numberOfInstallments: Int!, $paidAmount: BigDecimal!, $paidCurrency: Currency!, $rateStrategyConfigId: UUID!, $repaymentDayStrategyConfigId: UUID!) {
  createLoan(
    input: {name: $name, paymentDate: $paymentDate, numberOfInstallments: $numberOfInstallments, paidAmount: {amount: $paidAmount, currency: $paidCurrency}, rateStrategyConfigId: $rateStrategyConfigId, repaymentDayStrategyConfigId: $repaymentDayStrategyConfigId}
  ) {
    publicId
    paymentDate
    name
    numberOfInstallments
    rateStrategyConfig {
      __typename
      publicId
      name
      ... on ConstantForNFirstInstallmentRateStrategyConfig {
        constantRate
        becomesVariableRateAfterNInstallments
        variableRateMargin
      }
    }
    repaymentDayStrategyConfig {
      __typename
      publicId
      name
      ... on NthDayOfMonthRepaymentDayStrategyConfig {
        dayOfMonth
      }
    }
    paidAmount {
      amount
      currency {
        code
        description
      }
    }
  }
}
    `;
export const UpdateLoan = gql`
    mutation UpdateLoan($loanId: UUID!, $name: String!) {
  updateLoan(input: {loanId: $loanId, name: $name}) {
    publicId
    paymentDate
    name
    numberOfInstallments
    rateStrategyConfig {
      __typename
      publicId
      name
      ... on ConstantForNFirstInstallmentRateStrategyConfig {
        constantRate
        becomesVariableRateAfterNInstallments
        variableRateMargin
      }
    }
    repaymentDayStrategyConfig {
      __typename
      publicId
      name
      ... on NthDayOfMonthRepaymentDayStrategyConfig {
        dayOfMonth
      }
    }
    paidAmount {
      amount
      currency {
        code
        description
      }
    }
  }
}
    `;
export const DeleteLoan = gql`
    mutation DeleteLoan($loanId: UUID!) {
  deleteLoan(input: {loanId: $loanId})
}
    `;
export const CreateInstallment = gql`
    mutation CreateInstallment($loanId: UUID!, $paidAt: LocalDate!, $repaidInterest: BigDecimal!, $repaidAmount: BigDecimal!, $overpayment: BigDecimal!, $currency: Currency!) {
  createInstallment(
    input: {loanId: $loanId, paidAt: $paidAt, repaidInterest: {amount: $repaidInterest, currency: $currency}, repaidAmount: {amount: $repaidAmount, currency: $currency}, overpayment: {amount: $overpayment, currency: $currency}}
  ) {
    publicId
    paidAt
    repaidInterest {
      amount
      currency {
        code
        description
      }
    }
    repaidAmount {
      amount
      currency {
        code
        description
      }
    }
    overpayment {
      amount
      currency {
        code
        description
      }
    }
  }
}
    `;
export const DeleteInstallment = gql`
    mutation DeleteInstallment($installmentPublicId: UUID!) {
  deleteInstallment(installmentPublicId: $installmentPublicId)
}
    `;
export const CreateNthDayOfMonthRepaymentDayStrategyConfig = gql`
    mutation CreateNthDayOfMonthRepaymentDayStrategyConfig($name: String!, $dayOfMonth: Int!) {
  createNthDayOfMonthRepaymentDayStrategyConfig(
    input: {name: $name, dayOfMonth: $dayOfMonth}
  ) {
    publicId
    name
    ... on NthDayOfMonthRepaymentDayStrategyConfig {
      dayOfMonth
    }
  }
}
    `;
export const DeleteRateStrategyConfig = gql`
    mutation DeleteRateStrategyConfig($publicId: UUID!) {
  deleteRateStrategyConfig(input: {publicId: $publicId})
}
    `;
export const CreateConstantForNFirstInstallmentRateStrategyConfig = gql`
    mutation CreateConstantForNFirstInstallmentRateStrategyConfig($name: String!, $constantRate: BigDecimal!, $variableRateMargin: BigDecimal!, $becomesVariableRateAfterNInstallments: Int!) {
  createConstantForNFirstInstallmentRateStrategyConfig(
    input: {name: $name, constantRate: $constantRate, variableRateMargin: $variableRateMargin, becomesVariableRateAfterNInstallments: $becomesVariableRateAfterNInstallments}
  ) {
    publicId
    name
    ... on ConstantForNFirstInstallmentRateStrategyConfig {
      constantRate
      becomesVariableRateAfterNInstallments
      variableRateMargin
    }
  }
}
    `;
export const DeleteRepaymentDayStrategyConfig = gql`
    mutation DeleteRepaymentDayStrategyConfig($publicId: UUID!) {
  deleteRepaymentDayStrategyConfig(input: {publicId: $publicId})
}
    `;
export const SimulateLoan = gql`
    query SimulateLoan($loanAmount: BigDecimal!, $repaymentStart: LocalDate!, $rate: BigDecimal!, $wibor: BigDecimal!, $numberOfInstallments: Int!, $overpaymentMonthlyBudget: BigDecimal!, $overpaymentYearlyBudget: BigDecimal!) {
  simulateLoan(
    loanCalculationParams: {loanAmount: $loanAmount, repaymentStart: $repaymentStart, rate: $rate, wibor: $wibor, numberOfInstallments: $numberOfInstallments, overpaymentMonthlyBudget: $overpaymentMonthlyBudget, overpaymentYearlyBudget: $overpaymentYearlyBudget}
  ) {
    installment
    repaidCapital
    paidInterest
    overpayment
    paymentFrom
    paymentTo
    remainingCapitalAtTheBeginning
  }
}
    `;
export const SimulateExistingLoan = gql`
    query SimulateExistingLoan($loanId: UUID!, $monthlyBudget: MonetaryAmountInput, $yearlyOverpayment: MonetaryAmountInput) {
  simulateExistingLoan(
    loanSimulationParams: {loanId: $loanId, monthlyBudget: $monthlyBudget, yearlyOverpayment: $yearlyOverpayment}
  ) {
    installment
    repaidCapital
    paidInterest
    overpayment
    paymentFrom
    paymentTo
    remainingCapitalAtTheBeginning
  }
}
    `;
export const PerformLogin = gql`
    mutation PerformLogin($login: String!, $password: String!, $otp: String!) {
  login(loginParameters: {login: $login, password: $password, otp: $otp}) {
    jwt
    user {
      login
      name
      email
      roles
      domainPublicId
      domains {
        publicId
        name
      }
    }
  }
}
    `;
export const LoginWithGoogle = gql`
    mutation LoginWithGoogle($token: String!) {
  loginWithGoogleToken(loginWithGoogleTokenParameters: {googleToken: $token}) {
    jwt
    user {
      login
      name
      email
      roles
      domainPublicId
      domains {
        publicId
        name
      }
    }
  }
}
    `;
export const SwitchDomain = gql`
    mutation SwitchDomain($domainPublicId: UUID!) {
  switchDomain(switchDomainParameters: {domainPublicId: $domainPublicId}) {
    jwt
    user {
      login
      name
      email
      domainPublicId
      domains {
        name
        publicId
      }
      roles
    }
  }
}
    `;
export const GetCurrentUser = gql`
    query GetCurrentUser {
  currentUser {
    login
    name
    email
    roles
    domain {
      publicId
      name
    }
    domains {
      publicId
      name
    }
  }
}
    `;
export const PerformRegistration = gql`
    mutation PerformRegistration($firstName: String!, $lastName: String!, $login: String!, $email: String!, $password: String!, $repeatedPassword: String!) {
  register(
    registrationParameters: {firstName: $firstName, lastName: $lastName, login: $login, email: $email, password: $password, repeatedPassword: $repeatedPassword}
  ) {
    mfaCode
    qrLink
  }
}
    `;
export const SetupMfa = gql`
    mutation SetupMFA($login: String!, $password: String!, $otp: String!) {
  setupMFA(mfaParameters: {login: $login, password: $password, otp: $otp})
}
    `;
export const GetStrengthTrainingExerciseCatalog = gql`
    query GetStrengthTrainingExerciseCatalog {
  strengthTraining {
    exerciseFamilies {
      publicId
      name
      scope
      exerciseType
      active
      dimensions {
        publicId
        scope
        position
        required
        variantDimension {
          publicId
          scope
          name
        }
        allowedValues {
          publicId
          scope
          defaultValue
          variantValue {
            publicId
            scope
            name
          }
        }
      }
    }
    variantDimensions {
      publicId
      name
      scope
      active
      values {
        publicId
        name
        scope
        active
      }
    }
  }
}
    `;
export const CreateStrengthTrainingExerciseFamily = gql`
    mutation CreateStrengthTrainingExerciseFamily($name: String!, $exerciseType: StrengthTrainingExerciseType!) {
  strengthTraining {
    createExerciseFamily(input: {name: $name, exerciseType: $exerciseType}) {
      publicId
      name
      scope
      exerciseType
      active
    }
  }
}
    `;
export const CreateStrengthTrainingVariantDimension = gql`
    mutation CreateStrengthTrainingVariantDimension($name: String!) {
  strengthTraining {
    createVariantDimension(input: {name: $name}) {
      publicId
      name
      scope
      active
    }
  }
}
    `;
export const CreateStrengthTrainingVariantValue = gql`
    mutation CreateStrengthTrainingVariantValue($variantDimensionPublicId: UUID!, $name: String!) {
  strengthTraining {
    createVariantValue(
      input: {variantDimensionPublicId: $variantDimensionPublicId, name: $name}
    ) {
      publicId
      name
      scope
      active
    }
  }
}
    `;
export const AssignStrengthTrainingDimensionToFamily = gql`
    mutation AssignStrengthTrainingDimensionToFamily($exerciseFamilyPublicId: UUID!, $variantDimensionPublicId: UUID!, $position: Int!, $required: Boolean!) {
  strengthTraining {
    assignDimensionToFamily(
      input: {exerciseFamilyPublicId: $exerciseFamilyPublicId, variantDimensionPublicId: $variantDimensionPublicId, position: $position, required: $required}
    ) {
      publicId
      position
      required
      variantDimension {
        name
      }
    }
  }
}
    `;
export const SetAllowedStrengthTrainingVariantValues = gql`
    mutation SetAllowedStrengthTrainingVariantValues($familyDimensionPublicId: UUID!, $variantValuePublicIds: [UUID!]!, $defaultValuePublicId: UUID) {
  strengthTraining {
    setAllowedVariantValues(
      input: {familyDimensionPublicId: $familyDimensionPublicId, variantValuePublicIds: $variantValuePublicIds, defaultValuePublicId: $defaultValuePublicId}
    ) {
      publicId
      defaultValue
      variantValue {
        publicId
        name
      }
    }
  }
}
    `;